webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/T0IkRd/%3F1731411640389&title=Religious%20Liberty%2C%20Vol.%201%2C%20Emory%20University%20Studies%20in%20Law%20and%20Religion%20%28EUSLR%29&summary=The%20Collected%20Works%20on%20Religious%20Liberty%20comprehensively%20collects%20the%20scholarship%2C%20advocacy%2C%20and%20explanatory%20writings%20of%20leading%20scholar%20and%20lawyer%20Douglas%20Laycock%2C%20illuminating%20every%20major%20religious%20liberty%20issue%20from%20both%20theoretical%20and%20practical%20persp&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/T0IkRd/%3F1731411640389",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=The%20Collected%20Works%20on%20Religious%20Liberty%20comprehensively%20collects%20the%20scholarship%2C%20advocacy%2C%20and%20explanatory%20writings%20of%20leading%20scholar%20and%20law%0Dhttps://textcafe.co/books/T0IkRd/%3F1731411640389&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/T0IkRd/%3F1731411640389&posttype=link&caption=The%20Collected%20Works%20on%20Religious%20Liberty%20comprehensively%20collects%20the%20scholarship%2C%20advocacy%2C%20and%20explanatory%20writings%20of%20leading%20scholar%20and%20lawyer%20Douglas%20Laycock%2C%20illuminating%20every%20major%20religious%20liberty%20issue%20from%20both%20theoretical%20and%20practical%20persp",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/T0IkRd/%3F1731411640389&description=The%20Collected%20Works%20on%20Religious%20Liberty%20comprehensively%20collects%20the%20scholarship%2C%20advocacy%2C%20and%20explanatory%20writings%20of%20leading%20scholar%20and%20lawyer%20Douglas%20Laycock%2C%20illuminating%20every%20major%20religious%20liberty%20issue%20from%20both%20theoretical%20and%20practical%20persp&media=https://textcafe.co/books/T0IkRd/tc-custom/9781467434133.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781467434133&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=TsfHEAAAQBAJ&amp;rdid=book-TsfHEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467434133').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/T0IkRd/tc-custom/9781467434133.jpg?1731411640389',
        alt: 'Religious Liberty, Vol. 1, Emory University Studies in Law and Religion (EUSLR)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "005_Contents", "006_Foreword", "007_Preface01", "008_Preface02", "009_Chapter01", "010_Chapter02", "011_Chapter03", "012_Chapter04", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/T0IkRd/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_FM01__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_FM01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_FM01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_Titlepage__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_Titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_Titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Copyright__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Dedication__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Foreword__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Foreword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Foreword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Preface01__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Preface01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_Preface01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Preface02__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Preface02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Preface02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Chapter01__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_009_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter02__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_010_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter03__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_011_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter04__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_012_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Chapter05__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_013_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter06__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_014_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter07a__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter07a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_015_Chapter07a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_015_Chapter07b__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_015_Chapter07b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_015_Chapter07b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_016_Chapter08__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_016_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_016_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_017_Chapter09__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_017_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_017_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_018_Chapter10__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_018_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_018_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_019_Chapter11__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_019_Chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_019_Chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_020_Chapter12__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_020_Chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_020_Chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_021_Chapter13__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_021_Chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_021_Chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_022_Chapter14__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_022_Chapter14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_022_Chapter14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_023_Chapter15__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_023_Chapter15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_023_Chapter15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_024_Chapter16__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_024_Chapter16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_024_Chapter16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_025_Chapter17__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_025_Chapter17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_025_Chapter17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_026_Chapter18__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_026_Chapter18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_026_Chapter18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_027_Chapter19__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_027_Chapter19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_027_Chapter19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_028_Chapter20__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_028_Chapter20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_028_Chapter20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_029_Chapter21__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_029_Chapter21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_029_Chapter21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_030_Chapter22__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_030_Chapter22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_030_Chapter22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_031_Chapter23__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_031_Chapter23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_031_Chapter23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_032_Chapter24__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_032_Chapter24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_032_Chapter24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_033_Chapter25__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_033_Chapter25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_033_Chapter25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_034_Chapter26__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_034_Chapter26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_034_Chapter26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_035_Chapter27__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_035_Chapter27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_035_Chapter27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_036_Chapter28__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_036_Chapter28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_036_Chapter28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_037_Chapter29__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_037_Chapter29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_037_Chapter29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_038_Chapter30__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_038_Chapter30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_038_Chapter30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_039_Chapter31__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_039_Chapter31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_039_Chapter31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_040_Chapter32__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_040_Chapter32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_040_Chapter32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_041_Chapter33__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_041_Chapter33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_041_Chapter33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_042_Chapter34__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_042_Chapter34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_042_Chapter34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_043_Chapter35__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_043_Chapter35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_043_Chapter35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_044_Chapter36__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_044_Chapter36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_044_Chapter36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_045_Chapter37__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_045_Chapter37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_045_Chapter37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_046_Chapter38__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_046_Chapter38___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_046_Chapter38__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_047_Chapter39__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_047_Chapter39___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_047_Chapter39__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_048_Chapter40__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_048_Chapter40___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_048_Chapter40__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_049_Chapter41__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_049_Chapter41___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_049_Chapter41__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_050_Chapter42__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_050_Chapter42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_050_Chapter42__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_051_Chapter43__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_051_Chapter43___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_051_Chapter43__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_052_Chapter44__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_052_Chapter44___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_052_Chapter44__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_053_Chapter45__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_053_Chapter45___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_053_Chapter45__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_054_Chapter46__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_054_Chapter46___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_054_Chapter46__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_055_Chapter47__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_055_Chapter47___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_055_Chapter47__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_last__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_last__);
/*jshint esversion: 6 */
































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/005_Contents",
    "name": "005_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default.a
  }, {
    "path": "/006_Foreword",
    "name": "006_Foreword",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Foreword___default.a
  }, {
    "path": "/007_Preface01",
    "name": "007_Preface01",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_Preface01___default.a
  }, {
    "path": "/008_Preface02",
    "name": "008_Preface02",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Preface02___default.a
  }, {
    "path": "/009_Chapter01",
    "name": "009_Chapter01",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_009_Chapter01___default.a
  }, {
    "path": "/010_Chapter02",
    "name": "010_Chapter02",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter02___default.a
  }, {
    "path": "/011_Chapter03",
    "name": "011_Chapter03",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter03___default.a
  }, {
    "path": "/012_Chapter04",
    "name": "012_Chapter04",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter04___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_61__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Douglas Laycock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Douglas Laycock")]), _vm._v(" is Robert E. Scott Distinguished Professor of Law and professor of religious studies at the University of Virginia. In addition to his work as a lawyer, he has written for the "), _c('I', [_vm._v("New York Times")]), _vm._v(", the "), _c('I', [_vm._v("Washington Post")]), _vm._v(", and numerous other publications. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T0IkRd/tc-custom/9781467434133.jpg?1731411640389",
      "alt": "This image is the cover for the book Religious Liberty, Vol. 1, Emory University Studies in Law and Religion (EUSLR)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Religious Liberty, Vol. 1, Emory University Studies in Law and Religion (EUSLR)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Collected Works on Religious Liberty comprehensively collects the scholarship, advocacy, and explanatory writings of leading scholar and lawyer Douglas Laycock, illuminating every major religious liberty issue from both theoretical and practical perspectives.  / This first volume gives the big picture of religious liberty in the United States. It fits a vast range of disparate disputes into a coherent pattern, from public school prayers to private school vouchers to regulation of churches and believers. Laycock clearly and carefully explains what the law is and argues for what the law should be. He also reviews the history of Western religious liberty from the American founding to Protestant-Catholic conflict in the nineteenth century, using this history to cast light on the meaning of our constitutional guarantees.  / Collected Works on Religious Liberty is unique in the depth and range of its coverage. Laycock helpfully includes both scholarly articles and key legal documents, and unlike many legal scholars, explains them clearly and succinctly. All the while, he maintains a centrist perspective, presenting all sides — believers and nonbelievers alike — fairly.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Foreword#FORE"
    }
  }, [_c('em', [_vm._v("Foreword")]), _vm._v(", by John Witte, Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface01#PRE1"
    }
  }, [_c('em', [_vm._v("Preface to the Collected Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface02#PRE2"
    }
  }, [_c('em', [_vm._v("Preface to Volume 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#PT1"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONE")]), _vm._v(": O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VERVIEWS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#PT1.1"
    }
  }, [_c('strong', [_vm._v("A. Normative Overviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#PT1.1.3"
    }
  }, [_vm._v("Formal, Substantive, and Disaggregated Neutrality toward Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#PT1.1.3"
    }
  }, [_c('em', [_vm._v("39 DePaul Law Review 993 (1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#PT1.1.4"
    }
  }, [_vm._v("The Benefits of the Establishment Clause")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#PT1.1.4"
    }
  }, [_c('em', [_vm._v("42 DePaul Law Review 373 (1992)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_vm._v("Religious Liberty as Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_c('em', [_vm._v("7 Journal of Contemporary Legal Issues 313 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#PT1.1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Exercise Clause and Establishment Clause: General Theories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#PT1.1.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Religion and American Law: An Encyclopedia 516 (Paul Finkelman, ed., 2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter06#PT1.1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty: Not for Religion or against Religion, but for Individual Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#PT1.1.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3 UT Law 42 (No. 1, Spring 2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theology Scholarships, the Pledge of Allegiance, and Religious Liberty: Avoiding the Extremes but Missing the Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("118 Harvard Law Review 156 (2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Substantive Neutrality Revisited")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("110 West Virginia Law Review 51 (2007)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#PT1.1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remarks on Acceptance of National First Freedom Award from the Council for America’s First Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#PT1.1.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("January 15, 2009")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#PT1.2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B. Analytic and Descriptive Overviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#PT1.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Survey of Religious Liberty in the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#PT1.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("47 Ohio State Law Journal 409 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#PT1.2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty: The Legal Rights of Religious Belief and Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#PT1.2.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("30 Concern No. 1, at 16 (Jan. 1988)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter13#PT1.2.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Freedom and International Human Rights in the United States Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter13#PT1.2.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12 Emory International Law Review 951 (1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter14#PT1.2.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Round Table Discussion on International Human Rights Standards in the United States: The Case of Religion or Belief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter14#PT1.2.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12 Emory International Law Review 973 (1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter15#PT1.2.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Supreme Court and Religious Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter15#PT1.2.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("40 Catholic Lawyer 25 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter16#PT1.2.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vouching towards Bethlehem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter16#PT1.2.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religion in the News 2 (Summer 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter17#PT1.2.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church and State in the United States: Competing Conceptions and Historic Changes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter17#PT1.2.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("13 Indiana Journal of Global Legal Studies 503 (2006)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/026_Chapter18#PT1.2.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty in America: A Rapid Fire Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter18#PT1.2.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("33 Human Rights No. 3, at 3 (Summer 2006)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter19#PT1.2.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Conscripted Prophet’s Guesses about the Future of Religious Liberty in America")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter19#PT1.2.11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("October 25, 2007")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter20#PT1.3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("C. Book Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter21#PT1.3.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflections on Two Themes: Teaching Religious Liberty and Evolutionary Changes in Casebooks: Reviewing John T. Noon, Jr., "), _c('em', [_vm._v("Believers and the Powers That Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter21#PT1.3.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("101 Harvard Law Review 1642 (1988)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter22#PT1.3.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Note: Reviewing Mark V. Tushnet’s "), _c('em', [_vm._v("Red, White, and Blue:")]), _vm._v(" "), _c('em', [_vm._v("A Critical Analysis of Constitutional Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter22#PT1.3.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("31 Journal of Church and State 303 (1989)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter23#PT1.3.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Note: Reviewing Jesse H. Choper’s "), _c('em', [_vm._v("Securing Religious Liberty: Principles for Judicial Interpretation of the Religion Clauses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter23#PT1.3.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("44 Political Studies 1015 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter24#PT1.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("D. Judicial Nominations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter25#PT1.4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophy Is Enough to Deny Senate Consent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter25#PT1.4.3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("USA Today 10A (Sept. 15, 1987)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter26#PT1.4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senators Joseph R. Biden and Strom Thurmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter26#PT1.4.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Nomination of Robert H. Bork to Be Associate Justice of the Supreme Court of the United States 6099 (1987)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter27#PT1.4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Review: Reviewing Robert H. Bork’s "), _c('em', [_vm._v("The Tempting of America: The Political Seduction of the Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter27#PT1.4.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("101 Ethics 661 (1991)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter28#PT1.4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senator Patrick Leahy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter28#PT1.4.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("(July 2, 2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter29#PT1.4.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senator Orrin G. Hatch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter29#PT1.4.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Confirmation Hearings on Federal Appointments 737 (Senate Committee on the Judiciary 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/038_Chapter30#PT1.4.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forging Ideological Compromise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter30#PT1.4.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("New York Times A31 (Sept. 18, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter31#PT1.4.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some of the False Attacks on Michael McConnell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter31#PT1.4.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Confirmation Hearings on Federal Appointments 737 (Senate Committee on the Judiciary 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter32#PT1.4.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judicial Nominations in a Divided Government")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter32#PT1.4.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Austin American-Statesman A15 (Oct. 9, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter33#PT1.4.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Injudicious: Liberals Should Get Tough on Bush’s Conservative Judicial Nominees—and Stop Opposing Michael McConnell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter33#PT1.4.11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The American Prospect Online (Oct. 30, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/042_Chapter34#PT2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TWO")]), _vm._v(": H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/043_Chapter35#PT2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Founders Wanted Total Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/043_Chapter35#PT2.4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("USA Today 8A (Aug. 12, 1985)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter36#PT2.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Nonpreferential” Aid to Religion: A False Claim about Original Intent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter36#PT2.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("27 William & Mary Law Review 875 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter37#PT2.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Responding to the Nonpreferentialists: A Review of Thomas J. Curry’s "), _c('em', [_vm._v("The First Freedoms: Church and State in America to the Passage of the First Amendment")]), _vm._v(" (1986), and Leonard W. Levy’s "), _c('em', [_vm._v("The Establishment Clause: Religion and the First Amendment")]), _vm._v(" (1986)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter37#PT2.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4 Journal of Law and Religion 241 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/046_Chapter38#PT2.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text, Intent, and the Religion Clauses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/046_Chapter38#PT2.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4 Notre Dame Journal of Law, Ethics, and Public Policy 683 (1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter39#PT2.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Original Intent and the Constitution Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter39#PT2.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in The First Freedom: Religion and the Bill of Rights 87 (James E. Wood, ed., 1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter40#PT2.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Declaration Is Not Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter40#PT2.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Quarterly, A Publication of the Christian Legal Society 8 (Fall 1991)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/049_Chapter41#PT2.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Noncoercive” Support for Religion: Another False Claim about the Establishment Clause")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/049_Chapter41#PT2.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("26 Valparaiso University Law Review 37 (1992)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/050_Chapter42#PT2.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continuity and Change in the Threat to Religious Liberty: The Reformation Era and the Late Twentieth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/050_Chapter42#PT2.11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("80 Minnesota Law Review 1047 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/051_Chapter43#PT2.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty and Free Exercise: Back to the Future—What 21st Century Legal Culture Can Learn from the 19th Century’s First Amendment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/051_Chapter43#PT2.12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1 Engage 132 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter44#PT2.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regulatory Exemptions of Religious Behavior and the Original Understanding of the Establishment Clause")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter44#PT2.13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("81 Notre Dame Law Review 1793 (2006)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/053_Chapter45#PT3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THREE")]), _vm._v(": A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDICES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter46#PT3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter46#PT3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“God Alone Is Lord of the Conscience”: Policy Statement and Recommendations Regarding Religious Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secaut"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter46#PT3.1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Committee on Religious Liberty and Church/State Relations, Presbyterian Church (U.S.A.) (1988) (reprinted in 8 Journal of Law & Religion 331 [1990])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/055_Chapter47#PT3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('span', {
    attrs: {
      "href": "#/055_Chapter47#PT3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Legal Citations for Nonlegal Readers")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "FORE"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "chpara"
  }, [_vm._v("It is a special privilege for the Emory University Studies in Law and Religion Series to publish the collected writings of Douglas Laycock on religious liberty. Professor Laycock has been one of the world’s leading scholars of religious liberty for the past three decades and has written briefs and argued in a number of Supreme Court and Court of Appeals cases. He has crafted federal and state legislation on religious liberty, testified before countless Congressional committees, and appeared regularly in televised and print media. He has stood at distinguished lecterns throughout North America, including two memorable keynote appearances at Emory Law School. Currently the Yale Kamisar Professor of Law at the University of Michigan Law School, he was formerly chaired professor of law at the University of Texas at Austin and before that professor of law at the University of Chicago Law School.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("It is his work as a scholar of religious liberty, however, that has set Professor Laycock apart from virtually every other person now working in the field of religious liberty. Laycock’s work has shaped a number of major religious liberty doctrines in America. Building on the writings of Paul Kauper and Arlin Adams, for example, he developed the concept of “church autonomy” in a path-breaking 1981 article in the "), _c('em', [_vm._v("Columbia Law Review.")]), _vm._v(" The phrase is now commonly used, as he advocated, to describe a church’s right to manage its own internal affairs, as distinguished from the right of a church or believer to refrain from violating their religious teachings. This understanding is also now common currency in European jurisprudence of “religious autonomy.” He wrote a path-breaking article on “non-preferential aid” in the 1986 "), _c('em', [_vm._v("William & Mary Law Review")]), _vm._v(" that exposed a number of the false historical claims being pressed by judges and jurists alike in their attempts to weaken the First Amendment Establishment clause. He helped create the idea of equal access ")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("for religious and secular speakers by writing the seminal article on that idea in a 1986 "), _c('em', [_vm._v("Northwestern Law Review")]), _vm._v(", an article which has convinced secular liberals and religious conservatives alike to support equal access for religious speech. That concept has driven a dozen major Supreme Court cases. He coined the phrase “substantive neutrality,” distinguishing it from “formal neutrality,” in a memorable lecture at the DePaul Center for Church/State Studies. He was the first to explain how exempting religiously motivated behavior from regulation could be substantively neutral—and therefore consistent with neutrality understandings of the First Amendment religion clauses—even if it looked like special treatment for religion and thus was not formally neutral. Formal and substantive neutrality is now a widespread usage in the literature and case law. He was also one of the principal champions of the 1993 Religious Freedom Restoration Act and the 2000 Religious Land Use and Institutionalized Persons Act, two federal statutes which, among others, have provided some measure of protection for vulnerable religious minorities.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His writing is consistently crisp, concise, and cogent. He is not given to ponderous academic prose or arcane legalese, yet he finds a way of capturing complex legal issues artfully and comprehensively. Most of his work is readily accessible to scholars and students of law, theology, ethics, political science, history, and American studies alike. The chapters gathered in this volume and its sequels are goldmines of information and meet gold standards of erudition. Here are a few choice phrases you will encounter in the pages that follow:")]), _vm._v(" "), _c('p', {
    staticClass: "List1Sb"
  }, [_vm._v("•"), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“Suppression of a faith is no less suppression when the victims go quietly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "List1"
  }, [_vm._v("•"), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“Reliance on post-ratification practice leads to such absurd consequences because it proceeds backwards. It lets the behavior of government officials control the meaning of the Constitution, when the whole point is for the Constitution to control the behavior of government officials.”")])]), _vm._v(" "), _c('p', {
    staticClass: "List1"
  }, [_vm._v("•"), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“Nor is it the case that tax exemption, considered alone, is a subsidy. Government does not subsidize a church by leaving it alone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "List1"
  }, [_vm._v("•"), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“Religion is not free when the government charges for its exercise.”")])]), _vm._v(" "), _c('p', {
    staticClass: "List1"
  }, [_vm._v("•"), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“Proponents of landmarking seem genuinely unable to comprehend why churches object to maintaining their houses of worship as permanent architectural museums, at the expense of those who worship there, for the aesthetic pleasure of those who do not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "List1"
  }, [_vm._v("•"), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“The judicial role is defined by the Constitution; the Constitution is not defined by changing conceptions of the judicial role.”")])])]), _c('p', {
    staticClass: "indent-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("In all his writing, Professor Laycock’s perspective is not pro-religion or anti-religion, but pro-religious liberty. In his writing and advocacy, he has ")]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("defended religious liberty for believers and nonbelievers alike. He has worked closely with groups from across the religious and political spectrum—Evangelicals, Catholics, Mormons, Mainline Protestants, Seventh-day Adventists, Jews (including Orthodox, Conservative, and Reform), the ACLU, People for the American Way, Americans United for Separation of Church and State, liberal Democrats and conservative Republicans. Hanging on his office wall at the University of Texas when I visited him (and no doubt now at the University of Michigan, too) are pictures with him and Bill Clinton and a framed thank you note from George W. Bush. All serious sides of the perennial culture wars surrounding religion and religious liberty respect him, regardless of whether they agree or disagree with him.")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is a great boon to the field of religious liberty—and American religion and culture more generally—to have Professor Laycock’s wise writings, currently scattered in multiple forums and formats, gathered in one thematically organized collection. It is fitting to have his work appear in a book series that has included entries from several other scholarly titans on law and religion, including Harold J. Berman, Brian Tierney, and Glenn Tinder, with further volumes forthcoming from Michael McConnell, David Little, and others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This effort to publish the collected writings of leading scholars of religious liberty is part and product of a major project on “Law, Religion, and Human Rights,” generously sponsored by the Henry Luce Foundation in New York City. My colleagues and I in the Center for the Study of Law and Religion at Emory University would like to express our deep appreciation to Luce President Michael Gilligan and Senior Program Officer, Terry Lautz, for their uncommonly kind and keen project guidance and support. We would also to thank the University of Michigan Law School and the University of Texas Law School for their generous subvention in support of this collected works projects. We also express our deep gratitude to Amy Wheeler, Associate Editor of the Emory University Studies in Law and Religion Series, for her hard work on the preparation of this manuscript. And we express our deep gratitude to Jon Pott and his colleagues at Eerdmans for taking on this important collection and for publishing it with their usual efficiency, sharp editing, and handsome production.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We reserve our deepest thanks and praise to Douglas Laycock for his exemplary scholarship and advocacy on issues of religious liberty, religion and human rights, and church-state relations. May it long continue!")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col47"
  }), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "Right"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITTE")]), _vm._v(", J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("R")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Right"
  }, [_c('em', [_vm._v("General Editor")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Right"
  }, [_c('em', [_vm._v("Emory University Studies in Law and Religion")])])])])])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "PRE1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("Preface to the Collected Works")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "chpara"
  }, [_vm._v("It was both a surprise and an honor when the Center for the Study of Law and Religion at Emory University invited me to help compile a comprehensive collection of my work on religious liberty. At least, it will be comprehensive up to the date of publication; I do not intend to quit thinking and writing about these issues when these volumes are sent to the printer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In 2007, I finished my first thirty years of studying, defending, and writing about religious liberty. For reasons having nothing to do with me, it has been a remarkable thirty years, a time of great religious fervor and substantial religious conflict in the United States. Some commentators describe this time as a culture war. It is quite possible that historians will call it the fourth Great Awakening—one of a series of periods of intense evangelical Christian revival that have swept through the United States at long intervals since the first Great Awakening, which peaked in the 1740s. However we characterize the last thirty years, this period has produced serious debate and reexamination of every aspect of religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have participated in these debates from a position of relative neutrality in the putative culture wars. Of course I have taken strong positions on individual issues, but I have sometimes defended conservative Christians, sometimes their secular opponents, sometimes believers in other faiths. My perspective has never been for religion or against religion, but for religious liberty—for believers of all kinds and for nonbelievers as well. From that perspective, each of the publicly perceived sides in the culture wars is right on some issues and wrong on others. There is a simple reason why each side is right on some issues and wrong on others: it is because their positions are too often dictated by their own self-interest, by what is good for religion or bad for religion, or sometimes, by what is good for evangelical Christians or bad for evangelical Christians.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("I have argued for maximizing the religious freedom of all sides and letting the chips fall where they may. I have strongly defended the right of individuals and of organized groups to believe what they will about religion, to speak about those beliefs and attempt to persuade others, and to act on those beliefs. I have strongly opposed all efforts to get government to take sides with respect to beliefs about religion, to impose religious exercises on audiences assembled for other purposes, or to encourage or discourage any religious belief or practice. I have tried to think systematically about what it means to encourage or discourage religion and what it means for government to minimize its influence on religious choices and commitments.")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("This fundamental perspective led to a series of theoretical and policy principles that are prominently associated with my work (although none of them is entirely unique to me). One such principle, prominent in this volume, is substantive neutrality as distinguished from formal neutrality. Formal neutrality means religiously neutral categories—religion-blind government. Substantive neutrality means religiously neutral incentives—government conduct that insofar as possible neither encourages nor discourages religion. This theme is pervasive in my work, often explicit, sometimes implicit and simply assumed. ")]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#PT1.1.3"
    }
  }, [_c('em', [_vm._v("Formal, Substantive, and Disaggregated Neutrality toward Religion")]), _vm._v(" (1990)")]), _vm._v(" is my original statement of substantive neutrality; "), _c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Substantive Neutrality Revisited")]), _vm._v(" (2007)")]), _vm._v(" is a mature summary and review.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another premise fundamental in my work is that religious believers should be free to act on religious teachings or religiously informed conscience, except where the state must intervene to prevent significant harms to others. This right to “exercise” one’s religion, in the language of the Constitution’s Free Exercise Clause, sometimes requires that religiously motivated conduct be exempted from generally applicable laws, as when some faiths refuse to employ women as clergy, or when they give sacramental wine to children and adolescents. In a pervasively regulated society, such exemptions are essential to religious liberty. That view is by no means unique to me; it is very widely shared among defenders of religious liberty. But it has been controversial in the last generation, and it has been the subject of extensive legislation and litigation as well as academic debate. The Supreme Court of the United States interpreted the Constitution not to include any right to religious exemption from general regulation; Congress, many state legislatures, and many state supreme courts have disagreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This claim of a right to regulatory exemptions under the Constitution will be the focus of much of volume 2; multiple attempts to create a right to regulatory exemptions by legislation will be the focus of most of volume 3. My most basic statement on the right to religious exemption from regulation "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("is "), _c('em', [_vm._v("The Remnants of Free Exercise")]), _vm._v(" (1990), projected to appear in volume 2. In volume 1, the issue gets significant treatment in articles overviewing the entire field, especially ")]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_c('em', [_vm._v("Religious Liberty as Liberty")]), _vm._v(" (1996)")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/023_Chapter15#PT1.2.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Supreme Court and Religious Liberty")]), _vm._v(" (2000)")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Theology Scholarships, the Pledge of Allegiance, and Religious Liberty")]), _vm._v(" (2004)")]), _vm._v(". "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_c('em', [_vm._v("Religious Liberty as Liberty")])]), _vm._v(" is also my most basic statement of why we protect religious liberty in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The original impetus for my theory of substantive neutrality was to reconcile the claim to religious exemption from generally applicable laws, which seems axiomatic to religious liberty, with the widely shared intuition that government should be neutral towards religion. An exemption from regulation is a form of special treatment, and thus a departure from religiously neutral categories, but because it removes the threat that government will penalize religious observance, the exemption often creates religiously neutral incentives. So the right to regulatory exemptions is prominent in articles on substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A principle more specifically associated with my work is church autonomy—that religious organizations are entitled to manage their own internal affairs free of government interference. Church autonomy is distinct from, and independent of, the more widely understood claim of a right to regulatory exemptions on the basis of specific religious doctrines or conscientiously held beliefs. A church’s right to select its own clergy, define its own governing structure, and resolve its own internal disputes should not depend on whether it can show in every case that its decisions are based on some specific church teaching. Rather, the right to make such inherently religious decisions is inherent in religious liberty. Sometimes the courts agree; sometimes they seem not to understand the argument.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Church autonomy will be prominent in volume 2. I did not coin the phrase “church autonomy,” but I seem to have brought it to the attention of religious liberty scholars. The original article in which I defined and promoted the concept is "), _c('em', [_vm._v("Towards a General Theory of the Religion Clauses")]), _vm._v(" (1981). Volume 2 will also contain numerous applications of church autonomy to religious governance, religious employment, religious schools, and religious counseling, including the limits of church autonomy in such controversial contexts as the sex-abuse cases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another principle, widely shared but also prominently associated with my work, is that religious speech by citizens speaking in their private capacity is constitutionally protected, while the same religious speech by government employees speaking in their governmental capacity is constitutionally prohibited or very tightly restricted. This basic distinction and its many applications is projected to be the subject of much of volume 4. The original article "), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("in which I first promoted the idea is "), _c('em', [_vm._v("Equal Access and Moments of Silence")]), _vm._v(" (1986). The idea gets prominent treatment in overview articles in this volume, especially "), _c('em', [_vm._v("Religious Liberty as Liberty")]), _vm._v(" (1996), and "), _c('em', [_vm._v("Theology Scholarships, The Pledge of Allegiance, and Religious Liberty")]), _vm._v(" (2004).")])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("Still another basic principle, especially in my later work, is that government cannot fund religious activities, but that when a religious organization provides a secular service in a religious environment, government can fund the secular service to the same extent that it funds similar services by secular providers. I came to the second half of this position by a long slow evolution over the course of my career; many others had promoted the idea before me. Specific treatments of this idea will appear in volume 4. But my most complete statements of the theory appear in parts of overview articles in volume 1: ")]), _c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Theology Scholarships, the Pledge of Allegiance, and Religious Liberty")]), _vm._v(" (2004)")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Substantive Neutrality Revisited")]), _vm._v(" (2007)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Constitutional debates over religious liberty are much informed by history—the history of religious conflict and persecution in Europe and the American colonies, the debate in the Founding Era of the United States over religious liberty and especially over disestablishing the established churches in New England and the southern colonies, and the history of Catholic-Protestant conflict in the United States, especially in the nineteenth century. I have investigated each of these historical conflicts, and this historical work appears in volume 1. The history article that has had the greatest influence is probably "), _c('span', {
    attrs: {
      "href": "#/044_Chapter36#PT2.5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“Nonpreferential” Aid to Religion")]), _vm._v(" (1986)")]), _vm._v(", which refutes the claim that the American Founders intended to permit government to aid religion so long as it aided all religions without showing any preference among them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Each of these broad principles and each of these historical investigations has many applications, most of them disputed. Much of my work has been inductive in a sense, developing and elaborating broader principles in the course of proposing solutions to specific controversies. These treatments of specific applications appear throughout these volumes, in a variety of genres.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some of these specific applications involve distinctly contemporary disputes. But the underlying disagreements have had a remarkable staying power. The argument over whether to regulate religious practices, or to exempt them from regulation where possible, goes back to colonial times. The argument over government speech promoting or endorsing religion goes back to the creation of the public schools in the second quarter of the nineteenth century. The argument about government funding of religious institutions goes back to the same period, in substantially its modern form, and back to colonial times in a rather different form, when the debate was about funding the church itself. The persistence of these issues implies that they "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("will be with us long into the future, and that the discussions here will remain relevant to live controversies, both theoretical and practical.")])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The principles set forth here align me with different groups on different issues. Consequently, I have worked closely with groups from across the religious and political spectrum—mainline Protestants, evangelicals, the Catholic bishops, Jews (including Orthodox, Conservative, and Reform), Mormons, Seventh-day Adventists, small religions far outside the mainstream (Hare Krishna, Scientology, Santeria, Uniao do Vegetal), the American Civil Liberties Union, People for the American Way, Americans United for Separation of Church and State, liberal Democrats, conservative Republicans, the Clinton Administration, and the Bush Administration. Hanging on my office wall are photographs with Bill Clinton and a thank-you note from George W. Bush. I have worked closely with all these groups when we agreed, and they have generally respected my integrity when we disagreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have participated in these debates in the law reviews, in the religious and secular press, in the courts, and in legislative hearings, producing scholarly articles, popular articles, written and oral arguments to courts, and formal and informal statements to legislators. These different genres slice the material in different ways and may be useful to different readers. Some readers will prefer a fully elaborated, fully footnoted scholarly treatment; others will find it easier to get the main ideas from a short popular treatment. Each form is included here. And while there is overlap, each entry says something at least somewhat different from all the others. The editors and I have decided to omit only those writings that are almost entirely duplicative of earlier work. I will have more to say about the inclusion of briefs and legislative testimony in later volumes where those genres appear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most of this work is available only in major law libraries or subscription-based legal databases. These sources are accessible to lawyers but seriously inconvenient or wholly inaccessible to non-lawyers. Some of this work was circulated in limited quantities to select audiences and is not publicly available anywhere except in this collection. We hope that this collection will make this work available to religious leaders and religious scholars and to scholars studying these issues from the perspective of political science, sociology, or other disciplines, and that it will make the entire corpus more readily accessible to lawyers and law students.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("We anticipate that the work will appear in four volumes. The law of religious liberty is dominated by three broad sets of disputes, over regulation of religious practice, regulation and sponsorship of religious speech, and funding of religious institutions. Volume 1, "), _c('em', [_vm._v("Overviews and History")]), _vm._v(", includes overview articles that address at least two—often all three—of these broad areas. ")]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_vm._v("Volume 1 also includes my historical work, book reviews not focused on a specific issue addressed in a later volume, and some work on judicial nominations, where disagreements over religious liberty have played a large role.")])]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Volume 2, "), _c('em', [_vm._v("The Free Exercise Clause")]), _vm._v(", will collect my work on the constitutional right to free exercise of religion. Volume 3, "), _c('em', [_vm._v("Religious Liberty Legislation")]), _vm._v(", will collect work on statutory guarantees of religious liberty. Volume 4, "), _c('em', [_vm._v("The Free Speech and Establishment Clauses")]), _vm._v(", will collect work on freedom of religious speech and on the disestablishment of religion, including disputes over government speech about religion and government funding of religious institutions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Each entry is accompanied by a short introduction that places it in context. Each section of related entries has a similar introduction that explains the theme of the section and very briefly describes each entry. These introductions also contain cross-references to related entries that appear elsewhere because their dominant theme placed them in a different organizational category. Readers can use these introductions to find the pieces that most interest them. Within each section, the pieces are arranged chronologically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Many of the entries have a second explanatory paragraph, which appears in an unnumbered footnote at the bottom of the first page. This is the author’s note from the original publication, slightly amended because it is no longer necessary to identify the author.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Readers without legal training should not be intimidated by the footnotes. If you wish, you can ignore them and miss very little. I have always viewed textual footnotes as a burdensome distraction, and I try to write as few of them as possible. I see that I have succumbed to the temptation to write more of them than I like to remember, but even so, the great bulk of what you will find in the footnotes is extensive citations to other scholarly articles, court decisions, statutes, and regulations, usually with brief parenthetical explanations of what those sources say. If you are not interested in the details of my sources, you can skip those citations.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_vm._v("Legal writing is so voluminously footnoted because law is an adversary discipline. Practicing lawyers are paid to make arguments, they are tempted to exaggerate, and they don’t entirely trust each other. So when a lawyer wants to show that he’s telling the truth, he includes a footnote for every detail of his argument. The practice carried over to scholarly legal writing, which has absorbed some of the same adversary characteristics, and it was exaggerated by the tradition of entrusting the leading journals to student editors, who are understandably insecure about their role and compensate in part by strictly enforcing excessively detailed rules about footnoting. All this footnoting can be annoying, but much more so for authors than for readers. The advantage is that when a reader wants to know where some assertion ")]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v("comes from, she can generally get a very precise answer by taking a peek at the footnotes. The main thing for readers from other disciplines to remember is that lawyers put the volume number "), _c('em', [_vm._v("before")]), _vm._v(" the title of the book or journal article, not after.")])]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v("Because they footnote so heavily, lawyers developed a compact system of citation that conveys a lot of information about the cited source. Most of that information is surprisingly easy to extract. For any readers who are interested, ")]), _c('span', {
    attrs: {
      "href": "#/055_Chapter47#PT3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2")]), _vm._v(" is a decoder ring—a short and simple readers’ guide to the basics of legal citation form and the information encapsulated in citations. To reduce the number of citation forms and thus simplify the decoding process, citations have generally been conformed to current practice. Subsequent developments in cases cited while they were still pending are generally noted in brackets. Other minor editorial corrections have been made without notation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cross-references to my own work of course generally refer to the page number of the original publication. To enable readers to find the referenced passages in these volumes, we have added a parenthetical reference to the footnote number or numbers nearest to the cited passage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It has been my good fortune to teach at three great law schools—The University of Chicago from 1976 to 1981, The University of Texas from 1981 to 2006 (where I still hold an emeritus appointment), and The University of Michigan since 2006. The great bulk of this work was done during my long stay at Texas, but some of it was written at Chicago, and some of it was written at Michigan. None of it could have been done as well without the intellectual support of my colleagues in those places and the recurring financial support of my deans in those places. Nor could it have been done as well without the intellectual community of many other fine lawyers and scholars toiling in these same vineyards. Some of these people hold academic appointments, some work for public interest organizations, a few are in private practice; all those I am thinking of have made issues of religious liberty in our time and place a central part of their work. I am grateful to all who supported this work, in many different ways, over the decades.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col60"
  }), _vm._v(" "), _c('td', {
    staticClass: "col35"
  }, [_c('p', {
    staticClass: "Right"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUGLAS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYCOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "Right"
  }, [_c('em', [_vm._v("Ann Arbor")])]), _vm._v(" "), _c('p', {
    staticClass: "Right"
  }, [_c('em', [_vm._v("November 2009")])])])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "PRE2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('em', [_vm._v("Preface to Volume 1")])])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('p', {
    staticClass: "chpara"
  }, [_vm._v("The law of religious liberty is dominated by three broad sets of disputes: over regulation of religious practice, regulation and sponsorship of religious speech, and funding of religious institutions. Of course there are some smaller areas of controversy that do not fit neatly into these three broad divisions.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_vm._v("The overview articles in ")]), _c('a', {
    attrs: {
      "href": "#/009_Chapter01#PT1"
    }
  }, [_vm._v("Part One")]), _vm._v(" of this volume address at least two of these broad areas; most address all three. There is a continuing market for explanations of how it all fits together. For the nonspecialist, the law of religious liberty is often experienced as a series of incomplete news reports about particular controversies, received at irregular intervals and rarely placing the dispute in any more helpful context than that of secularists and religious conservatives at it again. So there can be real value in an overview that organizes these discrete controversies into a few broad issues and identifies larger patterns in judicial decisions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These overviews do not necessarily give equal treatment to all three areas of religious liberty. Written at different times and for different purposes, they have different emphases. Some of these overviews contain my most extensive treatment of particular issues, and those treatments are identified by cross-references in the introductions to more focused treatments of the same or related issues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The division between Normative Overviews, and Analytic and Descriptive Overviews, is of course not a bright line. But the basic division is this. In "), _c('a', {
    attrs: {
      "href": "#/009_Chapter01#PT1.1"
    }
  }, [_vm._v("Section A")]), _vm._v(", Normative Overviews, the emphasis is on what I think the law of religious liberty should be. In "), _c('span', {
    attrs: {
      "href": "#/018_Chapter10#PT1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section B")]), _vm._v(", Analytic and Descriptive Overviews, the emphasis is on making sense of what the law of religious liberty actually is, according to the Supreme Court of the United States and other authoritative sources of law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/028_Chapter20#PT1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section C")]), _vm._v(", Book Reviews, reviews books that are themselves broad overviews of the field. Other book reviews, more focused on specific issues, will appear in later volumes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter24#PT1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section D")]), _vm._v(", on Judicial Nominations, is included because the cluster of issues that have polarized the process of nominating and confirming federal judges has prominently included religious liberty and culture war issues such as abortion, and the two nominations that provoked these writings were of considerable interest to religious conservatives and their opponents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/042_Chapter34#PT2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(" of this volume, on History, is largely self-explanatory. Some of these articles are investigations into the original understanding of the Constitution on particular issues, and might plausibly have gone in a later volume that includes that issue. But it seemed to make the most sense to gather in one place all the work that was primarily historical.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This volume also contains two Appendices. "), _c('span', {
    attrs: {
      "href": "#/054_Chapter46#PT3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I")]), _vm._v(" is a report for the Presbyterian Church (U.S.A.), a collaborative work that speaks in the church’s voice and not mine, even though I drafted substantial parts of it. "), _c('span', {
    attrs: {
      "href": "#/055_Chapter47#PT3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II")]), _vm._v(" is a short and simple explanation of legal citation form for nonlegal readers.")]), _vm._v(" "), _c('p', {
    staticClass: "Right1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUGLAS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYCOCK")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-no",
    attrs: {
      "id": "PT1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("PART ONE")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "part-title"
  }, [_c('strong', [_vm._v("Overviews")])]), _vm._v(" "), _c('h1', {
    staticClass: "part-title1",
    attrs: {
      "id": "PT1.1"
    }
  }, [_c('strong', [_vm._v("A. Normative Overviews")])]), _vm._v(" "), _c('p', {
    staticClass: "para4"
  }, [_vm._v("Four of the eight articles in this Section are major scholarly works; they set out the basic principles that underlie all my work in the field. There are also four short pieces here, three written for scholarly outlets and one for law school alumni.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.1"
    }
  }, [_c('strong', [_vm._v("The Long …")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#PT1.1.3"
    }
  }, [_c('em', [_vm._v("Formal, Substantive, and Disaggregated Neutrality toward Religion")]), _vm._v(" (1990)")]), _vm._v(" was the first clear development of the distinction between formal and substantive neutrality. That distinction, and that vocabulary, is now widely used in the academic community. Both conceptions of neutrality appear in Supreme Court cases, but without the vocabulary and rarely with any attention to the difference. Substantive neutrality was and is an attempt to reconcile the lawyer’s instinct for neutrality with a robust conception of religious liberty, and to escape the implication that neutrality requires that churches be regulated to the same extent as commercial businesses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Substantive Neutrality Revisited")]), _vm._v(" (2007)")]), _vm._v(" is a more mature elaboration of the same distinction, written nearly two decades later, responding to some of the ways in which substantive neutrality had been criticized or misunderstood. This article also provided an occasion to compare my approach with those of the centrist Noah Feldman at Harvard and the strict separationist Steven Gey at Florida State.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_c('em', [_vm._v("Religious Liberty as Liberty")]), _vm._v(" (1996)")]), _vm._v(" attempts to set out a religion-neutral case for religious liberty. We protect religious liberty not because religion is a good thing or a bad thing, but because individual liberty with respect to religious "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("choices and commitments is a good thing. This piece also contains my most complete elaboration of why nonbelievers should be protected by the Religion Clauses.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Theology Scholarships, the Pledge of Allegiance, and Religious Liberty")]), _vm._v(" (2004)")]), _vm._v(" is organized around two Supreme Court decisions in 2004. The Court held that Washington does not have to provide state scholarships to theology majors, and it ducked on the constitutionality of “under God” in the Pledge of Allegiance. This article places those decisions in larger context and uses them to survey the whole field, although of course the most detailed attention is devoted to the bodies of law that most directly controlled those two cases.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.2"
    }
  }, [_c('strong', [_vm._v("… and the Short")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#PT1.1.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Liberty: Not for Religion or against Religion, but for Individual Choice")]), _vm._v(" (2004)")]), _vm._v(" is a 1,000-word summary of the themes in the larger pieces. There is not much detail or nuance, but if you want a five-minute introduction to what I think, this is the place to start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#PT1.1.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Remarks on Acceptance of National Award from the Council for America’s First Freedom")]), _vm._v(" (2009)")]), _vm._v(" is even shorter and draws the moral more pointedly. We must protect the religious liberty of those we disagree with as vigorously as we would protect religious liberty for ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#PT1.1.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Free Exercise Clause and Establishment Clause: General Theories")]), _vm._v(" (2000)")]), _vm._v(" is a brief summary of all the important competing theories of the Religion Clauses. They say you can’t tell the players without a scorecard; this short encyclopedia entry offers a scorecard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#PT1.1.4"
    }
  }, [_c('em', [_vm._v("The Benefits of the Establishment Clause")]), _vm._v(" (1992)")]), _vm._v(" is a talk on what the Establishment Clause adds to the Free Exercise Clause. Because of that comparative focus, and because the talk was delivered during the period of greatest concern about the Supreme Court’s contraction of the Free Exercise Clause, the talk and the questions and answers that follow the talk address both clauses.")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "PT1.1.3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Formal, Substantive, and Disaggregated Neutrality toward Religion")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "para9"
  }, [_c('em', [_vm._v("39 DePaul Law Review 993 (1990)")])]), _vm._v(" "), _c('p', {
    staticClass: "para4"
  }, [_c('em', [_vm._v("This was the Sixth Annual Lecture at the Center for Church/State Studies at DePaul University in Chicago. It is the first elaboration of “substantive neutrality,” a concept that has been foundational to much of my subsequent work. The core of the conceptual problem addressed in the lecture is this. Religious liberty sometimes requires that religiously motivated conduct be exempted from government regulation, so that believers can actually practice their faith. But regulatory exemptions on religious grounds look like special treatment for religion, and that seems inconsistent with another widely shared intuition, important in other religious liberty controversies: that government should be neutral toward religion. Is there a coherent understanding of neutrality that is consistent with full religious liberty?")])])]), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("A wide range of courts and commentators commonly say that government must be neutral toward religion."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1",
      "id": "ft4.1"
    }
  }, [_vm._v("1")]), _vm._v(" There are dissenters in both directions—those who think that government can support religion, and those who pursue separation to the point of hostility. In this Article, I will largely ignore those dissenters. I will assume that neutrality is an important part of the meaning of the Religion Clauses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This Article is about the meaning of neutrality. My goal is to clarify the concept, or at least to clarify our disagreements over its meaning. In the course of doing that, I will address a third group of dissenters—those who think that neutrality is meaningless and should be dropped from our discourse."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.2",
      "id": "ft4.2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Those who think neutrality is meaningless have a point. We can agree on the principle of neutrality without having agreed on anything at all. From benevolent neutrality"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.3",
      "id": "ft4.3"
    }
  }, [_vm._v("3")])]), _vm._v(" to separate but equal,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.4",
      "id": "ft4.4"
    }
  }, [_vm._v("4")])]), _vm._v(" people with a vast range of views on church and state have all claimed to be neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider "), _c('em', [_vm._v("Texas Monthly, Inc. v. Bullock.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.5",
      "id": "ft4.5"
    }
  }, [_vm._v("5")])]), _vm._v(" The Supreme Court said that Texas can not exempt the sale of religious publications from a sales tax that applies to all other publications. Justice Brennan and Justice Scalia fundamentally disagreed on almost every issue in the case, but they both claimed to be neutral."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.6",
      "id": "ft4.6"
    }
  }, [_vm._v("6")])]), _vm._v(" Both of them used the word “neutrality,” but neither of them defined it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most of us think of ourselves as fairminded, and so we tend to assume that our instinctive preferences are fair, and therefore neutral. Some scholars "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("have tried to define neutrality more carefully, but they have produced quite inconsistent definitions.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Both of these points—the power of our instincts and the inconsistency of formal definitions—were brought home to me when I presented a paper"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.7",
      "id": "ft5.7"
    }
  }, [_vm._v("7")]), _vm._v(" on the Equal Access Act."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.8",
      "id": "ft5.8"
    }
  }, [_vm._v("8")])]), _vm._v(" The Act tries to guarantee the right of student religious groups to meet in empty classrooms on the same terms as other extracurricular student groups. The Supreme Court has finally upheld the statute,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.9",
      "id": "ft5.9"
    }
  }, [_vm._v("9")])]), _vm._v(" ending six years of debate over its constitutionality. This seemed to me an easy case to resolve with the neutrality principle. I argued that government could not discriminate against religious speech by private speakers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A distinguished panel of commentators attacked me from all directions. Ruti Teitel insisted that the only neutral course was to exclude the religious speakers. She thought that my error was to treat as alike things that were different."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.10",
      "id": "ft5.10"
    }
  }, [_vm._v("10")])]), _vm._v(" Geoffrey Stone argued that neutrality permitted my solution, but certainly did not require it. He thought it was neutral to exclude the religion club if the school board also promised to exclude the atheist club, if there ever were one."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.11",
      "id": "ft5.11"
    }
  }, [_vm._v("11")])]), _vm._v(" Michael McConnell agreed with my solution, but he said my definition of neutrality was “heterodox.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.12",
      "id": "ft5.12"
    }
  }, [_vm._v("12")])]), _vm._v(" He insisted that neutrality is not a reliable principle, because properly defined, it is often at odds with religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was McConnell’s attack that troubled me the most. I believe that neutrality is consistent with religious liberty—indeed, essential to its preservation. Our miscommunication did not seem to flow from any underlying policy disagreement. As a result of that exchange, I feared that other meanings of neutrality had so captured our vocabulary that I could not use the term to communicate, even to sympathetic audiences and even when I defined it. McConnell’s comment on my definition of neutrality made it inevitable that I would explore the definition in greater depth. I take considerable comfort from McConnell’s move toward a somewhat similar definition in the intervening four years."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.13",
      "id": "ft5.13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("I. Is Neutrality Worth Defining?")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Maybe these conflicting uses of “neutrality” prove that we should abandon the concept. A few years ago, Peter Westen stirred up a great fuss by claiming that equality is an empty concept."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.6.14",
      "id": "ft6.14"
    }
  }, [_vm._v("14")]), _vm._v(" Neutrality and equality are near cousins; they have most of the same attractions and most of the same inadequacies. If Westen were right, then neutrality would also be empty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am quite sure that Westen was wrong, but he highlighted something important that we too often ignore. Equality and neutrality are not empty concepts, but neither are they self-defining. They are insufficient concepts—insufficient to decide cases without supplemental principles. Let me briefly explain this point, with apologies to those who are familiar with the debate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A claim to equal or neutral treatment is very different from an outright claim of entitlement. If I go to court claiming a constitutional right to a monthly check from the government, the court will laugh at me. It is up to Congress, and not the courts, to create government benefit programs. But if I go to court claiming a constitutional right to a check on the same terms as someone similarly situated, I may have a serious claim. If Congress has given social security benefits to women in my situation but not to men, I will probably win."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.6.15",
      "id": "ft6.15"
    }
  }, [_vm._v("15")])]), _vm._v(" My claim to an equal entitlement to benefits is very different from my claim to an outright entitlement to benefits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nor is it the case that once we have fully specified the entitlement, equality drops out. Westen would say that once we decide that sex is not one of the "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("eligibility criteria, we no longer need equality to decide my case. That is descriptively true, but it is not true until after we have decided. It begs the question of how we decide that sex is not one of the eligibility criteria. The elimination of sex as a criterion will depend in part on our understanding of sexual equality, and not merely on the policy of the social security program.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This separation in theory is greatly reinforced in practice by the constitutional separation of powers. Congress first specifies the eligibility criteria, and has sole responsibility for social security policy. But the Court reviews those criteria to see if they violate its understanding of constitutional rights to equality. This separation of responsibility for policy definition is critical to the debate over Westen, and it has received too little attention. It means that equality claims can never be collapsed into the initial specification of the entitlement. So equality is not an empty concept.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But equality is an insufficient concept. No one claims that all five billion humans must be given precisely equal treatment in all matters. Some inequalities are considered fair and just, like punishing the guilty but not the innocent. Some are considered unfair but lawful, like homelessness in the midst of wealth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Only a few inequalities violate legal rights to equality. Claims about equality, or neutrality, always require further specification: equality with respect to what classification, for what purpose, in what sense, and to what extent? Let me briefly consider these four variables.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First, there is the classification at issue. Those who are similarly situated should be treated equally, but what does it mean to be similarly situated? If Congress grants benefits to 40-year-old women but not to 40-year-old men, my claim will specify equality with respect to sex, and I will probably win.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("But if I specify equality with respect to age—if I claim that 40-year-old men are similar to 65-year-old men—I will surely lose."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.7.16",
      "id": "ft7.16"
    }
  }, [_vm._v("16")]), _vm._v(" Our law embodies a fairly strong and general commitment to sexual equality, but only a weak and narrow commitment to age equality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, there is the purpose of the classification. What it means to be similarly situated depends on why we are asking. If I claim that my employer fired me because of my age, then I have a claim under the age discrimination laws."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.7.17",
      "id": "ft7.17"
    }
  }, [_vm._v("17")])]), _vm._v(" Forty-year-old men are similar to 65-year-old men for purposes of hiring and firing, but not for purposes of social security. Third, there are different "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("senses of equality. Two sharply different meanings are inherent in the concepts of equality and neutrality. These different meanings are familiar from the great national debate over affirmative action."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.8.18",
      "id": "ft8.18"
    }
  }, [_vm._v("18")]), _vm._v(" Americans believe in equal opportunity and equal treatment, but in some contexts, we also believe in equal impact and equal outcomes. This is not an all-or-nothing universal choice; our choices vary with context. Few people would argue that equal impact is never the relevant measure, but we often disagree over when equal impact is the relevant measure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Fourth, there is the extent of the claim. Is it sufficient for government to treat people equally when it imposes penalties and distributes benefits—to treat people equally in all tangible ways? Or do we also require government to be neutral in intangible ways as well—to be neutral in its speech and symbolic conduct? This distinction is critical to debates about religious neutrality. I will call it the difference between equality and neutrality. When I say government should be neutral towards religion, I mean to include the claim that it should not express an opinion about religion. But this is a controversial claim. Nothing in the concepts themselves will tell us whether the Religion Clauses commit government to neutrality in this sense, or only to equal treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The first three variables are also controversial and insufficiently specified. Equality with respect to religion does not even sufficiently specify the classification. Religion may refer to status, to belief, to speech, or to conduct. The principal line of disagreement is different for each of these.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most of our serious disagreements are about religious conduct, and not about religious status or belief. It is therefore religious conduct that is the principal subject of our inquiry into religious neutrality. Americans have very different intuitions about what it means to say that religious conduct is similarly situated to secular conduct, or what it means to treat religious conduct equally.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In religion as elsewhere, the answers sometimes depend on the second variable—the purpose of the classification. Whether we think religious conduct is similarly situated may depend on whether we are talking about direct regulation of conduct, resolution of private disputes, expenditures of government funds, taxation and tax exemption, and so on through the whole range of ways in which religion and government interact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The debate over religious conduct also triggers sharp disagreement over the choice between equal treatment and equal impact. This may be the most fundamental source of disagreement about the meaning of neutrality toward religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Because neutrality requires so much further specification, it cannot be the only principle in the Religion Clauses. Nor can it be the most fundamental. We must specify the content of neutrality by looking to other principles in the Religion Clauses. When we have done that, neutrality should be defined in a way that makes it largely congruent with those other principles. We will often be able to explain the objection to a law by saying either that it restricts the autonomy of religious belief or practice, or that it threatens religious voluntarism, or that it deviates from religious neutrality, and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This variety of explanations is important, and the neutrality explanation should not be omitted. In a nation of immense religious diversity, it is of great symbolic value that government views all manner of religious belief neutrally. That the government aspires to religious neutrality, and that the courts stand ready to hold government to its aspiration, is an important reassurance to religious minorities. We should not abandon or de-emphasize that reassurance. We should not omit neutrality from our set of explanations, even if we also offer other explanations, and even if some readers believe that those other explanations are more fundamental. Neutrality has great explanatory importance.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Neutrality also continues to have operational importance. If neutrality properly understood is largely congruent with other principles of the Religion ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Clauses, then any of these principles can be the warning flag that calls attention to a threat to religious liberty. Sometimes the deviation from neutrality will be the most obvious explanation of the danger, and even the most fundamental.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("For example, I think neutrality is the most straightforward explanation in the equal access controversy. There is no general right to demand that the government make its property available for religious observance: there is not even such a right in narrow and especially appealing circumstances. The lack of such a right is implicit in "), _c('em', [_vm._v("Lyng v. Northwest Indian Cemetery Protective Association")]), _vm._v(","), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.10.19",
      "id": "ft10.19"
    }
  }, [_vm._v("19")]), _vm._v(" where the Court refused to stop the government from building a useless road on land owned by the government but sacred to Native Americans. There is no entitlement to special access to government property for religious exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, if the government makes its property available for meetings of nonreligious private groups, then it must make that property equally available to religious groups."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.10.20",
      "id": "ft10.20"
    }
  }, [_vm._v("20")])]), _vm._v(" This is a classic equality right. The equality or neutrality explanation is the one that best and most directly fits the case. Neutrality is the easiest way to recognize the problem, to decide the case, and to explain the result.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More generally, I doubt that there is any single foundational principle from which all the others can be derived. The Religion Clauses embody several principles, which are largely congruent, but occasionally in tension. The search for solutions is rarely a matter of deciding which principle is more fundamental. The search for solutions is more like an iteration in mathematics. In an iteration, you solve a problem by a series of approximations, each building on the one before, until you have as close an approximation as you need or as close as you can get with reasonable effort. We iterate Religion Clause problems by considering them in light of each of the relevant principles, including neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For all these reasons, I think that neutrality is worth defining. To that end, I will sketch the principal conceptions of neutrality toward religion in the cases and the literature, illustrating the differences with examples.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('strong', [_vm._v("II. Formal Neutrality")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("By far the best-known definition of religious neutrality is Philip Kurland’s. In 1961, he tendered the following principle:")])]), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The [free exercise and establishment] clauses should be read as stating a single precept: that government cannot utilize religion as a standard for action or inaction because these clauses, read together as they should be, prohibit classification in terms of religion either to confer a benefit or to impose a burden."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.21",
      "id": "ft11.21"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This standard of no religious classifications is closely akin to the equal treatment and equal opportunity side of the affirmative action debate. But the shift of context has enough implications so that a different label is required. I will call this standard “formal neutrality.” I will not call it Kurland’s Rule, because I am not sure he intended it in the way it has come to be understood. But I suspect that if you say “neutrality” to most religious liberty scholars, the first thing that they think of is Philip Kurland and a ban on religious classifications.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Formal neutrality sounds highly plausible until you think through its implications. Its simplicity and apparent even-handedness are appealing. It can explain some important cases, including my argument for the constitutionality of the Equal Access Act.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet formal neutrality has been almost universally rejected."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.22",
      "id": "ft11.22"
    }
  }, [_vm._v("22")])]), _vm._v(" No major commentator endorsed it for a generation, and no case has adopted it, although many cases and commentators have applied part of it to particular problems. Now an endorsement has come from a most unlikely source, Professor Mark Tushnet."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.23",
      "id": "ft11.23"
    }
  }, [_vm._v("23")])]), _vm._v(" Hardly anyone else has been willing to apply it universally, because it produces surprising results that are inconsistent with strong intuitions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The most striking example is historical. The National Prohibition Act forbad the sale or consumption of alcoholic beverages in the United States, but it exempted the use of sacramental wine."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.24",
      "id": "ft11.24"
    }
  }, [_vm._v("24")])]), _vm._v(" Under formal neutrality, the "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("exemption was unconstitutional. The exemption undeniably classified on the basis of religion. It was lawful to consume alcohol in religious ceremonies, but not otherwise.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now consider Prohibition without the exemption. There would be no violation of formal neutrality; religion would not even be mentioned in the statute. But it would be a crime to celebrate the Eucharist or the Seder. If the free exercise of religion includes anything beyond bare belief, it must be the right to perform the sacred rituals of the faith. A law enacted largely at the behest of Protestants that barred the sacred rites of Catholics and Jews, a law that changed the way these rites had been performed for millennia, could not be reconciled with any concept of religious liberty worthy of the name. That the law was formally neutral and enacted for a secular purpose would be no comfort to the victims.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("But facial neutrality would be dispositive to the Supreme Court of the United States. In a stunning opinion handed down after this lecture was delivered, the Court said that government may regulate the Mass for good reasons, bad reasons, or no reasons at all, so long as the regulation is facially neutral and does not single out religion."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.12.25",
      "id": "ft12.25"
    }
  }, [_vm._v("25")]), _vm._v(" The Court held that criminal punishment of the central religious ritual of an ancient faith raises no issue under the Free Exercise Clause and requires no governmental justification whatever! The example that I chose because I thought it was beyond reasonable argument has now been decided the other way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prohibition as applied to sacramental wine is the exemplar of a large class of cases, in which the exercise of religion requires exemption from laws of general applicability. Such exemptions are now a matter of legislative grace. The Court did not go all the way to Professor Kurland’s ban on exemptions for religious exercise. Rather, it said that the Constitution is indifferent to such exemptions—that legislatures may grant or refuse exemptions as they choose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will return to the problem of exemptions for religious conduct. For now, I note only that formal neutrality would permit a state to ban the Mass. If it produces such an implausible result in a case at the core of religious exercise, the principle is not off to a good start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Prohibition example, formal neutrality seems to trample religion. But formal neutrality also produces results that many Americans find unacceptably favorable to religion. Consider the case of financial aid to private education. Under formal neutrality, government can give unlimited amounts of "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("unrestricted aid to religious schools, so long as the aid goes to all schools and not to religious schools alone. But formal neutrality does not stop there. Any aid to secular private schools must be given to religious schools, on exactly the same terms. To exclude religious schools from the aid program, or to impose restrictions on religious uses of the money, would be to classify on the basis of religion. That would violate formal neutrality.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I do not think that this implication of formal neutrality is beyond the range of reasonable debate. Indeed, I think it captures an important insight. But I also believe that at least some of its results would be unconstitutional.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Stricter separationists react much more strongly. To many American separationists, the possibility that government could fully fund religious education must seem as preposterous as the banning of the Mass. This implication of formal neutrality is wildly inconsistent with the Supreme Court’s cases and with dominant understandings of the Establishment Clause."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.13.26",
      "id": "ft13.26"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As these two examples make clear, formal neutrality has something to offend everybody. As a general standard, it appeals to none of the competing factions in Religion Clause litigation. But it has had disproportionate influence on our understanding of what it means to be neutral.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.4"
    }
  }, [_c('strong', [_vm._v("III. Substantive Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("My understanding of neutrality is quite different. Again because we need a label, I will call my proposal “substantive neutrality.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My basic formulation of substantive neutrality is this: the Religion Clauses require government to minimize the extent to which it either encourages or discourages religious belief or disbelief, practice or nonpractice, observance or nonobservance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.13.27",
      "id": "ft13.27"
    }
  }, [_vm._v("27")])]), _vm._v(" If I have to stand or fall on a single formulation of neutrality, I will stand or fall on that one. But I must elaborate on what I mean by minimizing encouragement and discouragement. I mean that religion is to "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("be left as wholly to private choice as anything can be. It should proceed as unaffected by government as possible. Government should not interfere with our beliefs about religion either by coercion or by persuasion. Religion may flourish or wither; it may change or stay the same. What happens to religion is up to the people acting severally and voluntarily; it is not up to the people acting collectively through government.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("This elaboration highlights the connections among religious neutrality, religious autonomy, and religious voluntarism."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.14.28",
      "id": "ft14.28"
    }
  }, [_vm._v("28")]), _vm._v(" Government must be neutral so that religious belief and practice can be free. The autonomy of religious belief and disbelief is maximized when government encouragement and discouragement is minimized. The same is true of religious practice and refusal to practice. The goal of maximum religious liberty can help identify the baseline from which to measure encouragement and discouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My conception of religious neutrality includes a neutral conception of religion. That is, any belief about God, the supernatural, or the transcendent, is a religious belief. For constitutional purposes, the belief that there is no God, or no afterlife, is as much a religious belief as the belief that there is a God or an afterlife. It is a belief about the traditional subject matter of religion, and it is a belief that must be accepted on faith, because it is not subject to empirical investigation. Serious believers and serious disbelievers are sometimes troubled by this equation of their belief systems, but we cannot make sense of the Religion Clauses without it. This constitutional conception of religious belief as any belief about religion explains why atheists are protected from persecution,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.14.29",
      "id": "ft14.29"
    }
  }, [_vm._v("29")])]), _vm._v(" and why the government cannot establish atheism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Similarly, the deeply held conscientious objection of a non-theist must be treated equally with a similar objection rooted in a more traditional faith. As a plurality of the Supreme Court put it in a statutory context, the relevant category is “all those whose consciences … would give them no rest or peace” if they were compelled to comply with government policy."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.14.30",
      "id": "ft14.30"
    }
  }, [_vm._v("30")])]), _vm._v(" To be sure, there are difficulties in applying that standard to non-traditional sources of conscience. But in a nation with millions of non-believers, no other conception of conscientious objection is even plausibly neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("That is a bare sketch of substantive neutrality. The next step is to compare and contrast formal and substantive neutrality. Sometimes the two types of neutrality produce the same result. That is, sometimes we can minimize encouragement or discouragement to religion by ignoring the religious aspects of some behavior and treating it just like some analogous secular behavior.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But often the two understandings of neutrality diverge. Government routinely encourages and discourages all sorts of private behavior. Under substantive neutrality, these encouragements and discouragements are not to be applied to religion. Thus, a standard of minimizing both encouragement and discouragement will often require that religion be singled out for special treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider two of the examples I have mentioned so far. To prohibit the consumption of alcohol, without an exception for religious rituals, is to flatly prohibit important religious practices. Such a prohibition would discourage religious practice in the most coercive possible way—by criminalizing it. Many believers would abandon their religious practice; some would defy the law; some of those would go to jail. Such a law would be a massive departure from substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To "), _c('em', [_vm._v("exempt")]), _vm._v(" sacramental wine is not perfectly neutral either. Religious observers would get to do something that is forbidden to the rest of the population, but that observation goes to formal neutrality. Would this special treatment encourage religion? It is conceivable that the prospect of a tiny nip would encourage some desperate folks to join a church that uses real wine, or to attend Mass daily instead of weekly or only at Easter. It is conceivable, but only to a law professor or an economist. Such an exemption would have only an infinitesimal tendency to encourage religious activity. In contrast, withholding the exemption would severely discourage religious activity. The course that most nearly approaches substantive neutrality—the course that minimizes both encouragement and discouragement—is to single out religious uses for an exemption. In this and similar applications, substantive neutrality is akin to the equal impact, equal outcome side of the affirmative action debate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prohibition is an easy case under formal neutrality, and an easy case under substantive neutrality. The difference is that substantive neutrality gets the right answer. Formal neutrality, as applied to Prohibition, would lead directly to religious persecution.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Sometimes the two concepts of neutrality seem to converge. In the equal access controversy, I argued that substantive neutrality was best achieved by something close to formal neutrality—that student religious groups should ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("be treated like any other student extracurricular group."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.16.31",
      "id": "ft16.31"
    }
  }, [_vm._v("31")]), _vm._v(" To give them special privileges would encourage religion; to exclude them would discourage religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But even in that example, some deviations from formal neutrality were required. Most student extracurricular groups have a faculty sponsor, but it is widely agreed that a student religious group should not have a faculty sponsor."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.16.32",
      "id": "ft16.32"
    }
  }, [_vm._v("32")])]), _vm._v(" To say that the school will sponsor any student group except a religious group is to classify on the basis of religion. Withholding the faculty sponsor violates formal neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The school prayer cases"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.16.33",
      "id": "ft16.33"
    }
  }, [_vm._v("33")])]), _vm._v(" are the most obvious source of our intuition that public schools should not provide faculty sponsors to student religious groups. But substantive neutrality can explain that intuition. School sponsorship of a religious group commits the government to the success of a religious group, thus encouraging religion and violating substantive neutrality. Moreover, the faculty sponsor will inevitably influence the group’s conduct, thus encouraging some forms of religious practice and discouraging others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is true that religious groups are in some sense discouraged by being forced to organize and function without the school sponsorship available to all other student groups. But withholding the sponsor does not actively harm religious groups; it does not reduce or divert their own resources, or create obstacles for them to overcome. It merely withholds an intrusive benefit that is widely available to other groups that are in some ways analogous. The hoped-for benefit may turn out to be seriously harmful if the government sponsor changes the course of the religious organization. Withholding this risky benefit is not perfectly neutral, but the deviation from neutrality is considerably smaller than the deviations inherent in sponsorship. Thus, the closest the schools can come to substantive neutrality is to leave such groups alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prohibition and equal access are simple examples. I have not yet gotten to the hard cases, like public aid to religious schools. But even these simple cases illustrate some important points about substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Most obviously, substantive neutrality is harder to apply than formal neutrality. It requires judgments about the relative significance of various encouragements and discouragements to religion. Absolute zero is no more attainable in encouragement and discouragement than in temperature. We can aspire only to minimize encouragement and discouragement. Because substantive neutrality requires more judgment than formal neutrality, substantive neutrality is more subject to manipulation by advocates and result-oriented judges and law professors.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More important, substantive neutrality requires a baseline from which to measure encouragement and discouragement. What state of affairs is the background norm from which to judge whether religion has been encouraged or discouraged? This question also requires judgment; there is no simple test that can be mechanically applied to yield sensible answers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A conceivable mechanical standard is to treat religion as though government did not exist. If religion is better off than if government did not exist, it has been encouraged; if it is worse off, it has been discouraged. The only thing to recommend this standard is its intellectual purity; I doubt that it appeals to anyone in the real world.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("To take the most obvious example, no one suggests that churches be denied police and fire protection. Police and fire protection are sometimes explained as merely incidental benefits."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.17.34",
      "id": "ft17.34"
    }
  }, [_vm._v("34")]), _vm._v(" But to what are they incidental? I am not at all sure that police and fire protection arise as an incident of something else. These services are not incidental; they are provided outright and for their own sake. One might say that police and fire protection for churches is incidental to police and fire protection for everybody else, or for all property in the community. But it is easy to imagine either isolated or concentrated religious properties that would strain that rationale to the breaking point. That rationale also fails to explain why we protect churches against vandalism, embezzlement, and other property crimes that pose no threat to the neighbors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the Supreme Court’s better opinions on incidental benefits answers the question I have posed. A permissible benefit is one that is incidental to a larger policy of neutrality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.17.35",
      "id": "ft17.35"
    }
  }, [_vm._v("35")])]), _vm._v(" The benefits of police and fire protection are such an incident of neutrality. Police and fire protection are such a universal part of our lives that they have become part of the baseline. To deny police and fire protection would be to outlaw religion in the original sense of that word—to put religion outside the protection of the law. To demand that "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("churches provide their own police and fire protection in a modern society would be to place an extraordinary obstacle in their way—a discouragement that would make religion a hazardous enterprise indeed. To provide such services does not make religion attractive to anyone who is not attracted on the merits. As a practical matter, any encouragement is tiny. The discouraging effect of cutting off basic services greatly exceeds the encouraging effect of providing them.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Similar judgments about the baseline level of government activity are at the heart of the equal access controversy. To deny religious groups a faculty sponsor is neutral in the sense of leaving such groups where they would be if government did not exist. But if government did not exist, there would be no public schools and no classrooms in which groups could meet. The opponents of equal access argued that use of the classroom was a benefit—an encouragement in the terms I have been using—that violated the Establishment Clause."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.36",
      "id": "ft18.36"
    }
  }, [_vm._v("36")]), _vm._v(" The supporters of equal access argued that once classrooms were made available to other extracurricular groups, the use of the room was part of the baseline—a background norm that both religious and secular groups could take for granted."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.37",
      "id": "ft18.37"
    }
  }, [_vm._v("37")])]), _vm._v(" Most of the opponents seemed to concede that religious groups could use the streets and parks on an equal basis."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.38",
      "id": "ft18.38"
    }
  }, [_vm._v("38")])]), _vm._v(" Streets and parks are in the baseline by common consent; faculty sponsors are not in the baseline; classrooms are controversial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The proper background norm about public facilities is related to the background norm about student behavior. If the norm is that students can generally do what they want on their own time, subject only to restraints on harmful or disruptive behavior, then banning religious groups is discouragement. But if the norm is that high school students can do nothing without school sponsorship, then allowing meetings looks like sponsorship, and even endorsement, and excluding them from campus can be characterized as the neutral course of simply declining to sponsor them. Opponents of equal access have seriously made this argument."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.39",
      "id": "ft18.39"
    }
  }, [_vm._v("39")])]), _vm._v(" Supporters of equal access have looked to basic First Amendment principles, and to student free speech cases not involving religion—to cases involving war protest and underground newspapers. They argued that the relevant "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("constitutional norm was that unsponsored students could say what they wanted on school premises."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.40",
      "id": "ft19.40"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unless we carefully think through such issues, we will tend to select our baselines by intuition, and we will give free rein to our political preferences and our prejudices. Our preferences can operate freely because the principle of neutrality by itself is insufficient to define the baseline. Judgments about the state of the world must be brought to bear. Equally important, the other principles of the Religion Clauses must be brought to bear. We must keep in mind what neutrality is supposed to accomplish. Our goal is not to leave religion in a Hobbesian state of nature, nor to leave it regulated exactly to the extent that commercial businesses are regulated, with no extra burdens and no exemptions. Our goal is to maximize the religious liberty of both believers and nonbelievers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will return to the difficult problems of justifying and implementing substantive neutrality. But first, I want to briefly introduce a third way in which neutrality has been invoked.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.5"
    }
  }, [_c('strong', [_vm._v("IV. Disaggregated Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Supreme Court is rarely content with a broad principle if it can substitute a three-part test."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.41",
      "id": "ft19.41"
    }
  }, [_vm._v("41")])]), _vm._v(" Its most famous formulation of the neutrality requirement is the second part of the "), _c('em', [_vm._v("Lemon")]), _vm._v(" test, which says that a law violates the Establishment Clause if one of its substantial effects is either to advance or inhibit religion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.42",
      "id": "ft19.42"
    }
  }, [_vm._v("42")])]), _vm._v(" This formulation began simply as an elaboration of neutrality,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.43",
      "id": "ft19.43"
    }
  }, [_vm._v("43")])]), _vm._v(" but is often disaggregated into a test of no advancement and a separate test of no inhibition. If a law has some substantial effect that advances religion, that may be the end of the case. And there is sometimes a very low threshold for finding effects to be substantial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the extreme case of "), _c('em', [_vm._v("Aguilar v. Felton")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.44",
      "id": "ft19.44"
    }
  }, [_vm._v("44")])]), _vm._v(" the Supreme Court invalidated a federal program to provide remedial instruction in math and reading to low income children in private schools. Congress enacted this program in "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("pursuit of neutrality—to provide the same remedial program to disadvantaged children without regard to their religious choices. Why did the Court strike it down? Because the public employees who provided the remedial instruction might be influenced by the religious environment of parochial schools, and under that hypnotic influence, might encourage the children to religious belief."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.45",
      "id": "ft20.45"
    }
  }, [_vm._v("45")]), _vm._v(" That possibility created a risk of a substantial effect of advancing religion; that risk could be avoided only by close supervision that would excessively entangle church and state."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.46",
      "id": "ft20.46"
    }
  }, [_vm._v("46")])]), _vm._v(" That was the end of the case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I call this disaggregated neutrality, because it looks only at one side of the balance of advancing or inhibiting. Because absolute zero is not achievable, it is always possible to find some effect of advancing or inhibiting religion. Thus, if you look only at one side of the balance, you can always find a constitutional violation. Some of those who would have government sponsor their faith play the same game on the inhibits side of the balance: if government does not lead school children in prayer, or display religious symbols on major holidays, the public may infer that government is hostile to religion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.47",
      "id": "ft20.47"
    }
  }, [_vm._v("47")])]), _vm._v(" Therefore, these critics conclude, silence is not neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Substantive neutrality always requires that the encouragement of one policy be compared to the discouragement of alternative policies. The principal effect of "), _c('em', [_vm._v("Aguilar")]), _vm._v(" was to greatly increase the cost of providing remedial programs to children in private schools."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.48",
      "id": "ft20.48"
    }
  }, [_vm._v("48")])]), _vm._v(" After "), _c('em', [_vm._v("Aguilar")]), _vm._v(", the government or the school must provide separate off-campus facilities and the children must travel to those facilities and back again. The effect of increasing the cost was to reduce the number of children who could be served. So thousands of our least advantaged citizens are now forced to choose: forfeit their right to remedial instruction in math and reading, or forfeit their right to education in a religious environment. That effect discourages religion, and dwarfs the risk that the government’s remedial math or reading teacher might suddenly start "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("proselytizing. By disaggregating neutrality, the Court has lost sight of its original objective.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another way to disaggregate neutrality is to shift back and forth among different versions of neutrality without explanation. If you think that neutrality with respect to government-imposed burdens means that churches and believers never get an exemption (formal neutrality), but that neutrality with respect to government benefits means that churches can never participate (disaggregated substantive neutrality), you had better have a good explanation. The most obvious explanation is simply hostility to religion. If you have the opposite preferences, you are equally in need of a good explanation.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Voting patterns in the Supreme Court are often disaggregated, sometimes in suspicious ways. Justice Brennan applied formal neutrality to strike down a legislative tax exemption in "), _c('em', [_vm._v("Texas Monthly, Inc.")]), _vm._v(","), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.49",
      "id": "ft21.49"
    }
  }, [_vm._v("49")]), _vm._v(" and he applied disaggregated neutrality to strike down the remedial education program in "), _c('em', [_vm._v("Aguilar.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.50",
      "id": "ft21.50"
    }
  }, [_vm._v("50")])]), _vm._v(" But he believes the Constitution "), _c('em', [_vm._v("requires")]), _vm._v(" exemptions from laws that violate religious conscience, a position consistent with substantive neutrality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.51",
      "id": "ft21.51"
    }
  }, [_vm._v("51")])]), _vm._v(" Justice Rehnquist takes the opposite position on all three of these issues."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.52",
      "id": "ft21.52"
    }
  }, [_vm._v("52")])]), _vm._v(" Justice Stevens agrees with Brennan on tax exemptions"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.53",
      "id": "ft21.53"
    }
  }, [_vm._v("53")])]), _vm._v(" and aid to religious schools,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.54",
      "id": "ft21.54"
    }
  }, [_vm._v("54")])]), _vm._v(" but with Rehnquist on exemptions for conscience."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.55",
      "id": "ft21.55"
    }
  }, [_vm._v("55")])]), _vm._v(" Stevens votes against traditional religions on all three issues, an odd interpretation of religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Term since this lecture was delivered, the Court has dramatically embraced formal neutrality to uphold taxation and regulation of churches and believers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.56",
      "id": "ft21.56"
    }
  }, [_vm._v("56")])]), _vm._v(" In "), _c('em', [_vm._v("Jimmy Swaggart Ministries")]), _vm._v(", the Court unanimously held that churches can be taxed, so long as the tax laws do not single out churches for discriminatory rates or incidents of taxation. The Court in dictum suggested that it would apply the same standard to regulation of churches, except "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("where compliance with the regulation would require the church to violate its “sincere religious beliefs.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.57",
      "id": "ft22.57"
    }
  }, [_vm._v("57")]), _vm._v(" In "), _c('em', [_vm._v("Employment Division v. Smith")]), _vm._v(", the exception for sincere religious belief disappeared by a vote of five to four."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.58",
      "id": "ft22.58"
    }
  }, [_vm._v("58")])]), _vm._v(" The free exercise of religion now means that churches cannot be taxed or regulated any more heavily than General Motors. The only remaining protection is that provided by formal neutrality; religious conduct cannot be singled out for facially discriminatory regulation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court recognized that these holdings burdened the exercise of religion. The "), _c('em', [_vm._v("Smith")]), _vm._v(" opinion acknowledged that the conduct at issue was “the ‘exercise of religion,’ ”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.59",
      "id": "ft22.59"
    }
  }, [_vm._v("59")])]), _vm._v(" and that Oregon had subjected this conduct to “an across-the-board criminal prohibition,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.60",
      "id": "ft22.60"
    }
  }, [_vm._v("60")])]), _vm._v(" but it insisted that this prohibition of an exercise of religion did not mean that Oregon was “prohibiting the free exercise of religion.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.61",
      "id": "ft22.61"
    }
  }, [_vm._v("61")])]), _vm._v(" In "), _c('em', [_vm._v("Swaggart")]), _vm._v(", the Court said that the economic burden of paying the tax, and “substantial administrative burdens” of collecting the tax or complying with other regulations, were “not constitutionally significant.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.62",
      "id": "ft22.62"
    }
  }, [_vm._v("62")])]), _vm._v(" The Court found it “undeniable that a generally applicable tax has a secular purpose and neither advances nor inhibits religion, for the very essence of such a tax is that it is neutral and nondiscriminatory on questions of religious belief.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.63",
      "id": "ft22.63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This conception of neutrality is irreconcilable with "), _c('em', [_vm._v("Aguilar")]), _vm._v(" and the other cases striking down government payments to religiously affiliated schools. In "), _c('em', [_vm._v("Aguilar")]), _vm._v(", the federally-funded instruction in remedial math and reading was directed on equal terms to poor children in all schools, public and private, secular and religious. But the Court did not say that this “neutral and nondiscriminatory” instruction “neither advances nor inhibits religion.” Instead, it found that the government money conferred obvious benefits on religion, and did not say that those benefits were of no constitutional significance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court’s current position comes to this: when government demands money or obedience "), _c('em', [_vm._v("from")]), _vm._v(" churches, neutrality consists of treating churches just like other subjects of taxation or regulation, and it is irrelevant that the church is worse off than it would be without the tax or the regulation. But when government pays money "), _c('em', [_vm._v("to")]), _vm._v(" churches, neutrality consists of not making the churches any better off than they would be without the payment, and it is "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("irrelevant that the churches are treated just like other beneficiaries of the same program.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever explains these results, it is not a consistent understanding of neutrality. I suspect that the Justices are not deciding on the basis of neutrality at all, although they invoke it in their opinions. If they are deciding on the basis of neutrality, they have not defined it in any consistent way. But the inconsistency of the current rules may be only a transitional step on the way to widespread application of formal neutrality as the rule of judicial decision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The current rules may result from a temporary voting paradox. Justices Brennan, Marshall, and Blackmun would restrict both regulation of religion and government support of religion. Justices Rehnquist, White, Scalia, and Kennedy would generally permit both regulation and support of religion. Justice O’Connor is a swing vote on both regulation and support. For all eight of these Justices, their votes in Religion Clause cases are best explained by their general attitudes toward judicial enforcement of constitutional rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Justice Stevens is the exception. He votes with the judicial activists on most issues, including the Establishment Clause, but he joins the judicial minimalists in free exercise cases. The apparent explanation for his voting pattern is hostility to religion. Religion in his view is subject to all the burdens of government, but entitled to few of the benefits. And because the Court has been closely divided between activist and minimalist judges, he has been a swing vote on religion issues. His hostility to religion is reflected in the Court’s rules, even though he has but one vote.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Aguilar")]), _vm._v(", the decision striking down federally-funded remedial instruction in religious schools, was a five-four decision in 1985. Justices Scalia and Kennedy have replaced Burger and Powell, and it is a reasonable guess that if it came up today, "), _c('em', [_vm._v("Aguilar")]), _vm._v(" would be five-four the other way. We may soon see a formal neutrality opinion upholding government aid to religious education.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("That hypothetical development would greatly reduce the inconsistencies in the Court’s opinions. But it would not be a triumph for neutrality. Legislatures would be free to practice disaggregated formal neutrality. They could support religion or burden it, support some religions and burden others, as long as they stated their rules in facially neutral terms. The Court in "), _c('em', [_vm._v("Smith")]), _vm._v(" acknowledged somewhat euphemistically that its decision “will place at a relative disadvantage those religious practices that are not widely engaged in.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.23.64",
      "id": "ft23.64"
    }
  }, [_vm._v("64")]), _vm._v(" In plain English, this means that churches without political clout may be suppressed, that more powerful churches may be accommodated, "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("and if the principle is extended to the financial aid cases, they may be supported. If the Court’s decisions are eventually reconciled in this way, the explanatory principle will not be neutrality, but statism. The majority will be permitted to do anything it can achieve by facially neutral rules, however gerrymandered, and the Court will have largely abdicated its role of protecting religious minorities.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.6"
    }
  }, [_c('strong', [_vm._v("V. Applying Substantive Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Formal and substantive neutrality are broad categories. But as I noted earlier, religious liberty controversies present a succession of specific problems. It is necessary to search out the most neutral course with respect to each problem. That process will at least clarify our disagreements, and it might provide some basis for principled argument to legislatures and state courts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Recall my distinction between equality and neutrality: equality refers only to tangible penalties and rewards; neutrality also includes expression of government opinion. It seems to me that we have widespread consensus on both equality and neutrality with respect to religious status, consensus on equality but not on neutrality with respect to religious belief, consensus except for a few exceptional cases with respect to religious speech, and no consensus at all with respect to religious conduct.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("That is a glib set of categories; what do I mean by them? First, consensus with respect to status: almost no one any longer openly claims that nonbelievers, or non-Christians, or non-Protestants, should be discriminated against because of their religious affiliation. There are occasional exceptions, such as the recent attacks on Father Healy’s appointment to head the New York Public Library."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.24.65",
      "id": "ft24.65"
    }
  }, [_vm._v("65")]), _vm._v(" But these attacks are nearly always disguised with "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("pretextual justifications. Moreover, hardly anyone thinks it a proper function of government to denounce the adherents of some religious faiths and laud the adherents of others.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Second, partial consensus with respect to religious belief: we have consensus on equality; no one argues that government should actively penalize some religious beliefs and reward others. But we do not have consensus on neutrality. A vocal minority of lawyers and scholars,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.66",
      "id": "ft25.66"
    }
  }, [_vm._v("66")]), _vm._v(" and perhaps a majority of the public,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.67",
      "id": "ft25.67"
    }
  }, [_vm._v("67")])]), _vm._v(" believe that government may endorse a preferred religious belief. Some urge generic theism, some the Judeo-Christian tradition, some Christianity. Whatever their preferred teaching, these people reject the Supreme Court’s holdings that government should be neutral with respect to religious belief. And of course, the Supreme Court itself does not seem to take those holdings very seriously."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.68",
      "id": "ft25.68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, partial consensus with respect to religious speech: religious speech and political speech are the two core cases of highly protected speech, and they should be treated equally. A long line of Supreme Court cases are consistent with that proposition,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.69",
      "id": "ft25.69"
    }
  }, [_vm._v("69")])]), _vm._v(" and I think there is widespread agreement with those results, although not necessarily with my formulation of the principle. Religious speech in and around public schools is an exceptional case where consensus breaks down. Consensus also breaks down when money is involved, as in the "), _c('em', [_vm._v("Texas Monthly")]), _vm._v(" case, in the campaign finance and disclosure laws,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.70",
      "id": "ft25.70"
    }
  }, [_vm._v("70")])]), _vm._v(" and in the restrictions on political speech in the "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Internal Revenue Code."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.71",
      "id": "ft26.71"
    }
  }, [_vm._v("71")]), _vm._v(" My principle that religious and political speech should be treated equally could have explained the "), _c('em', [_vm._v("Texas Monthly")]), _vm._v(" case, and my principle had some relation to the discordant and troublesome combination of opinions that made up the majority. The more recent decision in "), _c('em', [_vm._v("Jimmy Swaggart Ministries")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.72",
      "id": "ft26.72"
    }
  }, [_vm._v("72")])]), _vm._v(" makes it harder to sustain benign readings of "), _c('em', [_vm._v("Texas Monthly.")]), _vm._v(" But it remains open to the Court to uphold a tax exemption that includes religious speech in some broader category, such as not-for-profit speech, or religious, anti-religious, and political speech. The relationship between constitutional protections for religious and political speech is now before the Court in the quite different context of judgments against churches for such speech torts as defamation and intentional infliction of emotional distress."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.73",
      "id": "ft26.73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, dissensus with respect to religious conduct. What does it mean to be neutral with respect to conscientious objection to government policy, or religious education, or religious charities, or the management of religious institutions? I am not sure we have consensus that either equality or neutrality is required with respect to religious conduct; we certainly have no consensus on what that means.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Allow me to consider just one of these examples, exemption from facially neutral laws that forbid religious conduct or require people to violate deeply held conscientious beliefs. The Supreme Court repeatedly announced the constitutional right to such exemptions, but enforced it half-heartedly."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.74",
      "id": "ft26.74"
    }
  }, [_vm._v("74")])]), _vm._v(" The "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Reagan Administration quietly hammered at that right for eight years."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.75",
      "id": "ft27.75"
    }
  }, [_vm._v("75")]), _vm._v(" Now the Court has wholly repudiated the right."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.76",
      "id": "ft27.76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scholars are also attacking the right to exemption, often in the name of neutrality. Two major scholars have recently offered all-out attacks on the constitutional right to such exemptions. One is Ellis West, a political scientist at the University of Richmond;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.77",
      "id": "ft27.77"
    }
  }, [_vm._v("77")])]), _vm._v(" the other is William Marshall, a lawyer at Case Western Reserve."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.78",
      "id": "ft27.78"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Neither the scholars or the Court goes as far as requiring formal neutrality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.79",
      "id": "ft27.79"
    }
  }, [_vm._v("79")])]), _vm._v(" Neither claims that exemptions for religion are unconstitutional when the legislature voluntarily grants them. Both rely on the formal conception of neutrality, but both draw back from its full implications, or at least from the claim that it is constitutionally required.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They do not appear to flinch from the full implications of their claim that the Constitution requires no exemptions for religious exercise. I assume that they would permit a state to enact Prohibition without an exception for the Mass or the Seder. The Court says as much in its opinion,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.80",
      "id": "ft27.80"
    }
  }, [_vm._v("80")])]), _vm._v(" and Professor West said as much in response to a question."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.81",
      "id": "ft27.81"
    }
  }, [_vm._v("81")])]), _vm._v(" He also said that if a law forbidding ethnic and religious discrimination in employment had no exception "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("for rabbis, then a synagogue might have to hire a Baptist rabbi. He defended himself on the ground that no state would pass such a law, and that probably the Baptist would be unqualified on some other ground."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.82",
      "id": "ft28.82"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The hope that no state would pass such a law is insufficient protection for religious minorities. It is true that Americans are more tolerant than many other populations, in part because of the teachings of the Religion Clauses. Many religious minorities have assimilated into the general culture and into the political process, and the legislature is unlikely to knowingly victimize these minorities in ways that go to the heart of their faith. That is why Jews and Catholics were protected by an exception to Prohibition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But the precondition of assimilation and respectability is why Oregon has failed to protect Native Americans’ ritual use of peyote."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.83",
      "id": "ft28.83"
    }
  }, [_vm._v("83")])]), _vm._v(" This social precondition is why in the nineteenth century we denied Mormons the right to vote,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.84",
      "id": "ft28.84"
    }
  }, [_vm._v("84")])]), _vm._v(" imprisoned some of their leaders,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.85",
      "id": "ft28.85"
    }
  }, [_vm._v("85")])]), _vm._v(" confiscated all the property of their church,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.86",
      "id": "ft28.86"
    }
  }, [_vm._v("86")])]), _vm._v(" and dissolved its legal existence,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.87",
      "id": "ft28.87"
    }
  }, [_vm._v("87")])]), _vm._v(" until the church changed its practice, its teaching, and its belief on plural marriage."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.88",
      "id": "ft28.88"
    }
  }, [_vm._v("88")])]), _vm._v(" This social precondition is why multi-million-dollar tort judgments threaten the very existence of the Hare Krishnas, the Scientologists, and other so-called “cults.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.89",
      "id": "ft28.89"
    }
  }, [_vm._v("89")])]), _vm._v(" I am not much comforted by the prospect that only small and unfamiliar religions will be persecuted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nor am I willing to assume that larger religious minorities are always safe. The Church of Christ is hardly a fringe group in Collinsville, Oklahoma, but it too is threatened with destruction from a huge tort judgment for intangible "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("harm to a disgruntled former member."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.90",
      "id": "ft29.90"
    }
  }, [_vm._v("90")]), _vm._v(" In this decade, the military attempted to eliminate Jewish officers who wore their yarmulke while in uniform. In what appeared to be a fit of unthinking deference, the Supreme Court upheld that practice."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.91",
      "id": "ft29.91"
    }
  }, [_vm._v("91")])]), _vm._v(" Congress intervened with protective legislation,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.92",
      "id": "ft29.92"
    }
  }, [_vm._v("92")])]), _vm._v(" but much harm had been done in the meantime. In retrospect, the Court’s refusal to protect yarmulkes was a precursor to its refusal in "), _c('em', [_vm._v("Smith")]), _vm._v(" to protect any religious conduct at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In times of political excitement, of xenophobia, of outbursts of anti-Catholic or anti-Semitic feeling, almost any kind of law is possible, especially at the state and local level. The question is not merely what the federal government might do in such times, although that is scary enough. It was Congress that persecuted the Mormons, and the federal executive that tried to purge observant Jewish military officers. But we must also consider what state and local jurisdictions with religiously homogeneous populations might do to small and unfamiliar minorities. The point is not that such populations are any less enlightened than other Americans, but simply that the forces of pluralism are more attenuated in homogenous communities. What might Utah, or Arkansas, or Yalobusha County do in times of excitement? We have a bill of rights to be enforced by an independent judiciary in part to get us through such times with minimal damage. To claim that the worst horror stories are unlikely to happen is to miss the point of a bill of rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I start with overt hostility because it would be a mistake to assume it away. But hostility is not the only source of law forbidding people to practice their religions, and probably not even the most important. The practice of a small faith may be forbidden just because the legislature did not know about it and never considered its needs. Then the bureaucracy will grind forward, enforcing the rule without regard to exceptional circumstance. This may be what happened to Frances Quaring, who thought the picture on her driver’s license was a graven image forbidden by the second commandment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.93",
      "id": "ft29.93"
    }
  }, [_vm._v("93")])]), _vm._v(" The Frances Quarings of the world may or may not be organized enough to get the attention of the legislature, but a court is required to listen to their complaint and to rule one way or the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course, inadvertence can interact with hostility, or with an insensitivity that borders on hostility. Consider what might happen when Frances "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Quaring writes her legislator. She may get a sympathetic response and a legislated exemption. But her legislator may find it so impossible to empathize with her belief that he never seriously considers whether an exemption would be workable. Even if he empathizes, the legislative calendar is crowded, and the original statute having been enacted, all the burdens of legislative inertia now work against an exemption.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("For a variety of reasons, therefore, we cannot always rely on legislatures to protect minority religious conduct. Courts are not always better, but they give religious liberty claims a second chance to be heard."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.30.94",
      "id": "ft30.94"
    }
  }, [_vm._v("94")]), _vm._v(" If we take seriously the constitutional right to freely exercise religion, we must restore a judicially enforceable right to religious exemption in appropriate cases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The right to exemptions for religious conduct is more easily explained in terms of religious liberty than in terms of neutrality. But the right is consistent with substantive neutrality, and it can be explained in those terms as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As I have already noted with respect to Prohibition, a law that penalizes religious conduct discourages religion. The discouragement is often severe, as when the penalty is criminal punishment or Frances Quaring’s loss of the right to drive. But in many of the cases, an exemption for conscientious objectors has only a de minimis tendency to encourage any aspect of religion. The exemption is substantively neutral; the lack of an exemption is not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another way to state this is that equal impact comes closer to the proper sense of neutrality with respect to conscientious objection. People with a deeply held conscientious objection to a law are not similarly situated to people without such an objection. To insist on formally equal treatment of objectors and non-objectors is to pursue the same majestic equality that forbids the rich and the poor alike to sleep under bridges."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.30.95",
      "id": "ft30.95"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Substantive equality and equal impact are not wholly equivalent. The difference between them appears in cases where religious belief coincides too closely with self-interest, as in conscientious objection to military service or payment of taxes. The distorting effects of self-interest do not make sincere conscientious objectors similarly situated with non-objectors; denying the exemption still has severe and unequal impact on objectors. The equal impact sense of neutrality would focus on the objectors and presumptively "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("grant the exemption, subject only to the government’s proof of a compelling reason to deny it.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("But substantive neutrality as I have defined it must also consider the non-objectors. If we grant exemptions from military service or general taxation, on the basis of conscientious objection, we will inevitably encourage religion. I do not refer to the people willing to feign religious belief in order to claim an exemption. There may be millions of these people, and the difficulty of adjudicating their false claims is relevant to the government’s claim of compelling interest,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.31.96",
      "id": "ft31.96"
    }
  }, [_vm._v("96")]), _vm._v(" but these false claimants are only incidentally relevant to neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I refer instead to the people who honestly persuade themselves that they have come to hold the religious belief that entitles them to the exemption, or who feel pressured to adopt that belief. Human nature being what it is, there may be millions of these people as well. The lure of exemption creates cognitive dissonance between the individual’s desire for the exemption and the belief that makes him ineligible for it. The psychological effort to reduce this dissonance can move his actual belief into conformity with the belief that serves his self-interest."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.31.97",
      "id": "ft31.97"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The problem for religious neutrality is that denying the exemption discourages religious belief in one set of people, and granting the exemption encourages religious belief in another, overlapping, set of people. It is no longer clear that exemption is the more nearly neutral course. If we suspect that the original number of conscientious objectors is small, and that the number of non-objectors seriously tempted by the exemption is large, then denying the exemption appears to be more nearly neutral than granting it. If we have no plausible estimate of which effect is larger, then there may be no basis in substantive neutrality for the courts to second-guess the legislature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever we do in these difficult cases, the deviation from neutrality is large. Either we will deny the exemption, with severe and unequal impact on the original objectors, devastating to their religious liberty, or we will grant the exemption, and greatly encourage religious belief in the objectors induced by the exemption. The case is hard, and the most nearly neutral course will not be very neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Legislatures can sometimes solve these problems by imposing an alternative burden, designed to accommodate conscience while reducing the self-interested "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("reasons for claiming the exemption. That is part of the logic of the alternative service requirement for objectors to military service,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.32.98",
      "id": "ft32.98"
    }
  }, [_vm._v("98")]), _vm._v(" and of the requirement that workers who object to union dues make an equivalent contribution to a charity other than their church."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.32.99",
      "id": "ft32.99"
    }
  }, [_vm._v("99")])]), _vm._v(" These legislative solutions are not perfect—thousands of Jehovah’s Witnesses spent World War II in prison because they objected even to alternative service"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.32.100",
      "id": "ft32.100"
    }
  }, [_vm._v("100")])]), _vm._v("—but they permit a closer approximation to substantive neutrality. They come from thoughtful legislatures; it is harder to see how courts could create them.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.7"
    }
  }, [_c('strong', [_vm._v("VI. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I hope I have at least persuaded you that the meaning of neutrality is not self-evident, and that substantive neutrality is a possible alternative to formal neutrality. Beyond that, I hope I have persuaded you that substantive neutrality is more consistent with religious liberty than is formal neutrality. I have much more work to do to show that a neutral baseline can usually be identified in a principled way across the whole range of interactions between religion and government. But I hope I have persuaded you that the work is worth doing. For that is the path toward maximum religious liberty, neutrally distributed among all kinds of believers and non-believers. And that multifarious formulation is as close as I can come to a single principle that summarizes the Religion Clauses.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.1",
      "id": "fn.4.1"
    }
  }, [_vm._v("1")]), _vm._v(". County of Allegheny v. American Civil Liberties Union Greater Pittsburgh Chapter, 492 U.S. 573, 589–94 (1989). Earlier cases are collected in Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")]), _vm._v(", 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 2 n.6 (1986). Commentators are collected in Steven D. Smith, "), _c('em', [_vm._v("Symbols, Perceptions, and Doctrinal Illusions: Establishment Neutrality and the “No Endorsement” Test")]), _vm._v(", 86 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 266, 314 n.183 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.2",
      "id": "fn.4.2"
    }
  }, [_vm._v("2")]), _vm._v(". For a clear statement of this position, "), _c('em', [_vm._v("see")]), _vm._v(" Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 313–32. "), _c('em', [_vm._v("Cf.")]), _vm._v(" John T. Valauri, "), _c('em', [_vm._v("The Concept of Neutrality in Establishment Clause Doctrine")]), _vm._v(", 48 U. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITT")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 83 (1986). Valauri would keep the concept of neutrality because its appeal is “compelling,” but would restrict the Supreme Court’s power to enforce it because it is “multiply and irresolvably ambiguous.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 149, 151.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.3",
      "id": "fn.4.3"
    }
  }, [_vm._v("3")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLER")]), _vm._v(" & R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONALD")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOWERS")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWARD")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENEVOLENT")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EUTRALITY")]), _vm._v(": C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPREME")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURT")]), _vm._v(" (3d ed. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.4",
      "id": "fn.4.4"
    }
  }, [_vm._v("4")]), _vm._v(". Ruti Teitel, "), _c('em', [_vm._v("When Separate Is Equal: Why Organized Religious Exercises, Unlike Chess, Do Not Belong in the Public Schools")]), _vm._v(", 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 174 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.5",
      "id": "fn.4.5"
    }
  }, [_vm._v("5")]), _vm._v(". 489 U.S. 1 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.6",
      "id": "fn.4.6"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 13 (Brennan, J.) (plurality opinion); "), _c('em', [_vm._v("id.")]), _vm._v(" at 40 (Scalia, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.7",
      "id": "fn.5.7"
    }
  }, [_vm._v("7")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.8",
      "id": "fn.5.8"
    }
  }, [_vm._v("8")]), _vm._v(". 20 U.S.C. §§ 4071–4074 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.9",
      "id": "fn.5.9"
    }
  }, [_vm._v("9")]), _vm._v(". Board of Educ. v. Mergens, 496 U.S. 226 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.10",
      "id": "fn.5.10"
    }
  }, [_vm._v("10")]), _vm._v(". Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.5"
    }
  }, [_vm._v("note 4")]), _vm._v(", at 183–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.11",
      "id": "fn.5.11"
    }
  }, [_vm._v("11")]), _vm._v(". Geoffrey Stone, "), _c('em', [_vm._v("The Equal Access Controversy: The Religion Clauses and the Meaning of “Neutrality.”")]), _vm._v(" 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 168, 170–71 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.12",
      "id": "fn.5.12"
    }
  }, [_vm._v("12")]), _vm._v(". Michael McConnell, "), _c('em', [_vm._v("Neutrality Under the Religion Clauses")]), _vm._v(", 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 146, 149 n.17 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.13",
      "id": "fn.5.13"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Michael McConnell & Richard Posner, "), _c('em', [_vm._v("An Economic Approach to Issues of Religious Freedom")]), _vm._v(", 56 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 14 (1989) (proposing requirement of neutrality toward religion, conceived not as “treating religion just like other activities,” but as minimizing effects on religious practice); Michael McConnell, "), _c('em', [_vm._v("Unconstitutional Conditions: Unrecognized Implications for the Establishment Clause")]), _vm._v(", 26 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IEGO")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 255, 260 (1989) (government “may not redistribute wealth on the basis of an individual’s, or group’s, exercise of a constitutionally protected right, unless it can show that it has a legitimate justification for doing so”). I have learned much from what he has written. Of course, he is not responsible for anything I say in this Article.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft6.14",
      "id": "fn.6.14"
    }
  }, [_vm._v("14")]), _vm._v(". Peter Westen, "), _c('em', [_vm._v("The Empty Idea of Equality")]), _vm._v(", 95 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 537 (1982). For critical commentary, see Steven J. Burton, "), _c('em', [_vm._v("Comment on “Empty Ideas”: Logical Positivist Analyses of Equality and Rules")]), _vm._v(", 91 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1136 (1982); Anthony D’Amato, "), _c('em', [_vm._v("Comment: Is Equality a Totally Empty Idea?")]), _vm._v(", 81 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 600 (1983); Kent Greenawalt, "), _c('em', [_vm._v("How Empty")]), _vm._v(" Is "), _c('em', [_vm._v("the Idea of Equality?")]), _vm._v(", 83 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1167 (1983); Kenneth W. Simons, "), _c('em', [_vm._v("Equality as a Comparative Right")]), _vm._v(", 65 B.U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 387 (1985). For Westen’s responses, see Peter Westen, "), _c('em', [_vm._v("To Lure the Tarantula from Its Hole: A Response")]), _vm._v(", 83 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1186 (1983); Peter Westen, "), _c('em', [_vm._v("The Meaning of Equality in Law, Science, Math & Morals: A Reply")]), _vm._v(", 81 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 604 (1983); Peter Westen, "), _c('em', [_vm._v("On “Confusing Ideas”: Reply")]), _vm._v(", 91 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1153 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft6.15",
      "id": "fn.6.15"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Califano v. Goldfarb, 430 U.S. 199 (1977) (invalidating different eligibility standards for widows and widowers); Weinberger v. Wiesenfeld, 420 U.S. 636 (1975) (same).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft7.16",
      "id": "fn.7.16"
    }
  }, [_vm._v("16")]), _vm._v(". "), _c('em', [_vm._v("Cf.")]), _vm._v(" Massachusetts Bd. of Retirement v. Murgia, 427 U.S. 307 (1976) (upholding mandatory retirement law); McCarthy v. Sheriff of Suffolk County, 322 N.E.2d 758 (Mass. 1975) (same).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft7.17",
      "id": "fn.7.17"
    }
  }, [_vm._v("17")]), _vm._v(". Age Discrimination in Employment Act, 29 U.S.C. §§ 621–634 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft8.18",
      "id": "fn.8.18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Stephen Carter, "), _c('em', [_vm._v("The Best Black, and Other Tales")]), _vm._v(", 1 R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECONSTRUCTION")]), _vm._v(" 6 (1990); Drew Days, "), _c('em', [_vm._v("Turning Back the Clock: The Reagan Administration and Civil Rights")]), _vm._v(", 19 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". C.R.-C.L. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 309 (1984); Charles Fried, "), _c('em', [_vm._v("Affirmative Action After")]), _vm._v(" City of Richmond v. J.A. Croson Co.: "), _c('em', [_vm._v("A Response to the Scholars’ Statement")]), _vm._v(", 99 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 155 (1989); Randall Kennedy, "), _c('em', [_vm._v("Persuasion and Distrust: A Comment on the Affirmative Action Debate")]), _vm._v(", 99 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1327 (1987); David L. Kirp & Nancy A. Weston, "), _c('em', [_vm._v("The Political Jurisprudence of Affirmative Action")]), _vm._v(", 5 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OC")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIL")]), _vm._v(". & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 223 (1987); Douglas Laycock, "), _c('em', [_vm._v("Taking Constitutions Seriously: A Theory of Judicial Review")]), _vm._v(" (Book Review), 59 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 343, 376–85 (1981); Glenn Loury, "), _c('em', [_vm._v("Why Should We Care About Group Inequality")]), _vm._v(", 5 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OC")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIL")]), _vm._v(". & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 249 (1987); Bernard Meltzer, "), _c('em', [_vm._v("The Weber Case: The Judicial Abrogation of the Antidiscrimination Standard in Employment")]), _vm._v(", 47 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 423 (1980); Charles E. Mitchell, "), _c('em', [_vm._v("Race-Conscious Remedies: Pursuing Equal Employment Opportunity or Equal Employment Results?")]), _vm._v(", 38 L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AB")]), _vm._v(". L.J. 781 (1987); George Rutherglen & Daniel Ortiz, "), _c('em', [_vm._v("Affirmative Action Under the Constitution and Title VII: From Confusion to Convergence")]), _vm._v(", 35 UCLA L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 467 (1988); Martin Schiff, "), _c('em', [_vm._v("Reverse Discrimination Redefined as Equal Protection: The Orwellian Nightmare in the Enforcement of Civil Rights Laws")]), _vm._v(", 8 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". J.L. & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 627 (1985); David A. Strauss, "), _c('em', [_vm._v("The Myth of Colorblindness")]), _vm._v(", 1986 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 99; Laurence Tribe, "), _c('em', [_vm._v("“In What Vision of the Constitution Must the Law Be Color-Blind?”")]), _vm._v(", 20 J. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARSHALL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 201 (1986); William Van Alstyne, "), _c('em', [_vm._v("Rites of Passage: Race, the Supreme Court, and the Constitution")]), _vm._v(", 46 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 775 (1979); J. Skelly Wright, "), _c('em', [_vm._v("Color Blind Theories and Color-Conscious Remedies")]), _vm._v(", 47 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 213 (1980); "), _c('em', [_vm._v("Affirmative Action")]), _vm._v(", 72 I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWA")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 255 (symposium featuring Jesse Choper, Rex Lee, and Paul Brest); Joint Statement, "), _c('em', [_vm._v("Constitutional Scholars’ Statement on Affirmative Action After")]), _vm._v(" City of Richmond v. J.A. Croson Co., 98 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1711 (1989); "), _c('em', [_vm._v("Scholars’ Reply to Professor Fried")]), _vm._v(", 99 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 163 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft10.19",
      "id": "fn.10.19"
    }
  }, [_vm._v("19")]), _vm._v(". 485 U.S. 439 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft10.20",
      "id": "fn.10.20"
    }
  }, [_vm._v("20")]), _vm._v(". Widmar v. Vincent, 454 U.S. 263 (1981); Equal Access Act, 20 U.S.C. § 4071–4074 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.21",
      "id": "fn.11.21"
    }
  }, [_vm._v("21")]), _vm._v(". Philip Kurland, "), _c('em', [_vm._v("Of Church and State and the Supreme Court")]), _vm._v(", 29 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 96 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.22",
      "id": "fn.11.22"
    }
  }, [_vm._v("22")]), _vm._v(". See Philip Kurland, "), _c('em', [_vm._v("The Irrelevance of the Constitution: The Religion Clauses of the First Amendment and the Supreme Court")]), _vm._v(", 24 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 3, 24 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.23",
      "id": "fn.11.23"
    }
  }, [_vm._v("23")]), _vm._v(". Mark Tushnet, "), _c('em', [_vm._v("“Of Church and State and the Supreme Court”: Kurland Revisited")]), _vm._v(", 1989 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 373. It is surprising to find a leader of the critical legal studies movement endorsing a rule of formal neutrality, implicitly assuming that the government is not responsible for the unequal impact of its actions, and urging the virtues of clear legal doctrine.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.24",
      "id": "fn.11.24"
    }
  }, [_vm._v("24")]), _vm._v(". An Act to Prohibit Intoxicating Beverages, ch. 85 § 6, 41 Stat. 305, 311 (1919).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft12.25",
      "id": "fn.12.25"
    }
  }, [_vm._v("25")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872 (1990). For analysis of this case, see Douglas Laycock, "), _c('em', [_vm._v("Peyote, Wine, and the First Amendment")]), _vm._v(", 106 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTURY")]), _vm._v(" 876 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft13.26",
      "id": "fn.13.26"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Aguilar v. Felton, 473 U.S. 402 (1985); Lemon v. Kurtzman, 403 U.S. 602 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft13.27",
      "id": "fn.13.27"
    }
  }, [_vm._v("27")]), _vm._v(". This is a modest elaboration of the definition I offered in 1986:")]), _vm._v(" "), _c('p', {
    staticClass: "Quote1Sb"
  }, [_vm._v("I do not mean neutrality in the sense of a ban on religious classifications. Instead, I mean neutrality in the sense of government conduct that insofar as possible neither encourages nor discourages religious belief or practice. This requires identification of a base line from which to measure encouragement and discouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes-para1"
  }, [_vm._v("Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 3 (text at "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.10"
    }
  }, [_vm._v("note 10")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft14.28",
      "id": "fn.14.28"
    }
  }, [_vm._v("28")]), _vm._v(". "), _c('em', [_vm._v("Cf.")]), _vm._v(" Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 316 n.192 (listing commentators who argue that neutrality, voluntarism, and separation are not consistent values).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft14.29",
      "id": "fn.14.29"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Torcaso v. Watkins, 367 U.S. 488, 496 (1961) (requiring atheist to affirm belief in God violates his “freedom of belief and religion”); "), _c('em', [_vm._v("cf.")]), _vm._v(" EEOC v. Townley Eng. & Mfg. Co., 859 F.2d 610, 613 (9th Cir. 1988) (requiring atheist employee to attend religious services at work discriminates against him on basis of religion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft14.30",
      "id": "fn.14.30"
    }
  }, [_vm._v("30")]), _vm._v(". Welsh v. United States, 398 U.S. 333, 344 (1970).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft16.31",
      "id": "fn.16.31"
    }
  }, [_vm._v("31")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 10–11 (text at "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.47"
    }
  }, [_vm._v("notes 47–56")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft16.32",
      "id": "fn.16.32"
    }
  }, [_vm._v("32")]), _vm._v(". "), _c('em', [_vm._v("See id.")]), _vm._v(" at 28–31 (text at notes 142–50). The Equal Access Act somewhat ineptly provides that schools should not sponsor student religious groups. 20 U.S.C. § 4071(c)(2) & (3) (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft16.33",
      "id": "fn.16.33"
    }
  }, [_vm._v("33")]), _vm._v(". "), _c('em', [_vm._v("E.g.")]), _vm._v(", Wallace v. Jaffree, 472 U.S. 38 (1985) (striking down statute authorizing moment of silence “for meditation or voluntary prayer” where legislative history showed intent to return prayer to public schools); School Dist. of Abington Township v. Schempp, 374 U.S. 203 (1963) (state cannot require daily Bible reading and recitation of Lord’s Prayer in public schools); Engel v. Vitale, 370 U.S. 421 (1962) (state may not compose or require recitation of official state prayer).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft17.34",
      "id": "fn.17.34"
    }
  }, [_vm._v("34")]), _vm._v(". Roemer v. Board of Public Works, 426 U.S. 736, 747 (1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft17.35",
      "id": "fn.17.35"
    }
  }, [_vm._v("35")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 746–47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.36",
      "id": "fn.18.36"
    }
  }, [_vm._v("36")]), _vm._v(". Ruti Teitel, "), _c('em', [_vm._v("The Unconstitutionality of Equal Access Policies and Legislation Allowing Organized Student-Initiated Religious Activities in the Public High Schools: A Proposal for a Unitary First Amendment Forum Analysis.")]), _vm._v(" 12 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTINGS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". L.Q. 529, 562–65 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.37",
      "id": "fn.18.37"
    }
  }, [_vm._v("37")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 10 (text at "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.47"
    }
  }, [_vm._v("notes 47–48")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.38",
      "id": "fn.18.38"
    }
  }, [_vm._v("38")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 36, at 582.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.39",
      "id": "fn.18.39"
    }
  }, [_vm._v("39")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Bender v. Williamsport Area School Dist., 741 F.2d 538, 554–55 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 36, at 579–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.40",
      "id": "fn.19.40"
    }
  }, [_vm._v("40")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 16–17, 28, 47–51 (text at notes 79–92, 141, 225–42).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.41",
      "id": "fn.19.41"
    }
  }, [_vm._v("41")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" Robert Nagel, "), _c('em', [_vm._v("The Formulaic Constitution")]), _vm._v(", 84 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 165 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.42",
      "id": "fn.19.42"
    }
  }, [_vm._v("42")]), _vm._v(". Lemon v. Kurtzman, 403 U.S. 602, 612 (1971), "), _c('em', [_vm._v("as modified in")]), _vm._v(" Committee for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 783–84 n.39 (1973).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.43",
      "id": "fn.19.43"
    }
  }, [_vm._v("43")]), _vm._v(". The antecedents of the test are traced in Douglas Laycock, "), _c('em', [_vm._v("Towards a General Theory of the Religion Clauses: The Case of Church Labor Relations and the Right to Church Autonomy")]), _vm._v(", 81 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1373, 1380–81 (1981) (text at notes 70–74).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.44",
      "id": "fn.19.44"
    }
  }, [_vm._v("44")]), _vm._v(". 473 U.S. 402 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.45",
      "id": "fn.20.45"
    }
  }, [_vm._v("45")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 411–12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.46",
      "id": "fn.20.46"
    }
  }, [_vm._v("46")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 412–14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.47",
      "id": "fn.20.47"
    }
  }, [_vm._v("47")]), _vm._v(". County of Allegheny v. American Civil Liberties Union Greater Pittsburgh Chapter, 492 U.S. 573, 657–58 (1989) (Kennedy, J., dissenting); W. H. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERLY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RISIS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIVERSITY")]), _vm._v(" 55–56 (1949); R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICHARD")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EUHAUS")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AKED")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBLIC")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("QUARE")]), _vm._v(" (1984); James Hitchcock, "), _c('em', [_vm._v("Church, State and Moral Values: The Limits of American Pluralism")]), _vm._v(", 44 L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" & C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROBS")]), _vm._v(". 3 (Spring 1981); Andrew Woodbridge Hull, Note, "), _c('em', [_vm._v("A Moment of Silence: A Permissible Accommodation Protecting the Capacity to Form Religious Belief")]), _vm._v(", 61 I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ND")]), _vm._v(". L.J. 429, 431–33 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.48",
      "id": "fn.20.48"
    }
  }, [_vm._v("48")]), _vm._v(". The costs of implementing "), _c('em', [_vm._v("Aguilar")]), _vm._v(" are carefully assessed in T. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITULLO")]), _vm._v("-M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTIN")]), _vm._v(" & B. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OOPER")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPARATION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILD")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDERAL")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ID")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOLS")]), _vm._v(" 41–66 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.49",
      "id": "fn.21.49"
    }
  }, [_vm._v("49")]), _vm._v(". Texas Monthly, Inc. v. Bullock, 489 U.S. 1, 10–17 (1989) (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.50",
      "id": "fn.21.50"
    }
  }, [_vm._v("50")]), _vm._v(". Aguilar v. Felton, 473 U.S. 402 (1985) (opinion of the Court by Brennan, J.).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.51",
      "id": "fn.21.51"
    }
  }, [_vm._v("51")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Goldman v. Weinberger, 475 U.S. 503, 520–24 (1986) (Brennan, J., dissenting); Wisconsin v. Yoder, 406 U.S. 205 (1972) (Brennan, J., joining opinion of the Court).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.52",
      "id": "fn.21.52"
    }
  }, [_vm._v("52")]), _vm._v(". "), _c('em', [_vm._v("Texas Monthly, Inc.")]), _vm._v(", 489 U.S. 1, 29–45 (Rehnquist, C.J., joining dissent of Scalia, J.); "), _c('em', [_vm._v("Aguilar")]), _vm._v(", 473 U.S. at 420–21 (Rehnquist, C.J., dissenting); "), _c('em', [_vm._v("Goldman")]), _vm._v(", 475 U.S. 503 (opinion of the Court); Thomas v. Review Bd., 450 U.S. 707, 720 (1981) (Rehnquist, C.J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.53",
      "id": "fn.21.53"
    }
  }, [_vm._v("53")]), _vm._v(". "), _c('em', [_vm._v("Texas Monthly, Inc.")]), _vm._v(", 489 U.S. 1, 10–17 (Stevens, J., joining plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.54",
      "id": "fn.21.54"
    }
  }, [_vm._v("54")]), _vm._v(". "), _c('em', [_vm._v("Aguilar")]), _vm._v(", 473 U.S. 402 (Stevens, J., joining opinion of the Court).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.55",
      "id": "fn.21.55"
    }
  }, [_vm._v("55")]), _vm._v(". Goldman v. Weinberger, 475 U.S. 503, 510–13 (1986) (Stevens, J., concurring); United States v. Lee, 455 U.S. 252, 261–64 (1982) (Stevens, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.56",
      "id": "fn.21.56"
    }
  }, [_vm._v("56")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872 (1990); Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.57",
      "id": "fn.22.57"
    }
  }, [_vm._v("57")]), _vm._v(". "), _c('em', [_vm._v("Swaggart")]), _vm._v(", 493 U.S. at 391–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.58",
      "id": "fn.22.58"
    }
  }, [_vm._v("58")]), _vm._v(". 494 U.S. 872.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.59",
      "id": "fn.22.59"
    }
  }, [_vm._v("59")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 877 (quoting U.S. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". amend. I).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.60",
      "id": "fn.22.60"
    }
  }, [_vm._v("60")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 884.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.61",
      "id": "fn.22.61"
    }
  }, [_vm._v("61")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 878.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.62",
      "id": "fn.22.62"
    }
  }, [_vm._v("62")]), _vm._v(". Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378, 391, 394 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.63",
      "id": "fn.22.63"
    }
  }, [_vm._v("63")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 394.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft23.64",
      "id": "fn.23.64"
    }
  }, [_vm._v("64")]), _vm._v(". "), _c('em', [_vm._v("Smith")]), _vm._v(", 494 U.S. at 890.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft24.65",
      "id": "fn.24.65"
    }
  }, [_vm._v("65")]), _vm._v(". For news stories, see James Barron, "), _c('em', [_vm._v("Georgetown’s President Named Head of Public Library")]), _vm._v(", New York Times, Feb. 24, 1989, at B1, col. 2; Dena Kleiman, "), _c('em', [_vm._v("Jesuits See Library Post as Part of Their Mission")]), _vm._v(", New York Times, Feb. 25, 1989, at A33, col. 1; Peter Steinfels, "), _c('em', [_vm._v("Priest Picked for Library Post Responds to Critics")]), _vm._v(", New York Times, Apr. 2, 1989, at A29, col. 1. For editorials, one on each side, see "), _c('em', [_vm._v("The Librarian Priest")]), _vm._v(", New York Times, Mar. 21, 1989, at A24, col. 1 (opposed); "), _c('em', [_vm._v("Father Healy as Public Man")]), _vm._v(", New York Times, Apr. 9, 1989, at A26, col. 1 (supporting). For letters to the editor, see New York Times, Mar. 1, 1989, at A24, col. 3 (Gay Talese, opposed); New York Times, Mar. 16, 1989, at A30, col. 4 (Garry Wills, supporting); New York Times, Mar. 31, 1989, at A34, col. 3 (Joseph Heller, opposed: Albert H. Bowker & Joseph S. Murphy, supporting; Andrew Humm, Eleanor Cooper, and Tom Smith, opposed); New York Times, Apr. 13, 1989, at A26, col. 3 (Sen. Daniel Patrick Moynihan, supporting; Paul Halsall, supporting); New York Times, Apr. 21, 1989, at A30, col. 3 (Andrew M. Greeley, supporting); New York Times, May 8, 1989, at A18, col. 3 (Peter G. Finn, supporting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.66",
      "id": "fn.25.66"
    }
  }, [_vm._v("66")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", County of Allegheny v. American Civil Liberties Union Greater Pittsburgh Chapter, 492 U.S. 573, 668–77 (1989) (Kennedy, J., dissenting); Wallace v. Jaffree, 472 U.S. 38, 114 (1985) (Rehnquist, J., dissenting); Edwin Meese, "), _c('em', [_vm._v("The Supreme Court of the United States: Bulwark of a Limited Constitution")]), _vm._v(", 27 S. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 455, 464 (1986) (argument that Religion Clauses require neutrality between religion and nonreligion “would have struck the founding generation as bizarre”); John Whitehead & John Conlan, "), _c('em', [_vm._v("The Establishment of the Religion of Secular Humanism and Its First Amendment Implications")]), _vm._v(", 10 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 21–25 (1978) (Supreme Court rulings have replaced theism with secular humanism as an established faith).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.67",
      "id": "fn.25.67"
    }
  }, [_vm._v("67")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERBERT")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C")]), _vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOSKY")]), _vm._v(" & A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIDA")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RILL")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMENSIONS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLERANCE")]), _vm._v(": W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAT")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICANS")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HINK")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BOUT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVIL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(" 133 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.68",
      "id": "fn.25.68"
    }
  }, [_vm._v("68")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Lynch v. Donnelly, 465 U.S. 668 (1984) (upholding municipal creche); Marsh v. Chambers, 463 U.S. 783 (1983) (upholding legislative chaplain who opens daily sessions with prayer).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.69",
      "id": "fn.25.69"
    }
  }, [_vm._v("69")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Widmar v. Vincent, 454 U.S. 263 (1981); Heffron v. International Soc’y for Krishna Consciousness, Inc., 452 U.S. 640 (1981); Poulos v. New Hampshire, 345 U.S. 395 (1953); West Virginia State Bd. of Educ. v. Barnette, 319 U.S. 624 (1943); Largent v. Texas, 318 U.S. 418 (1943); Cantwell v. Connecticut, 310 U.S. 296 (1940); Lovell v. City of Griffin, 303 U.S. 444 (1938).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.70",
      "id": "fn.25.70"
    }
  }, [_vm._v("70")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Buckley v. Valeo, 424 U.S. 1 (1976); L.A. Powe, "), _c('em', [_vm._v("Mass Speech")]), _vm._v(", 1982 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 243.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.71",
      "id": "fn.26.71"
    }
  }, [_vm._v("71")]), _vm._v(". 26 U.S.C. § 501(c)(3) (1982). For criticism of the use of tax exemptions to restrict religious speech, see Wilfred Caron & Deidre Dessingue, "), _c('em', [_vm._v("IRC § 501(c)(3): Practical and Constitutional Implications of “Political” Activity Restrictions")]), _vm._v(", 2 J.L. & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v(". 169 (1985); Edward Gaffney, "), _c('em', [_vm._v("On Not Rendering to Caesar: The Unconstitutionality of Tax Regulation of Activities of Religious Organizations Relating to Politics")]), _vm._v(", 40 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1 (1990) (forthcoming).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.72",
      "id": "fn.26.72"
    }
  }, [_vm._v("72")]), _vm._v(". Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378 (1990), discussed in text "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.56"
    }
  }, [_vm._v("notes 56–63")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.73",
      "id": "fn.26.73"
    }
  }, [_vm._v("73")]), _vm._v(". George v. International Soc’y for Krishna Consciousness, No. D007153 (Cal. App. 4th Dist. 1989), "), _c('em', [_vm._v("vacated")]), _vm._v(", 499 U.S. 914 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.74",
      "id": "fn.26.74"
    }
  }, [_vm._v("74")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Frazee v. Illinois Dept. of Employment Sec., 489 U.S. 829 (1989) (employee who loses his job for religious reasons is entitled to unemployment compensation); Hobbie v. Unemployment Appeals Comm’n, 480 U.S. 136 (1987) (same); Thomas v. Review Bd., 450 U.S. 707 (1981) (same); Wisconsin v. Yoder, 406 U.S. 205 (1972) (Amish parents who conscientiously object to public high school exempted from compulsory education laws); Sherbert v. Verner, 374 U.S. 398 (1963) (another unemployment compensation case) "), _c('em', [_vm._v("with")]), _vm._v(" Goldman v. Weinberger, 475 U.S. 503 (1986) (military can discipline officer for wearing "), _c('em', [_vm._v("yarmulke")]), _vm._v(" with uniform); Bob Jones Univ. v. United States, 461 U.S. 574, 602–04 (1983) (pervasively religious school that conscientiously forbids interracial dating by students has no constitutional right to retain its charitable tax exemption); United States v. Lee, 455 U.S. 252 (1982) (conscientious objectors to social security have no constitutional right to refuse to pay social security taxes); Gillette v. United States, 401 U.S. 437 (1971) (conscientious objectors to unjust wars have no constitutional right to exemption from serving in such wars).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.75",
      "id": "fn.27.75"
    }
  }, [_vm._v("75")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Brief of the United States as Amicus Curiae Supporting Appellees at 7–10, Hobbie v. Florida Unemployment Comm’n, 480 U.S. 136 (1987) (No. 85–993) (arguing that government may "), _c('em', [_vm._v("restrict or penalize")]), _vm._v(" free exercise of religion as long as it does not "), _c('em', [_vm._v("prohibit")]), _vm._v(" free exercise of religion); Brief for the Appellants at 27–30, Bowen v. Roy, 476 U.S. 693 (1986) (No. 84–780) (arguing that government’s interest in denying constitutional exemption to conscientious objector must be measured by the cost of repealing the challenged law entirely, and not by the cost of exempting conscientious objectors); Brief for the Respondents, Goldman v. Weinberger, 475 U.S. 503 (1986) (No. 84–1097) (arguing against right to wear "), _c('em', [_vm._v("yarmulke")]), _vm._v(" with military uniform); Brief of the United States as Amicus Curiae at 5–15, Jensen v. Quaring, 472 U.S. 478 (1985) (No. 83–1944) (arguing that Constitution does not require exemption from photograph required for driver’s license); Brief for the United States at 15–18, United States v. Lee, 455 U.S. 252 (1982) (No. 80–767) (arguing that Constitution does not protect against indirect burdens on exercise of religion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.76",
      "id": "fn.27.76"
    }
  }, [_vm._v("76")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.77",
      "id": "fn.27.77"
    }
  }, [_vm._v("77")]), _vm._v(". Ellis West, "), _c('em', [_vm._v("The Case Against a Right to Religion-Based Exemptions")]), _vm._v(", 4 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTRE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" J.L. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THICS")]), _vm._v(", & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 591 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.78",
      "id": "fn.27.78"
    }
  }, [_vm._v("78")]), _vm._v(". William Marshall, "), _c('em', [_vm._v("The Case Against the Constitutionally Compelled Free Exercise Exemption")]), _vm._v(", 40 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASE")]), _vm._v(" W. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ES")]), _vm._v(". 357 (1989–90).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.79",
      "id": "fn.27.79"
    }
  }, [_vm._v("79")]), _vm._v(". "), _c('em', [_vm._v("But see")]), _vm._v(" Tushnet, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.23"
    }
  }, [_vm._v("note 23")]), _vm._v(", at 384, 402.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.80",
      "id": "fn.27.80"
    }
  }, [_vm._v("80")]), _vm._v(". "), _c('em', [_vm._v("Smith")]), _vm._v(", 494 U.S. at 877 (using example of “sacramental use of bread and wine”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.81",
      "id": "fn.27.81"
    }
  }, [_vm._v("81")]), _vm._v(". Oral exchange at Notre Dame conference on religious liberty, South Bend, Indiana, March 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.82",
      "id": "fn.28.82"
    }
  }, [_vm._v("82")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.83",
      "id": "fn.28.83"
    }
  }, [_vm._v("83")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Employment Div. v. Smith, 494 U.S. 872 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.84",
      "id": "fn.28.84"
    }
  }, [_vm._v("84")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Davis v. Beason, 133 U.S. 333 (1890).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.85",
      "id": "fn.28.85"
    }
  }, [_vm._v("85")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Reynolds v. United States, 98 U.S. 145 (1878).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.86",
      "id": "fn.28.86"
    }
  }, [_vm._v("86")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Late Corp. of the Church of Jesus Christ of Latter Day Saints v. United States, 136 U.S. 1 (1890).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.87",
      "id": "fn.28.87"
    }
  }, [_vm._v("87")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.88",
      "id": "fn.28.88"
    }
  }, [_vm._v("88")]), _vm._v(". See J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OONAN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIEVER")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWERS")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAT")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RE")]), _vm._v(" 207 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.89",
      "id": "fn.28.89"
    }
  }, [_vm._v("89")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" George v. International Soc’y for Krishna Consciousness, No. D007153 (Cal. App. 4th Dist. 1989) ($32.7 million verdict reduced to $3 million), "), _c('em', [_vm._v("vacated")]), _vm._v(", 499 U.S. 914 (1991); Wollersheim v. Church of Scientology, 260 Cal. Rptr. 331 (Cal. App. 1989) ($30 million verdict remitted to $2.5 million), "), _c('em', [_vm._v("vacated")]), _vm._v(", 499 U.S. 914 (1991); Church Universal & Triumphant, Inc. v. Witt, No. B021187 (Cal. App. 2d Dist. 1989) ($1.5 million); O’Neil v. Schuckardt, 733 P.2d 693 (Idaho 1986) ($1 million); Christofferson v. Church of Scientology, 5 Religious Freedom Rptr. 126 (Or. Cir. Ct. Multnomah County 1985) ($39 million). For earlier proceedings in "), _c('em', [_vm._v("Christofferson")]), _vm._v(", see 644 P.2d 577 (Or. App. 1982). The California courts appear not to believe that judicial destruction of a minority faith even requires a published opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.90",
      "id": "fn.29.90"
    }
  }, [_vm._v("90")]), _vm._v(". Guinn v. Church of Christ, 775 P.2d 766 (Okla. 1989) ($390,000 against local congregation).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.91",
      "id": "fn.29.91"
    }
  }, [_vm._v("91")]), _vm._v(". Goldman v. Weinberger, 475 U.S. 503 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.92",
      "id": "fn.29.92"
    }
  }, [_vm._v("92")]), _vm._v(". 10 U.S.C. § 774 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.93",
      "id": "fn.29.93"
    }
  }, [_vm._v("93")]), _vm._v(". Quaring v. Peterson, 728 F.2d 1121 (8th Cir. 1984), "), _c('em', [_vm._v("aff’d by equally divided Court, sub nom.")]), _vm._v(" Jensen v. Quaring, 472 U.S. 478 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft30.94",
      "id": "fn.30.94"
    }
  }, [_vm._v("94")]), _vm._v(". I elaborate on the second-chance rationale for judicial review in Douglas Laycock, "), _c('em', [_vm._v("Notes on the Role of Judicial Review, the Expansion of Federal Power, and the Structure of Constitutional Rights")]), _vm._v(" (Book Review), 99 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1711, 1727–30 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft30.95",
      "id": "fn.30.95"
    }
  }, [_vm._v("95")]), _vm._v(". See B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTLETT")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMILIAR")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UOTATIONS")]), _vm._v(" 802a (14th ed. 1968) (“The law, in its majestic equality, forbids the rich as well as the poor to sleep under bridges, to beg in the streets, and to steal bread”) (quoting A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NATOLE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANCE")]), _vm._v(", L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YS")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUGE")]), _vm._v(" (1894)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft31.96",
      "id": "fn.31.96"
    }
  }, [_vm._v("96")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Mayer Freed & Daniel Polsby, "), _c('em', [_vm._v("Race, Religion, and Public Policy:")]), _vm._v(" Bob Jones University v. United States, 1983 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 20–30; Marshall, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.78"
    }
  }, [_vm._v("note 78")]), _vm._v("; West, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.77"
    }
  }, [_vm._v("note 77")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft31.97",
      "id": "fn.31.97"
    }
  }, [_vm._v("97")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EON")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTINGER")]), _vm._v(", A T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEORY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OGNITIVE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISSONANCE")]), _vm._v(" 1–31, 84–122 (1957).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft32.98",
      "id": "fn.32.98"
    }
  }, [_vm._v("98")]), _vm._v(". 50 U.S.C. App. § 456(j) (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft32.99",
      "id": "fn.32.99"
    }
  }, [_vm._v("99")]), _vm._v(". 29 U.S.C. § 169 (Supp. V. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft32.100",
      "id": "fn.32.100"
    }
  }, [_vm._v("100")]), _vm._v(". M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULFORD")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBLEY")]), _vm._v(" & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILIP")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACOB")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCRIPTION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCIENCE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCIENTIOUS")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BJECTOR")]), _vm._v(", 1940–1947, at 84 (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes-para"
  }, [_vm._v("This article is adapted from the Sixth Annual Lecture of the Center for Church/State Studies, delivered in Chicago, Illinois, on April 6, 1989. Much of the argument speaks as of that date. In the interim, the Supreme Court has announced sweeping changes in the relevant law. Initial reaction to those changes is largely confined to inserts.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_vm._v("I am grateful to the DePaul University Law School and the Center for Church/State Studies for their invitation, support, and helpful reactions to this lecture; to Jay Westbrook and Sanford Levinson for helpful comments on an earlier written draft; and to the University Research Institute at the University of Texas for a research leave that made it possible for me to accept DePaul’s invitation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_vm._v("I should disclose that I wrote and filed amicus briefs in the Supreme Court in the following cases cited or discussed in this Article: George v. International Soc’y for Krishna Consciousness, 499 U.S. 914 (1991); Board of Educ. v. Mergens, 496 U.S. 226 (1990); Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378 (1990), and that I was of counsel on the petition for rehearing in Employment Div. v. Smith, 494 U.S. 872 (1990).")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "PT1.1.4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("The Benefits of the Establishment Clause")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "para9"
  }, [_c('em', [_vm._v("42 DePaul Law Review 373 (1992)")])]), _vm._v(" "), _c('p', {
    staticClass: "para4"
  }, [_c('em', [_vm._v("This was presented at a conference at the DePaul Center for Church/State Studies. I was part of a panel asked to respond to the question, “Does the United States need an Establishment Clause?” To answer that question, I focused on what the Establishment Clause adds to the Free Exercise Clause. The published version closely tracks the oral presentation, and exchanges with the audience are included. Footnotes have been renumbered in the Question and Answer segment.")])]), _vm._v(" "), _c('p', {
    staticClass: "design"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chpara"
  }, [_vm._v("I must begin by briefly discussing both the Free Exercise Clause and the Establishment Clause and the relationship between them. In my view, they are both clauses to protect religious liberty. Together, they protect both believers and nonbelievers. Indeed, each clause considered separately protects both believers and nonbelievers, or each would if it were properly interpreted. The shortest summary I can offer is that the clauses together are designed to minimize government influence on religious belief and practice. By minimizing government influence, they maximize religious liberty. Much more than with respect to any of our other liberties, the Religion Clauses are designed to make religious practice and nonpractice, belief and nonbelief, wholly matters of private choice insulated from government influence or control.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Much of the contribution of the Establishment Clause is that religious ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("belief and practice are insulated even from government persuasion. There is no other area of our life where we say that government cannot even try to persuade you. On political issues, persuasion is a large part of what government does. Government leads; government tries to mold opinion. But with respect to religious opinion, we say that molding opinion is precisely what government should not do.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In too many discussions of the Religion Clauses, including at least occasionally at this conference, you get a sense that each Religion Clause is one side’s club to beat the other with. Among some aggressively proselytizing religious groups you occasionally hear the Free Exercise Clause explained as their way to maximize their religious influence, and the Establishment Clause as an unfortunate inconvenience. On the other side, and far more often in academic life, you hear the Establishment Clause pointed to as the clause by which we keep these troublesome religious folks under control and out of the public sphere. Each of these views is nonsense. These two clauses, which are found in the same sentence, are not in opposition to one another. At the big picture level, they are not even in tension with one another, although I concede that in applying the clauses in close cases, the hard cases, there is sometimes tension.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("It is important to remember that the votes for disestablishment came from evangelicals."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.34.1",
      "id": "ft34.1"
    }
  }, [_vm._v("1")]), _vm._v(" The votes came from Baptists, Presbyterians, Methodists, and Quakers. I do not mean to underestimate the contribution of James Madison, but he alone did not have the votes. The necessary political pressure, the demand for disestablishment, the threat not to ratify the Constitution unless something were done about religious liberty, came from the evangelical dissenting churches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am sure about where the votes came from. I am less sure about this next point, but I think it is more probable than not: but for the evangelicals, Madison would not have had the motivation to pursue religious liberty. He was influenced by the specter and the occasional reality of persecution of Baptist preachers in Virginia. Without that experience, I am not at all sure there would be "), _c('em', [_vm._v("The Memorial and the Remonstrance")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.34.2",
      "id": "ft34.2"
    }
  }, [_vm._v("2")])]), _vm._v(" or any of the rest that "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("we credit to Madison. In fact, Madison was nearly defeated for election to the First Congress, partly because of an Anti-Federalist gerrymander, but also because he was dragging his feet on a federal bill of rights, and religious dissenters in his district were demanding an explicit guarantee of religious liberty."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.35.3",
      "id": "ft35.3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Under the Religion Clauses, as I understand them and as the Supreme Court has understood them, all religions are protected. But that commitment itself entails one choice about types of religion. There is one type of religion that cannot be fully protected. That is the religion of those people who believe that their religious exercise requires the use of the instruments of government, either to directly impose their belief on others or to use government in their own worship services. This choice among types of religion is also a choice among types of liberty. I believe it is not simply a raw choice. It is a principled choice, based on the view that the best you can do to maximize religious liberty for all citizens is to prevent anyone from using the government for religious purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What then is the role of the Establishment Clause as one of this pair of clauses to protect religious liberty? One way to view this question is in practical lawyer terms. What does the Establishment Clause add to the Free Exercise Clause? What abuses are forbidden by the Establishment Clause that would not be forbidden if we had the Free Exercise Clause alone?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Susan Gilles"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.35.4",
      "id": "ft35.4"
    }
  }, [_vm._v("4")])]), _vm._v(" and Richard Kay"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.35.5",
      "id": "ft35.5"
    }
  }, [_vm._v("5")])]), _vm._v(" have outlined what an established church can look like in a tolerant society under the most favorable conditions for liberty. One can decide for oneself whether the results are satisfactory. I tend to approach the question from the opposite perspective. Constitutional rights do not exist to protect us against the times when things are going well. Rather, we have constitutional rights to ameliorate the times when things are going very badly. Constitutional rights are aimed at abuses. The question then becomes: What abuses are forbidden by the Establishment Clause that are not forbidden by the Free Exercise Clause?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is certainly true that constitutional clauses and judicial review are very thin reeds to rely on. When a society is bent on abuse or persecution, there is a great danger that judges will go along. A sufficiently determined political majority can appoint judges who promise not to enforce much of the Bill of "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Rights. Our mechanisms for preserving minority rights and majority rule are ingenious but fragile.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("The claim that constitutional clauses do some good is not a claim that judges are inherently better than legislators at protecting liberty. Sometimes they are better; sometimes they are worse. Usually they are about the same. The claim that the Constitution does some good is simply the claim that two chances are better than one. Unlike legislators, judges have to at least go through the motions of listening to every complaint that is presented to them and of giving principled reasons for each decision. They have some incentives to do so, incentives in judicial tradition and in insulation from political pressure. Some of the time, judicial review will do some good. The judges did nothing for the Mormons,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.36.6",
      "id": "ft36.6"
    }
  }, [_vm._v("6")]), _vm._v(" but they may have saved the Jehovah’s Witnesses"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.36.7",
      "id": "ft36.7"
    }
  }, [_vm._v("7")])]), _vm._v(" and the Amish."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.36.8",
      "id": "ft36.8"
    }
  }, [_vm._v("8")])]), _vm._v(" If judges can save one religious minority a century, I consider that ample justification for judicial review in religious liberty cases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I come at last to the question of what abuses might be forbidden by the Establishment Clause that may not be forbidden by the Free Exercise Clause. The first, and most obvious, is taxation to support religion as religion. In Virginia by 1776, there were still some licensing provisions, and Baptist ministers were occasionally hassled, but Virginians were very close to general free exercise."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.36.9",
      "id": "ft36.9"
    }
  }, [_vm._v("9")])]), _vm._v(" The dissenting churches were already allowed to function. It would have been very easy to enact a Free Exercise Clause with no Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In fact, that is what they did. The Virginia Free Exercise Clause was enacted in 1776, and disestablishment came some time later."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.36.10",
      "id": "ft36.10"
    }
  }, [_vm._v("10")])]), _vm._v(" The general assessment proposal that Madison resisted would have continued free exercise for all but required each citizen to pay taxes to support the religion of his choice."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.36.11",
      "id": "ft36.11"
    }
  }, [_vm._v("11")])]), _vm._v(" The historian Thomas Curry thinks that many at the time believed that taxation to support the church violated free exercise."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.36.12",
      "id": "ft36.12"
    }
  }, [_vm._v("12")])]), _vm._v(" He may be right, "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("although there is no support in the case law for that claim today."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.37.13",
      "id": "ft37.13"
    }
  }, [_vm._v("13")]), _vm._v(" Certainly it is easier to explain to a judge why taxation to support the church violates the Establishment Clause than to explain why it would violate the Free Exercise Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Taxation to support education and social services delivered by churches may or may not be distinguishable from taxation to support religion as religion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.37.14",
      "id": "ft37.14"
    }
  }, [_vm._v("14")])]), _vm._v(" If church-sponsored education and social services are distinguishable from the church itself, then tax support violates neither Religion Clause. If church-sponsored education and social services are indistinguishable from the church itself, then the tax support violates the Establishment Clause. A free exercise claim is much harder to make out. The analysis of whether the Establishment Clause adds anything to the Free Exercise Clause with respect to education and social services is analogous to the analysis of which clause forbids taxation to support religion as religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A second abuse forbidden by the Establishment Clause is coerced worship. Just as the general assessment proposal would have required everybody to pay a tax to some church, it is easy to imagine a law that required everybody to attend some church. Such a law might let the individual choose the church, but would require attendance somewhere. In fact, that is a rule at military academies today."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.1.AST",
      "id": "ft1.AST"
    }
  }, [_vm._v("*")])]), _vm._v(" Coerced worship is one way to understand school prayer: all the students are required to participate in this little worship service. I am assuming that in our pluralistic society, such a requirement would at least have some aspect of nonpreferentialism about it. But one can even "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("imagine a rule that says every church can continue to function, and you can go to your own church, as long as you also show up at the established or preferred church once a week.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("A requirement that everyone worship would violate the Free Exercise Clause, if properly interpreted. Just as the Speech Clause protects one’s right not to speak, the Free Exercise Clause protects one’s right not to worship. I am not at all convinced, however, that the current Supreme Court would have agreed with this, even before "), _c('em', [_vm._v("Employment Division v. Smith.")]), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.38.15",
      "id": "ft38.15"
    }
  }, [_vm._v("15")]), _vm._v(" The Court says there is no free exercise claim unless a person is required to violate a specific and obligatory tenet of her religious belief."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.38.16",
      "id": "ft38.16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider what the Court’s rule implies for coerced worship. Suppose I say: “I am a traditional Roman Catholic and I have a specific tenet against worshiping with anyone else. And I still believe that, even though the rest of the Catholic Church has become considerably more liberal as to this tenet.” If I sincerely believe this, then I may have a free exercise claim of coerced worship at another faith’s service. But suppose I say: “I’m just a non-believer. I do not care about any of this stuff.” Or suppose I say: “I am a post-Vatican II Catholic. I have no objection in principle to worshiping with other faiths. But except on special occasions, I do not get much out of it. I am certainly not going to give up the Mass, and it is a burden to also attend someone else’s worship service every week.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In either of the latter scenarios, the current judicial response is likely to be: “You have no specific religious tenet that says you cannot show up and worship in someone else’s church once a week as the law requires. You have no free exercise claim. The burden of two worship services every week is irrelevant, or in any event is much less onerous than the burden of closing a store two days a week in "), _c('em', [_vm._v("Braunfeld v. Brown.")]), _vm._v("”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.38.17",
      "id": "ft38.17"
    }
  }, [_vm._v("17")])]), _vm._v(" That may be the wrong interpretation of the Free Exercise Clause but, again, protection against coerced worship is much more easily explained in terms of the Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Neither coerced worship, nor coerced tax support for religion as religion, seems very likely in the current political environment. A third and more real "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("concern, as raised here by Daniel Conkle, is noncoercive religious observances by government."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.39.18",
      "id": "ft39.18"
    }
  }, [_vm._v("18")]), _vm._v(" What about government-sponsored worship that no one has to attend but anyone may attend? What about government crosses, creches, menorahs, Christmas pageants, and the like? This is where much of the real issue exists today. If the Establishment Clause were cut back to only a rule against coercive impositions of religion by government, and if coercion were interpreted to mean only physical force or formal sanctions,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.39.19",
      "id": "ft39.19"
    }
  }, [_vm._v("19")])]), _vm._v(" then there would be much less political controversy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So, what are the benefits of a rule against all government-sponsored religious observances? What are the reasons for a rule that government cannot even persuade about religion, cannot engage in religious observances, and cannot put up religious symbols, even if it’s not coercing anybody?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will begin my response by saying that if I had to give up one of the rights in the First Amendment, this is the one I would give up. A rule against government persuasion or influence is less critical than a rule against government coercion. In terms of history, in terms of comparative law, and in terms of what the rest of the world does, the Establishment Clause is an extraordinary protection. We would probably still be a free society without it. But I at least would mourn the loss. Repeal of our protection against religious persuasion by government would be a serious loss for reasons that have already been mentioned by other speakers at this conference. I review those reasons briefly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First is the harm it would bring to religious minorities, those whose faith will not be the one that the government observes and whose symbols will not be displayed. These minorities include nonbelievers—atheists, agnostics, and the wholly indifferent—but also believers in the extraordinary array of minority faiths in this country. Justice O’Connor described this harm in principle, although she can never recognize it when she sees it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.39.20",
      "id": "ft39.20"
    }
  }, [_vm._v("20")])]), _vm._v(" Government observance of the majority religion does indeed tell religious minorities that they are outsiders and not fully accepted members of the community.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Those who think government ought to be able to engage in religious rituals and display religious symbols might ask: “What is the problem? We see ideas that offend us all the time. Political dissenters who are seriously alienated from the policies of the Bush Administration are told that they are second class citizens in the same sense as offended religious minorities. If no one thinks it unconstitutional that the government lets political dissenters know it does not care about their views, what is so different about religion?” What’s different is that on matters of governmental policy, somebody has to decide. This polity has decided that it should be the majority, but it must inevitably be someone. The government "), _c('em', [_vm._v("must")]), _vm._v(" make decisions about political matters.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the case of religion, no one has to rule. There is no need for the government to make decisions about Christian rituals versus Jewish rituals versus no religious rituals at all. For government to make that choice is simply a gratuitous statement about the kind of people we really are. By making such statements, the government says the real American religion is watered-down Christianity, and everybody else is a little bit un-American.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is also relevant here that people suffer more when you take away something they have come to think of as their own than if you never give it to them in the first place. After forty years of telling religious minorities in this country that it is part of their rights that the government will not engage in school prayer and in public religious observance, the harm of overruling all those cases at this point would be more severe than if the issue had been decided the other way from the beginning.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("The other set of harms from noncoercive establishments is to the religious majority. It is not good for religion to have government engaged in religious rituals. Government by its sheer size and prominence will have a disproportionate influence on the kinds of rituals that are exercised and on public perception of what are appropriate rituals. The result will not be pretty. Government-sponsored religion is theologically and liturgically thin. It is politically compliant. It is supportive of incumbent administrations. In intolerant communities, it inevitably tends to impose the majority’s forms, rituals, and terminology on everybody. In tolerant communities, efforts to be all-inclusive inevitably lead to desacralization, to the least common denominator, to a secular Incarnation with plastic reindeer, to Christmas and Chanukah mushed together as the Winter Holidays."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.40.21",
      "id": "ft40.21"
    }
  }, [_vm._v("21")]), _vm._v(" By stripping all the "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("specific elements of different faiths and denominations and attempting to keep only the common elements that all faiths share, tolerant governments produce a mishmash that no faith can accept or believe in. It has always been a great puzzle to me why certain elements of the religious community invest so much effort in demanding that government model bad religion in this way. There are serious costs to these government religious observances.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Finally, it is occasionally suggested that the Establishment Clause helps keep religion out of politics. Simply put, that is nonsense. As history clearly demonstrates, religion is always a part of politics. I think Daniel Conkle offered more or less the right distinction."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.41.22",
      "id": "ft41.22"
    }
  }, [_vm._v("22")]), _vm._v(" What the Establishment Clause separates from government is theology, worship, and ritual, the aspects of religion that relate only to things outside the jurisdiction of government. Questions of morality, of right conduct, of proper treatment of our fellow humans, are questions to which both church and state have historically spoken. They are questions within the jurisdiction of both. In a democratic society, the state will ultimately decide these questions at least to the extent of deciding what conduct will be subject to legal sanctions. But these are also questions on which churches are absolutely entitled to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For better or worse, churches always have spoken on these issues. Those who think that religion and religious believers should be kept out of politics should reflect on abolition. Those who think that there are no risks of religion intruding into politics should meditate on Prohibition. There are good stories and bad stories about religious views and about religious participation in politics. The bad stories are about intolerance and failure to accommodate differing views in a pluralistic society; but there are equally bad stories about secular movements of all sorts. In a society where David Duke can be taken seriously as a candidate for President, I am not uniquely or especially worried about religious participation in politics.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.4.1"
    }
  }, [_c('strong', [_vm._v("Questions and Answers to Panel 5")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Mary Mitchell (Indiana University Law School):")]), _vm._v(" I am extremely interested in Professor Kay’s list of noncoercive injuries. And I would like to pick up Professor Laycock’s point and be sure that his point gets added to your list; there is a very important kind of noncoercive injury that comes when government tries to persuade people. I don’t look on that as a lightweight kind of harm, because another way of saying “persuasion” is “indoctrination.” And, especially "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("in the arena of the public schools, I believe that type of injury becomes a very serious kind of injury.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("Engel")]), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.42.23",
      "id": "ft42.23"
    }
  }, [_vm._v("23")]), _vm._v(" and "), _c('em', [_vm._v("Schempp")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.42.24",
      "id": "ft42.24"
    }
  }, [_vm._v("24")])]), _vm._v(" the Supreme Court cases dealing with prayer and Bible reading in the schools, the Supreme Court justices made a point of saying that they did not consider this kind of activity coercive. So presumably there would not be a Free Exercise Clause issue there. And if coercion is also required to show an Establishment Clause violation, then there would not be protection against this kind of harm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I think we keep assuming, when we talk about injuries that the Establishment Clause can cause, that we have two kinds of people: we have the people whose religion is favored and those whose religion is disfavored. And those whose religion is favored, the harm to them is maybe dilution or weakening of their religion; for others, the harm is offense to them or humiliation or the communication of a message that they’re outsiders. But it seems to me that we have another class of people, and those are the uncommitted. And especially children who have not yet made their decision. And in our society where religious choices are so fluid, people do change opinions. So it seems to me there is harm in government attempting to influence the religious decision at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And if we do not call that coercive, it is the kind of harm that is hard to detect; it is one of those harms that the more severe it is, the harder it is to detect. How do parents know how their children are being indoctrinated? How do you measure that? And that is another reason why, when you say: “Well, maybe it’s not so bad in England; we just have this little problem in the schools,” to me it looms very large. I just want to be sure that gets added to the list of noncoercive injuries. You might even want to call that a form of coercion; and that may bear on what we mean by religious freedom: we mean freedom to influence our own children, not let the government do that.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Richard Kay (University of Connecticut Law School):")]), _vm._v(" There is little to disagree with in what you said. If we have a difference, I suppose it is a classification question; it is just a quibble. As to the kind of harm that arises when government attempts to persuade, I think we can, I can break it down into two different kinds of injuries. On the one hand there is, as you said, the persuasion which becomes indoctrination, which I would then essentially assimilate under the idea of coercion. And I think the prayer cases really could very easily be understood as coercion. And I have not read the cases in a while but I "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("thought that, in discussing the effect of the opting out part of the laws in those cases, that coercion—indirect coercion—was an element of the decisions. And, insofar as we find no coercive influence, then I think it would fall under one of the other categories that I mentioned and that Professor Laycock mentioned about the other affronts which that kind of a speech can effect. But as I say, this is just a question of your category and mine; in substance, I agree.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Mark Tushnet (then of Georgetown University Law School, later of Harvard University Law School):")]), _vm._v(" This picks up on something Professor Laycock said, and also that came up earlier. It is something I have been campaigning unsuccessfully about; but I should try it again. It is the argument that: “Why not try it twice rather than once?” Or in Professor Hartigan’s version: “I give up on one of the branches of government.” The presentations of that argument are always one-sided in giving the necessary cost/benefit analysis. The analysis goes, the cost of giving judicial review up is that you are relinquishing the chance of getting another institution to consider this. What harm can come from that? And occasionally benefit can come.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("There is a harm that can come from having judicial review. As my comment indicates, legislatures can act mindlessly; courts have to explain what they’re doing. In Oregon, the imposition of the requirement on the Native Americans was mindless; it communicated nothing about the society’s view of their practice. Justice O’Connor writes an opinion explaining why, while we sort of regret that we have to do this to you, the imperatives of the war on drugs are so great as to overcome this burden that we are placing on your religion."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.43.25",
      "id": "ft43.25"
    }
  }, [_vm._v("25")]), _vm._v(" Or even worse in "), _c('em', [_vm._v("Lyng")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.43.26",
      "id": "ft43.26"
    }
  }, [_vm._v("26")])]), _vm._v(" where the acknowledgement of the harm to the religious interests is even more direct.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Similarly, it seems to me not irrelevant that Professor Laycock says: “Justice O’Connor has the right test, but she never knows it when she sees it.” The origins of the endorsement test are in her opinion in "), _c('em', [_vm._v("Lynch v. Donnelly.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.43.27",
      "id": "ft43.27"
    }
  }, [_vm._v("27")])]), _vm._v(" I do not need a Supreme Court Justice to get up there, using the authority of my government, to say I am unreasonable in believing that a nativity scene communicates a message of exclusion. She makes us think that a reasonable Jew would not regard the communication as a message of exclusion. But who is she to tell me that sort of thing? Given who the Justices are likely to be, the chance of their articulating bad things about religion when they do the balancing "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("is pretty high, and that is a cost that has to be factored into this overall balance of the costs and benefits of judicial review.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" I agree that some of the things the Court says are outrageous, and its opinions can sometimes do real harm by giving prominence and legitimacy to repressive or offensive views on these issues. I am not sure you can eliminate that. You can make that cost greater or smaller, but you can not get rid of it by simply saying: Let’s get the Court out of this business. Cases are going to be filed; and then, in the cases where they get out of the business, they are going to say some outrageous things. And then in subsequent cases looking for exceptions and loopholes and trying to chip away at it, they are going to say some more outrageous things. Trying to get out of these cases in "), _c('em', [_vm._v("Smith")]), _vm._v(", the Court in effect said it is open season on religious minorities, and a lot of lawyers for political actors are reading it exactly that way. Nothing they could say in the course of entertaining a claim and then rejecting it would hurt worse than that.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("I do not have a whole lot of confidence in courts. But I have considerably more confidence in courts than in local legislators and city councils. There have been religious persecutions in this country. There are localized persecutions right now. I am representing some of those people. We have not gotten any of them off yet, although we have gotten some judgments delayed, and we may accomplish something more permanent. I can at least say the Hare Krishnas are going to have a temple to worship in for two years longer than they would have if we had not had a federal appeal to take."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.44.28",
      "id": "ft44.28"
    }
  }, [_vm._v("28")]), _vm._v(" Some of these cases will be won, but many of them will be lost. There have been periods in the past when a larger percentage of these cases were won.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even if the record of the courts is not all that good, there is no reason whatever in my view to think that, on average, unpopular minorities will do better with legislators than they will do with courts. That may just be an empirical disagreement between the two of us.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Daniel O. Conkle (Indiana University Law School):")]), _vm._v(" If I could add one comment. There are not just legislators and there are not just federal courts; there are state courts. And although the state courts are not overwhelmingly—for "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("example, on the "), _c('em', [_vm._v("Smith")]), _vm._v(" free exercise issues—moving away from the United States Supreme Court, some are."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.45.29",
      "id": "ft45.29"
    }
  }, [_vm._v("29")]), _vm._v(" So there is a path where you have—depending on the way that they are elected or whether they are appointed—at least somewhat politically detached judges at the state court level who may have different views from the current Supreme Court.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("William P. Marshall (then of Case Western University Law School, later of the University of North Carolina Law School):")]), _vm._v(" Professor Laycock, not surprisingly my question is to you. I want to make my position clear if I did not before, that I do not believe the Establishment Clause stands for the proposition that religion can not get involved in political issues. If in fact it did, it would come in conflict with the Free Speech Clause which would demand that the religious values be infused by whoever wants to infuse them into the public dialogue. What I see the Establishment Clause standing for—or actually not the Establishment Clause but this privatization theory—is that there should be a legitimate rhetorical objection to be made when religion comes into the public square. Now, if religion wants to recognize this objection and then say: “Okay, we recognize this but we really need to come in here because this is important!” as it frequently has in our political history, then so be it. I was not going to comment on this, because I thought it was fairly obvious what our differences were, but you brought up the David Duke campaign, and as long as you did, that is the perfect example. The man ran on the idea of bringing Christian principles back into government. And he did not mask that; he masked his racism, but he said outwardly: “This is just putting Christian values back into government.” I want the rhetorical response still to be available when that kind of campaigning takes place. I do not want this objection eliminated as a matter of constitutional theory. In short, I think it is appropriate that, when religion is used in that sort of way, that it is a legitimate criticism to say that religion has got no place coming into the public square through this kind of interplay. And I just want your response to that.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" “Religion has no place coming into the public square,” and “Religion has no place coming into the public square in this kind of interplay,” are profoundly different statements. I do not know what you mean by “this kind of interplay.” And I suspect it would take us a lot of exchanges to work that all out. But what “in this kind of interplay” adds is: There can be "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("good ways and bad ways, and we have to do something about the bad ways. I do not disagree with that.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("But when you say, “Religion has no business coming into the public square,” I hear you making the Bruce Ackerman argument that this is a state in which religious values cannot be considered and should not be spoken out loud."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.46.30",
      "id": "ft46.30"
    }
  }, [_vm._v("30")]), _vm._v(" I think that is preposterous. You say you do not mean that, but that is what I hear without the qualifier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With respect to the particular example of Duke, I think the response that he drew from many religious leaders is far more effective as a political matter than your response: “This isn’t Christianity. You are a racist, Nazi phony trying to invoke the symbols and language of Christianity; and that is not what our religion teaches. This is not real Christianity.” Simply as a political matter, you’re going to persuade more people with the religious response than with the secularist response.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("William P. Marshall:")]), _vm._v(" Maybe, if you are fortunate enough to be able to get that response in those particular circumstances. Now, you have pointed out the supposed inconsistency in what I seem to be saying. But if I may point back, if you admit that there is some legitimate concern with religious involvement in the public square, then you must recognize that there is a problem.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" I think there are good arguments and bad arguments, right. And there are good and bad religious arguments, and there are good and bad secular arguments. When the Catholic bishops teach on social justice, I like what I hear although I think they may go a little too far; when they teach on abortion, I say I disagree. But I do not think their arguments are any more or less acceptable in the public sector depending on whether I agree with them or not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now, it may be that what you were principally thinking about is something I am hardly thinking about at all, which is people who say: “Everyone should vote for candidate X or you’ll go to hell.” Right? All right, if that’s what you’re concerned about, I agree with you. That is an inappropriate form of argument; it is not an argument we hear much; it is not an argument that is very effective in a pluralistic society. I don’t disagree, but I think it is such a "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("tiny slice of religious arguments that I … if you are confined to that, then I think you have to single that out and say that is what you mean.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What I hear you saying and Ackerman saying is that it is illegitimate to appeal to the religious basis of moral values. It is illegitimate to say: “One reason for putting more money into welfare programs is the Sermon on the Mount and the values that are expressed there.” No, that argument I find preposterous. And no caution flag goes up for me when I hear somebody make that argument from the Sermon on the Mount.")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('strong', [_vm._v("Keith Pavlischek:")]), _vm._v(" I wanted to get at an Establishment Clause hypothetical by addressing the education issue. As Professor Gilles said, on the one hand, you have the English situation in which there is direct funding of religious schools, which clearly would not—and, I think, should not—pass the establishment test. But on the other hand, in our country we have a situation in which many people argue the educational system has, in effect, served the sociological purpose that the church once did; so now it is the focal point of unity. To the point that, now, many evangelicals and fundamentalists feel the way Catholics did in the 1840s and 1850s when Protestants told them they were having a neutral public educational system."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.47.31",
      "id": "ft47.31"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And so on the one hand, you have the idea of direct funding of private education, which wouldn’t work. On the other hand, you have a situation in which many people cannot feel comfortable in putting their kids into the public school system because it promotes an ethos which is contrary to some of their deepest religious convictions or sometimes perceived as an antagonistic ethos to their deepest convictions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now, the alternatives that are increasingly gaining currency are voucher-type schemes in which the arguments are: “Well, funding will go not to the schools, as in England, and they won’t go directly into a governmental school system; but rather they’ll go to the parents of the school children, who can opt for the type of education they wish.” And the argument would be that that would go to Jewish parents and fundamentalist parents and Missouri Synod Lutheran parents and Catholic parents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now, my question is: Do you believe that that type of funding—and I think we’re going to see it within the next ten or fifteen years; I mean, it is going to happen, and I would expect it is going to be litigated, perhaps under the Establishment Clause—do any of you have any beliefs about whether that type of scheme would be a violation of the Establishment Clause? Because, although it is nondiscriminatory, nevertheless I guess Jewish people "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("would set up Jewish schools and Marxists perhaps—if they can get together—would set up Marxist schools and fundamentalists would set up their fundamentalist schools.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('strong', [_vm._v("Daniel O. Conkle:")]), _vm._v(" If you’re asking what the United States Supreme Court would rule, my belief would be that the Supreme Court—depending on how the program was structured—would probably approve it. It is not entirely clear from what the Supreme Court has previously decided. But I think it is likely, given the direction the Court has taken in previous cases—particularly "), _c('em', [_vm._v("Bowen v. Kendrick")]), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.48.32",
      "id": "ft48.32"
    }
  }, [_vm._v("32")]), _vm._v(" and some of the earlier parochial aid cases that approved tax deductions and credits for parents, primarily for parents, who sent their kids to religious schools. It seems to me that the Court probably would approve it. Whether it would run into state constitutional problems would be a separate issue, and the policy wisdom of vouchers, I think, is a separate issue that I am not really prepared to comment on.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" It would run into state constitutional problems because nearly all the state constitutions have much more explicit provisions, enacted during a wave of nineteenth-century anti-Catholicism, that expressly talk about funds to sectarian schools while preserving Protestant devotional services in the public schools."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.48.33",
      "id": "ft48.33"
    }
  }, [_vm._v("33")])]), _vm._v(" So it might not be sufficient for the United States Supreme Court to say vouchers are okay. It might also have to say vouchers are constitutionally required, which no court is likely to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On the underlying policy matter, I part with most other separationists here. I would not allow the Christmas tree; I think it is an establishment. But I would allow a voucher scheme if it were implemented in a way that avoids the kinds of unfairness that Professor Gilles described in the English system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The existing system is a classic unconstitutional condition. The state says to these people: “You have a constitutional right to a private, religiously-affiliated education or you have a state constitutional right to a free education, but you can’t have both. You have to choose. And if you want the religious education, you forfeit the $2000 or the $4000 that the state is otherwise willing to spend on educating your child.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If you want to think through the arguments about that, read Professor "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("McConnell’s article on school funding and abortion funding."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.49.34",
      "id": "ft49.34"
    }
  }, [_vm._v("34")]), _vm._v(" There is hardly anybody in the country with a consistent position on those two issues. The pro-choice people tell us it is an unconstitutional condition not to fund abortions for poor women, but it would be an establishment to fund religious education for poor children. Those two positions do not fit together. Funding cannot be a forbidden subsidy for education but a required part of the constitutional right for abortion. The political right is equally inconsistent. These issues are very hard, and few of us have thought through them all the way.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Susan Gilles (Capital University Law School):")]), _vm._v(" I would like to address this issue from an English point of view. I think you described two different schemes. One is an opt-out scheme for those with (I presume you would say) conscientious objections, as well as religious-based objections.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Keith Pavlischek:")]), _vm._v(" I would say for any reason whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Susan Gilles:")]), _vm._v(" For any ideological reason.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Keith Pavlischek:")]), _vm._v(" Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Susan Gilles:")]), _vm._v(" If you do that, I do not think you walk into establishment problems and you avoid the British problem of defining what qualifies as a religion. But I do want to emphasize, having grown up in a system which does separate school children based on religion, you would have a cost there. You would have a loss of understanding of other religions. And one way to fix it, which is part of the British idea, is to have compulsory religious education so everybody understands everybody else’s religion. If you are going to opt everyone out, are you going to require people to understand others’ religion as part of the tolerance which we expect in the United States?")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Stanley Ingber (Drake University Law School):")]), _vm._v(" I would like to pick up on something that Professor Laycock said at the very beginning of his talk, in which he mentioned that the two clauses, the two Religion Clauses, should be interpreted as mutually supporting and interrelating. I would like to then deal with that in terms of some of the things that Professor Bradley said in the panel before, and the implications for the Establishment Clause of the "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('em', [_vm._v("Smith")]), _vm._v(" decision and what happened in the free exercise scenario. And I would be pleased if someone could show me how the scenario that I am about to describe is wrong, because this is how I see it progressing.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("We have Justice Scalia fairly adamantly decrying the confusion in the religion field—the seeming schizophrenia, the uncertainty of doctrine, the confusion in this area. And there is an attempt to sort of simplify this all, partially, in "), _c('em', [_vm._v("Smith.")]), _vm._v(" At the same time, we see him joining Justice Rehnquist’s decision in "), _c('em', [_vm._v("Jaffree")]), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.50.35",
      "id": "ft50.35"
    }
  }, [_vm._v("35")]), _vm._v(" on the Establishment Clause, trying to, in essence, simplify the history of the Establishment Clause and holding it to that history. And he says—this is Rehnquist—in its most simplified form, as we infuse meaning into the Establishment Clause, it means that there should not be a single national established church or there shall not be political discrimination among the sects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Then you see "), _c('em', [_vm._v("Smith")]), _vm._v(", which says, “No constitutionally compelled accommodations, but individual legislators can make separate accommodations as they see fit.” And if it affects some religions differently than others, that is the way the political cookie crumbles. And so you would have a situation, for example, where there would be an exemption for the use of wine for ritual sacraments, but maybe not for the use of peyote for religious sacraments. That would seem to me to fall into the very limited description, the historical description, of the Establishment Clause set up in the "), _c('em', [_vm._v("Jaffree")]), _vm._v(" decision—discrimination between sects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consequently, what I find is that even to avoid the schizophrenia and the confusion, the simple historical description of the Establishment Clause needs to be rejected for "), _c('em', [_vm._v("Smith")]), _vm._v(" to be able to be sustained. Otherwise, we continue with the same confusion that Scalia was talking about. No preference among sects must be rejected; and we need to move to a situation where coercion—which is basically the same type of thing as the Free Exercise Clause—coercion becomes the rule for the Establishment Clause. Because otherwise, even in this very limited historical perspective of the Establishment Clause, "), _c('em', [_vm._v("Smith")]), _vm._v(" becomes just as subject to the difficulties that Scalia is trying to avoid as the earlier jurisprudence was.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" I think you’re clearly right that, under the regime of "), _c('em', [_vm._v("Smith")]), _vm._v(", some religions will be allowed to practice either because their practices are "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("not forbidden by a majoritarian legislature in the first place or because they secure exemptions. You are right that other religions with seemingly analogous and indistinguishable practices will fall within the statute and will not get exemptions and will not be allowed to practice. The Court is going to have to deal with that and it is going to be messy.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The realist in me says they will deal with it largely by denying the problem; they will always find that the two cases are distinguishable and there really isn’t any discrimination. But they’ve got that problem under free exercise and under equal protection as well as under establishment. And certainly the victimized religion whose practice is prohibited is being coerced; so cutting the Establishment Clause back to coercion does not help solve the Court’s problem. So I guess I do not see how the Establishment Clause plays into your question.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("But I think the problem is a very real one; and there are going to be cases about it. One of the cases I am involved in at the moment is one of the ones I had in mind when I said there are localized persecutions going on: the set of ordinances in Hialeah that are carefully drafted to protect Kosher ritual slaughter but to outlaw Santeria ritual sacrifice of small animals. The lower courts were wholly uninterested in the rather obvious discrimination; I was surprised when the Supreme Court said it might be interested."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.51.36",
      "id": "ft51.36"
    }
  }, [_vm._v("36")]), _vm._v(" But "), _c('em', [_vm._v("Smith")]), _vm._v(" produces that kind of problem: accepted groups get exemptions and unaccepted groups do not.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Steve Green (then at Vermont Law School, now at Willamette Law School):")]), _vm._v(" I guess this question is probably for Professor Laycock, too. To what extent are you concerned about the expropriation of government by religious organizations and then the acquiescence of the governmental entity to that expropriation under the noncoercive level that you were talking about?")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" “Expropriation” meaning what?")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Steve Green:")]), _vm._v(" The expropriation of governmental symbols or governmental approval. The claims by religious entities that they have certain governmental blessings, either subtly or explicitly. And then the concomitant actions or inaction by government against that. And that could be in the form of what Jerry Falwell used to do. It could be in the form of a religious entity attempting "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("to put up a symbol on a public forum in front of a governmental office or whatever. And then the government not doing anything to counter the impression that may come about by that.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" Okay. One question that I have never thought about, and one that I have. So let me talk about the second one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The private placement of religious symbols on the public square seems to me a fairly straightforward public forum problem, although it has not been treated that way. If the government lets lots of groups put up symbols there, then certainly religious groups ought to be included. And I think the better policy is, the government ought to let lots of groups set up symbols in some appropriate place in the community. And I think if we did that, a whole lot of this creche litigation would be solved. There is no reason for the city government to put it up if the association of churches can put it up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The other problem—the televangelist flying the flag and interweaving patriotism and religion—is not one I have ever thought about. Although I guess my instinct is: it is demeaning to religion, but there are a lot of bad religions out there and there is not much the government can or should do about it. Lots of secular groups do the same sort of thing. It is probably protected by the Speech Clause and the Free Exercise Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Jeanne Swantko:")]), _vm._v(" I’m not sure if this rises to the level of a question or just an expression of a concern. But I will state it, and I guess anyone on the panel can respond if they want to. It is related to what the previous questioner asked about the standard in "), _c('em', [_vm._v("Smith")]), _vm._v(" where Justice Scalia says, “If the locals pass a law and it incidentally infringes on your religion, basically it’s too bad for you because that wasn’t the intent of it.” So you have that standard emerging from the Court on the one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And then, I will use for an example something that Dean Gaffney said earlier, when he described the law school association that passed a regulation that said you had to not discriminate in hiring against anyone because of their sexual preference; and this impacted on religious law schools who see homosexuality as a violation of a basic tenet of their faith.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Now, I guess I’m trying to see how those two things can be reconciled. And from my own perspective as a parent in a community in a minority religion, I have concerns as to how the oftentimes state-sponsored legislation—which has a sort of common denominator element to it—impacts on me and the way that I want to raise my children when the defense that can be given is: “The state legislature passed it; so if it impacts on your religion, it’s too bad,” even when it goes to something fundamental. But I want to issue to ")]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("lawyers a challenge. When preparing briefs and doing litigation, I think there has to be some foresight to suggest remedies to judges and courts that somehow make common sense and provide a right way of reasoning to go forward from here. That makes a way for the court to—if you want to say—do the right thing. Violating one side against the other as little as possible. But I guess I would like to know if anybody has any response to my concern.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Daniel O. Conkle:")]), _vm._v(" I share your concern. And I guess that my only point is to state again that I think, at least for the United States Supreme Court and other federal courts, I am very pessimistic as to whether these kinds of claims will be taken seriously in the foreseeable future. The other avenues of appeal are state courts and trying to sensitize and educate legislators and local decisionmakers. I do not know that that will be successful.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Douglas Laycock:")]), _vm._v(" Scalia’s quite clear: it does not matter how central or fundamental the religious obligation is. And keep in mind the facts in "), _c('em', [_vm._v("Smith.")]), _vm._v(" This is a worship service. Suppression of a worship service raises no issue under the Constitution of the United States and requires no justification. That is the law of the land at the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Richard Kay:")]), _vm._v(" I would like to add to that, so that we do not leave with the wrong impression, that the result of that decision is not that there can be no religious exemptions. As Professor Conkle just pointed out, there are alternative avenues to pursue, both constitutional in terms of state systems, and in terms of political redress. Now, that might not avoid what we regard as an injustice in every case. But it is not the situation that, by this opinion, all religious exemption was eliminated.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft34.1",
      "id": "fn.34.1"
    }
  }, [_vm._v("1")]), _vm._v(". See, e.g., T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOMS")]), _vm._v(": C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASSAGE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MENDMENT")]), _vm._v(" 134–37, 141, 143–46, 148–51, 156–57, 163–77, 179–83, 185–89, 195, 198–99, 216–17 (1986); Michael W. McConnell, "), _c('em', [_vm._v("The Origins and Historical Understanding of Free Exercise of Religion")]), _vm._v(", 103 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1409, 1436–43 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft34.2",
      "id": "fn.34.2"
    }
  }, [_vm._v("2")]), _vm._v(". Madison’s "), _c('em', [_vm._v("Memorial and Remonstrance Against Religious Assessments")]), _vm._v(" was circulated in 1785 in response to the general assessment bill then pending in the Virginia legislature. The bill and "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v(" are reprinted in an appendix to "), _c('em', [_vm._v("Everson v. Board of Education")]), _vm._v(", 330 U.S. 1, 63–74 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft35.3",
      "id": "fn.35.3"
    }
  }, [_vm._v("3")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" A. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTLAND")]), _vm._v(", J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUNDING")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATHER")]), _vm._v(" 44–49 (1987); C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.34.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 198–99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft35.4",
      "id": "fn.35.4"
    }
  }, [_vm._v("4")]), _vm._v(". Susan M. Gilles, "), _c('em', [_vm._v("“Worldly Corruptions” and “Ecclesiastical Depredations”: How Bad Is An Established Church")]), _vm._v(", 42 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 349 (1992).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft35.5",
      "id": "fn.35.5"
    }
  }, [_vm._v("5")]), _vm._v(". Richard S. Kay, "), _c('em', [_vm._v("The Canadian Constitution and the Dangers of Establishment")]), _vm._v(", 42 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 361 (1992).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft36.6",
      "id": "fn.36.6"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Late Corp. of the Church of Jesus Christ of Latter-Day Saints v. United States, 136 U.S. 1 (1890); Davis v. Beason, 133 U.S. 333 (1890); Reynolds v. United States, 98 U.S. 145 (1878).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft36.7",
      "id": "fn.36.7"
    }
  }, [_vm._v("7")]), _vm._v(". The Jehovah’s Witness cases are collected in Douglas Laycock, "), _c('em', [_vm._v("A Survey of Religious Liberty in the United States")]), _vm._v(", 42 O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIO")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 409, 419–20 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft36.8",
      "id": "fn.36.8"
    }
  }, [_vm._v("8")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Wisconsin v. Yoder, 406 U.S. 205 (1972).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft36.9",
      "id": "fn.36.9"
    }
  }, [_vm._v("9")]), _vm._v(". T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" E. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCKLEY")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVOLUTIONARY")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRGINIA")]), _vm._v(", 1776–87, at 36 (1977).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft36.10",
      "id": "fn.36.10"
    }
  }, [_vm._v("10")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.34.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 135–36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft36.11",
      "id": "fn.36.11"
    }
  }, [_vm._v("11")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 136.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft36.12",
      "id": "fn.36.12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 147, 217.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft37.13",
      "id": "fn.37.13"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Tilton v. Richardson, 403 U.S. 672, 689 (1971) (rejecting a free exercise challenge to tax support for religious schools, on ground that paying taxes to support another religion did not violate any practice or exercise of plaintiff’s religion); "), _c('em', [_vm._v("cf.")]), _vm._v(" United States v. Lee, 455 U.S. 252 (1982) (rejecting a free exercise challenge to use of tax money to support the Social Security system, which "), _c('em', [_vm._v("did")]), _vm._v(" violate the Amish plaintiffs’ religious tenets against participation in public insurance programs, on the ground that the government’s interest in collecting taxes was compelling); Flast v. Cohen, 392 U.S. 83, 103–04 (1968) (holding that the Establishment Clause is exception to the general rule of no standing for taxpayers to challenge government expenditures, and that this clause operates as a specific constitutional limitation upon Congressional taxing and spending powers; there is no similar holding under the Free Exercise Clause).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft37.14",
      "id": "fn.37.14"
    }
  }, [_vm._v("14")]), _vm._v(". For an analysis of this possible distinction, see Michael W. McConnell, "), _c('em', [_vm._v("The Selective Funding Problem: Abortion and Religious Schools")]), _vm._v(", 104 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 989 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_vm._v("["), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft1.AST",
      "id": "fn.1.AST"
    }
  }, [_vm._v("*")]), _vm._v("I did not know it at the time, but that rule had been held unconstitutional in "), _c('em', [_vm._v("Anderson v. Laird")]), _vm._v(", 466 F.2d 283 (D.C. Cir. 1972). Students at the academies may feel some pressure to attend services, but I am not aware of allegations that any of the academies have openly violated this decision. My information was seriously out of date, and for a collateral illustration in an informal talk, I made the mistake of not checking.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft38.15",
      "id": "fn.38.15"
    }
  }, [_vm._v("15")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872 (1990) (holding that there is no constitutional right to exemption from facially neutral and generally applicable laws that prohibit religious practices).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft38.16",
      "id": "fn.38.16"
    }
  }, [_vm._v("16")]), _vm._v(". Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378, 391–92 (1990). "), _c('em', [_vm._v("See also")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("The Remnants of Free Exercise")]), _vm._v(", 1990 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 23–28 (analyzing this part of the "), _c('em', [_vm._v("Swaggart")]), _vm._v(" opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft38.17",
      "id": "fn.38.17"
    }
  }, [_vm._v("17")]), _vm._v(". 366 U.S. 599 (1961) (holding that a Sunday closing law did not violate the free exercise rights of an Orthodox Jewish merchant where religion required him to close on Saturday and law required him to close on Sunday).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft39.18",
      "id": "fn.39.18"
    }
  }, [_vm._v("18")]), _vm._v(". Daniel O. Conkle, "), _c('em', [_vm._v("God Loveth Adverbs")]), _vm._v(", 42 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 339, 346 (1992).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft39.19",
      "id": "fn.39.19"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Lee v. Weisman, 505 U.S. 577, 592–96 (1992) (recognizing coercive pressure to participate in prayer at graduation ceremony), "), _c('em', [_vm._v("with id.")]), _vm._v(" at 640 (Scalia, J., dissenting) (recognizing coercion only if imposed “by force of law and threat of penalty”). For an analysis of why the majority has the more realistic understanding of coercion, see Douglas Laycock, "), _c('em', [_vm._v("“Noncoercive” Support for Religion: Another False Claim About the Establishment Clause")]), _vm._v(", 26 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 37, 67–68 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft39.20",
      "id": "fn.39.20"
    }
  }, [_vm._v("20")]), _vm._v(". See Lynch v. Donnelly, 465 U.S. 668, 688 (1984) (O’Connor, J., concurring) (concluding that a government endorsement of one religion sends a message of exclusion to others, but that a government display of a creche does not endorse Christianity).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft40.21",
      "id": "fn.40.21"
    }
  }, [_vm._v("21")]), _vm._v(". See County of Allegheny v. ACLU, Greater Pittsburgh Chapter, 492 U.S. 573, 616 (1990) (“[B]oth Christmas and Chanukah are part of the same winter-holiday season, which has attained a secular status in our society.”). For further analysis of the harm to religion, see Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.39.19"
    }
  }, [_vm._v("note 19")]), _vm._v(", at 61–65 (text at notes 154–64).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft41.22",
      "id": "fn.41.22"
    }
  }, [_vm._v("22")]), _vm._v(". Conkle, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.39.18"
    }
  }, [_vm._v("note 18")]), _vm._v(", at 345–46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft42.23",
      "id": "fn.42.23"
    }
  }, [_vm._v("23")]), _vm._v(". Engel v. Vitale, 370 U.S. 421 (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft42.24",
      "id": "fn.42.24"
    }
  }, [_vm._v("24")]), _vm._v(". Abington School Dist. v. Schempp, 374 U.S. 203 (1963).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft43.25",
      "id": "fn.43.25"
    }
  }, [_vm._v("25")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872, 903–07 (1990) (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft43.26",
      "id": "fn.43.26"
    }
  }, [_vm._v("26")]), _vm._v(". Lyng v. Northwest Indian Cemetery Protective Ass’n, 485 U.S. 439 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft43.27",
      "id": "fn.43.27"
    }
  }, [_vm._v("27")]), _vm._v(". 465 U.S. 668, 688, 690–94 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft44.28",
      "id": "fn.44.28"
    }
  }, [_vm._v("28")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" International Soc’y for Krishna Consciousness v. George, 499 U.S. 914 (1991), "), _c('em', [_vm._v("vacating and remanding")]), _vm._v(" 262 Cal. Rptr. 217 (Cal. App. 1989) (awarding a judgment of more than three million dollars, more than five million dollars with interest added, that would have been collected by judicial sale of all Krishna temples and monasteries. For the initial judgment on remand, see 4 Cal. Rptr. 2d 473 (Cal. App. 1992) (remanding for a new trial on punitive damages, and reinstating a judgment for $1,837,500 in compensatory damages).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft45.29",
      "id": "fn.45.29"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Donahue v. Fair Empl. & Housing Comm’n, 2 Cal. Rptr. 2d 32 (Cal. App. 1991), "), _c('em', [_vm._v("review granted")]), _vm._v(", 825 P.2d 766 (Cal. 1992); State v. Hershberger, 462 N.W.2d 393 (Minn. 1990). [Supreme Court review in "), _c('em', [_vm._v("Donahue")]), _vm._v(" was later dismissed.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft46.30",
      "id": "fn.46.30"
    }
  }, [_vm._v("30")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUCE")]), _vm._v(" A. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CKERMAN")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OCIAL")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USTICE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERAL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" (1980). I had thought that Kathleen Sullivan took this position, but she disclaims it in the published version of her paper. Kathleen M. Sullivan, "), _c('em', [_vm._v("Religion and Liberal Democracy")]), _vm._v(", 59 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 195, 196 (1992). Her position is far from clear; I think she says that religious believers can make their arguments but government can never act on them.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft47.31",
      "id": "fn.47.31"
    }
  }, [_vm._v("31")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IANE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVITCH")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARS")]), _vm._v(" (1974).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft48.32",
      "id": "fn.48.32"
    }
  }, [_vm._v("32")]), _vm._v(". 487 U.S. 589 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft48.33",
      "id": "fn.48.33"
    }
  }, [_vm._v("33")]), _vm._v(". For the history of these provisions, see 2 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSON")]), _vm._v(" P. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" 69–70 (1950); C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARL")]), _vm._v(" Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLMAN")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" §§ 62–66 at 75–80 (2d ed. 1933). For typical state provisions, "), _c('em', [_vm._v("see, e.g.")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". art. IX, § 8; I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAHO")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v("., art. IX, § 5; M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASS")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v("., art. XVIII, § 2; M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INN")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". art. XIII, § 2; N.H. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". pt. 2, art. 83; N.Y. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". art. XI, § 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft49.34",
      "id": "fn.49.34"
    }
  }, [_vm._v("34")]), _vm._v(". Michael W. McConnell, "), _c('em', [_vm._v("The Selective Funding Problem: Abortions and Religious Schools")]), _vm._v(", 104 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 989 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft50.35",
      "id": "fn.50.35"
    }
  }, [_vm._v("35")]), _vm._v(". Wallace v. Jaffree, 472 U.S. 38, 91–114 (1985) (Rehnquist, J., dissenting). Justice Scalia was not on the Court at the time of "), _c('em', [_vm._v("Jaffree")]), _vm._v(", but he appears to have endorsed at least the general thrust of Rehnquist’s dissent in that case. "), _c('em', [_vm._v("See")]), _vm._v(" Edwards v. Aguillard, 482 U.S. 578, 636 (Scalia, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ft51.36",
      "id": "fn.51.36"
    }
  }, [_vm._v("36")]), _vm._v(". Church of the Lukumi Babalu Aye, Inc. v. City of Hialeah, 723 F. Supp. 1467 (S.D. Fla. 1989), "), _c('em', [_vm._v("aff’d mem.")]), _vm._v(", 936 F.2d 586 (11th Cir. 1991), "), _c('em', [_vm._v("cert. granted")]), _vm._v(", 503 U.S. 935 (1992). [The Supreme Court later struck down the ordinances. 508 U.S. 520 (1993).]")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes-para"
  }, [_vm._v("This paper is based on oral remarks delivered at a conference sponsored by the Center for Church/State Studies, DePaul University College of Law, held on December 6 and 7, 1991.")])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "PT1.1.5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Religious Liberty as Liberty")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "para9"
  }, [_c('em', [_vm._v("7 Journal of Contemporary Legal Issues 313 (1996)")])]), _vm._v(" "), _c('p', {
    staticClass: "para4"
  }, [_c('em', [_vm._v("This article was part of a symposium in which leading church-state scholars were invited to set out their theory of how and why the Constitution protects religious liberty. It addresses such questions as why religious liberty is singled out for special constitutional protection, why nonbelievers must be included in that protection, and what the content of that protection should be. The theme is that the point of the Religion Clauses is not to protect religion as such, but rather, to protect liberty in matters of religion. This piece also tries to explain how different applications of substantive neutrality fit together, without falling into the trap of disaggregating neutrality or pleading for special interests. And it contains a rare discussion of my personal views on religion.")])]), _vm._v(" "), _c('p', {
    staticClass: "design"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.5.1"
    }
  }, [_c('strong', [_vm._v("I. The Fundamentals")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Religious liberty is first and foremost a guarantee of liberty. To be sure, the guarantee is of liberty within a specified domain; it is liberty with respect to religious choices and commitments. But religion is not guaranteed, and neither ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("is secularism—only liberty is guaranteed. Within the liberty guaranteed by the Religion Clauses, the free human beings who make up the sovereign People may experience a Great Awakening of Christianity, a mass conversion to Islam or New Age mysticism or any other faith, or an overwhelming swing to atheism. In the Supreme Court’s inelegant but accurate phrase, the state should neither advance nor inhibit religion."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.1",
      "id": "ft55.1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Religious liberty does not presuppose that God is good,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2",
      "id": "ft55.2"
    }
  }, [_vm._v("2")])]), _vm._v(" nor that faith is bad or subordinate to reason."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.3",
      "id": "ft55.3"
    }
  }, [_vm._v("3")])]), _vm._v(" These are equal and opposite errors. Religious liberty guarantees instead that each citizen in a free country may believe as he will about the existence and characteristics of God and about the role of faith.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Religious liberty does not constitute America as a Christian nation,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.4",
      "id": "ft55.4"
    }
  }, [_vm._v("4")])]), _vm._v(" nor does it establish a “secular public moral order.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.5",
      "id": "ft55.5"
    }
  }, [_vm._v("5")])]), _vm._v(" These too are equal and opposite errors. Each assumes that on the most fundamental religious questions, the Constitution has taken a position. But the core point of religious liberty is that the government does not take positions on religious questions—not in its daily administration, not in its laws, and not in its Constitution either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Religious liberty does not view religion as a good thing to be promoted, nor as a dangerous force to be contained. But people who view religion in each of these ways struggle to capture the Religion Clauses for their side. Each side claims that it won the late-twentieth-century culture wars and took over the government—two hundred years ago."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.6",
      "id": "ft55.6"
    }
  }, [_vm._v("6")])]), _vm._v(" These too are equal and opposite errors. What happened two hundred years ago is that conflict over theology, liturgy, and church governance was confined to the private sector, the federal government was declared a permanent neutral, and all factions were "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("given equal political rights and a guarantee of religious liberty no matter what faction took over the government. In 1868, these guarantees were extended to the states.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.5.2"
    }
  }, [_c('strong', [_vm._v("II. Why "), _c('em', [_vm._v("Religious")]), _vm._v(" Liberty?")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-t",
    attrs: {
      "id": "PT1.1.5.2.1"
    }
  }, [_c('strong', [_c('em', [_vm._v("A. The Problem of Reasons")])])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Contemporary scholars have puzzled over why the Constitution would specially protect religious liberty, as distinguished from liberty in other domains."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.56.7",
      "id": "ft56.7"
    }
  }, [_vm._v("7")]), _vm._v(" If one views religion as a silly superstition of no importance, or as a dangerous force that requires tight regulation, or as containing one fundamental and binding truth competing with many falsehoods that lead to individual and collective ruin—"), _c('em', [_vm._v("and")]), _vm._v(" if one fails to learn from history—then constitutional guarantees of religious liberty might indeed seem puzzling or even wrongheaded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even so, the why of religious liberty may not matter as much as is sometimes supposed. For whatever reason, the Constitution does give special protection to liberty in the domain of religion, and we cannot repudiate that decision without rejecting an essential feature of constitutionalism, rendering all constitutional rights vulnerable to repudiation if they go out of favor. “Because the Constitution says so, and because all our liberties depend on maintaining the authority of the Constitution’s guarantees,” should be sufficient reason to vigorously protect religious liberty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.56.8",
      "id": "ft56.8"
    }
  }, [_vm._v("8")])]), _vm._v(" We can work out the regime that maximizes liberty with respect to religious choices and commitments without agreeing on why our Constitution specially protects liberty in that domain. Of course it is more satisfying, and sometimes clarifying, to have a reason. And unfortunately, “because the Constitution says so” does not appear to be a sufficient reason to persuade many Americans to support a constitutional right unless they are also persuaded of the wisdom of the right at issue. But the search for underlying reasons is not easy. As great as are the difficulties "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("of identifying the originally intended "), _c('em', [_vm._v("meaning")]), _vm._v(" of a provision, it is even more difficult to identify the original "), _c('em', [_vm._v("reasons")]), _vm._v(", because supporters who agree on what a provision means can support it for quite different reasons.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("The incredible diversity of views represented in this symposium highlights the danger. If we are each permitted to characterize in global terms the dominant themes of the eighteenth century, or the dominant themes of the Constitution generally, or sound general policy toward religion, and then impose the resulting analysis on the Religion Clauses, anything can happen. Suzanna Sherry concludes that secular rationalists won the eighteenth-century political battles and dominated the drafting of the Constitution;"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.9",
      "id": "ft57.9"
    }
  }, [_vm._v("9")]), _vm._v(" Steven Smith concludes that the Protestants won;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.10",
      "id": "ft57.10"
    }
  }, [_vm._v("10")])]), _vm._v(" John Garvey concludes that at least those who believe in a benevolent God won."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.11",
      "id": "ft57.11"
    }
  }, [_vm._v("11")])]), _vm._v(" Professor Smith concludes that the clauses are only about federalism and are incoherent if applied to religious liberty;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.12",
      "id": "ft57.12"
    }
  }, [_vm._v("12")])]), _vm._v(" Professor Sherry concludes that the Religion Clauses are about religious liberty but are incoherent because contradictory, and that the Free Exercise Clause must be subordinated to the Establishment Clause."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.13",
      "id": "ft57.13"
    }
  }, [_vm._v("13")])]), _vm._v(" William Marshall proposes that the Free Exercise Clause is just a special case of the Free Speech Clause,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.14",
      "id": "ft57.14"
    }
  }, [_vm._v("14")])]), _vm._v(" leaving us to wonder whether any cases would be decided differently if the Free Exercise Clause were repealed; Abner Greene and Michael Perry struggle with the contrasting possibility that the Establishment Clause is an exception to the Free Speech Clause, so that religious speakers might have less free speech than secular speakers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.15",
      "id": "ft57.15"
    }
  }, [_vm._v("15")])]), _vm._v(" Only Greene, Perry, and Ira Lupu give sufficient attention to liberty and neutrality to get inside my conception of the ballpark."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.16",
      "id": "ft57.16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If I could confine all these people to the literal text of the Constitution, I suppose that they would somehow reach the same astonishing conclusions; "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("Maimon Schwarzschild’s paper implies as much."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.58.17",
      "id": "ft58.17"
    }
  }, [_vm._v("17")]), _vm._v(" But at least if we were confined to the text, readers could check authors’ claims without learning most of sociology, political science, epistemology, and religious and political history. Interpretations that obliterated or deeply discounted one of the two clauses would be immediately suspect, and there would be less material available to rationalize these suspicious results. If searching for reasons leads to this symposium, literalism is looking better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Searching for “the reason” has an extra difficulty with respect to religious liberty, because many people support religious liberty for reasons based in their views about religion. These conflicting views about religion cannot be imputed to the Constitution without abandoning the widely held intuition that part of the core content of religious liberty is that government may not adopt some religious beliefs and reject others. The Constitution cannot adopt a Baptist or Deist or Episcopal conception of religious liberty, at least not without deep paradox. Nor can the Constitution adopt a view of religion as idea or religion as identity;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.58.18",
      "id": "ft58.18"
    }
  }, [_vm._v("18")])]), _vm._v(" religion plainly includes both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Moreover, explanations of religious liberty based on beliefs about religion cannot possibly persuade persons who do not hold the same religious beliefs, and so these explanations have little ability to explain or maintain support for religious liberty. To those who do not share the relevant religious belief, “because my religion says so,” or “because the Founders’ religion said so,” is even less persuasive than “because the Constitution says so.” To explain the Religion Clauses as a Baptist or Deist or Episcopalian capture is to forfeit their credibility.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "PT1.1.5.2.2"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. The Religion-Neutral Case for Religious Liberty")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("An acceptable explanation of the Religion Clauses must make sense of the ratified text. For the reasons just given, the strongest such explanation would make sense of the ratified text without entailing commitments to any proposition about religious belief. On what theory would the Founders single out the domain of religious choice and commitment for a special guarantee of liberty? The answer seems to me obvious, and while it is not at all illogical, it depends far more on history than on logic. Three secular propositions are sufficient to justify a strong commitment to religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("First, in history that was recent to the American Founders, governmental attempts to suppress disapproved religious views had caused vast human suffering in Europe and in England"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.19",
      "id": "ft59.19"
    }
  }, [_vm._v("19")]), _vm._v(" and similar suffering on a smaller scale in the colonies that became the United States."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20",
      "id": "ft59.20"
    }
  }, [_vm._v("20")])]), _vm._v(" The conflict had continued for centuries without producing a victor capable of restoring peace by suppressing all opposition. This is prima facie reason to forever ban all such governmental efforts. Madison argued:")]), _vm._v(" "), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_vm._v("Torrents of blood have been spilt in the old world, by vain attempts of the secular arm to extinguish Religious discord, by proscribing all difference in Religious opinions. Time has at length revealed the true remedy. Every relaxation of narrow and rigorous policy, wherever it has been tried, has been found to assuage the disease. The American Theatre has exhibited proofs, that equal and complete liberty, if it does not wholly eradicate it, sufficiently destroys its malignant influence on the health and prosperity of the state."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.21",
      "id": "ft59.21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The negative goal is to minimize this conflict; the affirmative goal is to create a regime in which people of fundamentally different views about religion can live together in a peaceful and self-governing society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, beliefs about religion are often of extraordinary importance to the individual—important enough to die for, to suffer for, to rebel for, to emigrate for, to fight to control the government for. This is why governmental efforts to impose religious uniformity had been such bloody failures. But this is also an independent reason to leave religion to the people who care about it most, which is to say, to each individual and to the groups that individuals voluntarily form or join.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, beliefs at the heart of religion—beliefs about theology, liturgy, and church governance—are of little importance to the civil government. Failure to achieve religious uniformity had not led to failure of the state. By the time of the American founding, experience had revealed that people of quite different religious beliefs could be loyal citizens or subjects. The claim here is not that religious beliefs are "), _c('em', [_vm._v("wholly")]), _vm._v(" irrelevant to the government; it "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("may be that some religious beliefs are more conducive than others to behaviors the government legitimately seeks to encourage or require."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.22",
      "id": "ft60.22"
    }
  }, [_vm._v("22")]), _vm._v(" But this indirect and always debatable government interest in religious beliefs will never make religious beliefs as important to the government as to the individual (the second proposition), and experience showed that government could not impose the religious beliefs it wanted anyway (the first proposition).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This third proposition was the most controversial of the three, and some in the founding generation were not sure it applied to Catholics,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.23",
      "id": "ft60.23"
    }
  }, [_vm._v("23")])]), _vm._v(" or to the hypothetical atheists that occasionally appeared in their rhetoric."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.24",
      "id": "ft60.24"
    }
  }, [_vm._v("24")])]), _vm._v(" Some citizens today continue to believe that atheists are unreliable citizens and that decent government cannot survive without a critical mass of believers. But with increasing religious pluralism, longer experience, and the universalizing logic of legal principle, the law at least has made the point general. It is enough for the state to regulate behavior, not belief; to regulate conduct, not theology or liturgy or church governance. The state could enforce the murder laws in 1791 without agreeing on the proper mode of worship or the proper form of church governance; it can enforce the murder laws today without agreeing on the Ten Commandments, the Sermon on the Mount, the Kantian imperative, or the utilitarian calculus as the best explanation for those laws. It is a sufficient explanation that the People have enacted such a law through constitutional processes and that it violates no limitation on governmental authority enacted by the People through a more authoritative process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These three propositions are readily inferable from the history of failed governmental attempts to achieve religious uniformity. They are in no sense religious claims; they are testable against the facts of history and the experience of governments and citizens. They are equally accessible to believers and nonbelievers; they are consistent with the most profound belief and with the most profound skepticism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These three propositions are entirely neutral about the truth or value of any religious belief save one: the third proposition necessarily rejects any belief that the State should or must support religion. But that belief is rejected in the Establishment Clause itself, so it must necessarily be rejected in any justification for the Establishment Clause. Those who believe that religious "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("exercise requires the instruments of government, or that state support is essential or important to continued religious belief, are really arguing for repeal of the Establishment Clause or for its minimalist interpretation."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.25",
      "id": "ft61.25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These three propositions are entirely adequate to explain a special guarantee of religious liberty, in which religion is to be left as wholly to private choice and private commitment as anything can be."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.26",
      "id": "ft61.26"
    }
  }, [_vm._v("26")])]), _vm._v(" Once it is understood that government efforts to control religious belief create conflict and suffering, that they cannot succeed without the most extraordinary tyranny (and often not even then), any government will abandon such attempts if it is committed to liberty or even if it is committed only to utilitarian avoidance of human suffering. Once it is understood that religion is far more important to individuals than to the government, the same considerations of liberty and utility argue for leaving religion entirely to individuals and their voluntary groups.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "PT1.1.5.2.3"
    }
  }, [_c('strong', [_c('em', [_vm._v("C. Some Implications of These Reasons")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Most obviously and most powerfully, these three propositions argue for separating the coercive power of government from all questions of religion, so that no religion can invoke government’s coercive power and no government can coerce any religious act or belief.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These three propositions argue for presumptively extending this protection to religiously motivated behavior, because attempts to suppress religious behavior will lead to all the problems of conflict and suffering that religious liberty is designed to avoid, and because religious behavior is as likely as religious belief to be of extraordinary importance to individuals."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.27",
      "id": "ft61.27"
    }
  }, [_vm._v("27")])]), _vm._v(" This protection can be only presumptive; sometimes religiously motivated behavior will "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("be sufficiently important to the government to justify suppression. But that is a reason for something like the compelling interest exception; it is not a reason to tell people that they are free to believe their religions but not to practice them.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("The coercive powers of government include its powers to allocate money, licenses, privileges, and the like in discriminatory ways. The principle that government should not coerce religious beliefs or behaviors necessarily entails the proposition that government should not create incentives to change religious beliefs or behaviors—that government should be neutral with respect to religion in all its regulation, taxation, and spending. I have argued elsewhere that this goal is best achieved by substantive neutrality, defined in terms of minimizing government incentives to change religious behavior, and not by formal neutrality, defined as the mere absence of religious classifications:"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.62.28",
      "id": "ft62.28"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_vm._v("The Religion Clauses require government to minimize the extent to which it either encourages or discourages religious belief or disbelief, practice or nonpractice, observance or nonobservance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.62.29",
      "id": "ft62.29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In this formulation, autonomy and neutrality are mutually reinforcing elements of religious liberty:")]), _vm._v(" "), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_vm._v("Government must be neutral so that religious belief and practice can be free. The autonomy of religious belief and disbelief is maximized when government encouragement and discouragement is minimized."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.62.30",
      "id": "ft62.30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The case for extending this guarantee of neutrality to the noncoercive powers of government—for separating those powers too from all questions of religion—is weaker than the case for separating the coercive powers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.62.31",
      "id": "ft62.31"
    }
  }, [_vm._v("31")])]), _vm._v(" but I think the case is easily strong enough. Government should be entirely neutral in matters of religion even when it coerces no one. That is, government should not sponsor or endorse a church or any set of beliefs about religious questions, and it should not resolve or seek to influence disputes about religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My three propositions suggest several reasons for this commitment to neutrality. First, because beliefs about religion are so much more important "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("to individuals than to the government, individuals and their voluntary groups should be free to develop their own beliefs about religion without the distorting influence of government. Government influence interferes with a matter important to individuals, a matter that many individuals believe is sacred and to be ordered by God, with little gain to government if religious choices and commitments are generally unimportant to government.")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Second, because religious choices and commitments are so important to so many individuals, and because of the history of government efforts to suppress disapproved religions, many citizens will be highly sensitive to any hint that government disapproves of their religious beliefs or even that it prefers some other set of religious beliefs. This sensitivity is illustrated by fights over creches, public prayers, and conscientious objection today,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.63.32",
      "id": "ft63.32"
    }
  }, [_vm._v("32")]), _vm._v(" and by Baptist and Presbyterian complaints about remnants of recognition for the formally disestablished Episcopal Church in eighteenth-century Virginia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.63.33",
      "id": "ft63.33"
    }
  }, [_vm._v("33")])]), _vm._v(" Individuals and groups will fear that what starts with mere preference or disapproval will escalate to discrimination, suppression, or coerced participation in observances of the dominant religion. These fears gain substance from history, and also because the line between coercion and mere influence is easily crossed and hard to monitor or even define, as illustrated by Justice Kennedy’s unsuccessful struggle to articulate a coherent coercion standard."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.63.34",
      "id": "ft63.34"
    }
  }, [_vm._v("34")])]), _vm._v(" Government attempts to influence religious choices and commitments cause some of the harms of government coercion and threaten the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, these direct harms of noncoercive government influence have a corollary. If government is permitted to attempt to influence religious beliefs and commitments, each religious faction must necessarily seek to control or at least influence the government so that the faction’s members will be more benefited than harmed. Even if government is permitted only to express views about religion, religious factions will seek to control or influence the government so that they can control or influence the religious views that it "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("expresses. Individuals and groups will compete over which religions are respected and which are disrespected, over which can feel safe and which must fear more serious government hostility in the future. Even if this conflict is confined to peaceful political processes, it is an unnecessary source of conflict over a matter of little legitimate importance to government; it diverts politics into unproductive issues and perpetuates religious conflict. Justice O’Connor captures a small part of this explanation with her recognition that government endorsements of religious beliefs make citizens of other faiths feel like outsiders or second-class citizens."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.64.35",
      "id": "ft64.35"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is a plausible response that the dominant religious faction will so strongly demand government endorsement and practice of that faction’s religion that the pursuit of neutrality will cause even more religious conflict than letting the dominant faction have its way. This necessarily entails the proposition that religious minorities should suffer in silence and hope things get no worse; it comes close to arguing that “the vitality of these constitutional principles [must] yield simply because of disagreement with them.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.64.36",
      "id": "ft64.36"
    }
  }, [_vm._v("36")])]), _vm._v(" Which interpretation will minimize religious conflict is unanswerable empirically; all we can say is that a regime of religious liberty has dramatically reduced but not wholly eliminated religious conflict, and there is little reason to expect that to change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But there is an answer in principle; only one of these interpretations has at least the potential to minimize religious conflict. If we could all agree on the principle of government neutrality toward religion, we could all abandon our efforts to influence government on religious matters, and devote all that energy to religious practice and proselytizing in the private sector. Conflict over the government’s role in religion could, in theory, end. But if we interpret the Religion Clauses to mean that government may promote the religious views of the dominant religious faction so long as it refrains from coercion, we ensure perpetual battles for dominance, perpetual battles to control or influence the government’s religious message. That interpretation abandons in principle the goal of eliminating conflict over the government’s role in religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Secular intellectuals skeptical of religious liberty may argue that other strong personal commitments should have been protected as well. But they were not, for the sufficient reason that other strong personal commitments had not produced the same history. The protected liberty is religious liberty, and although the word “religion” must be construed in light of continuing "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("developments in beliefs about religion, we cannot rewrite the Constitution to say that religious liberty should not receive special protection.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Professors Garvey and Smith make similar claims from the other side of the religious spectrum."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.65.37",
      "id": "ft65.37"
    }
  }, [_vm._v("37")]), _vm._v(" They say that concern for autonomy alone cannot explain religious liberty, because autonomy claims extend to all aspects of human existence, and Professor Smith adds that other issues have been more disruptive of American social peace than religion. But the Founders gave special protection to "), _c('em', [_vm._v("religious")]), _vm._v(" liberty, and they had good historical reason for that choice. That protection remains in the Constitution even if the problem that made it necessary has receded. And certainly the problem has not disappeared. The Constitution has not been able to prevent intermittent episodes of religious violence, most notably against Mormons, Catholics, and Jehovah’s Witnesses."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.65.38",
      "id": "ft65.38"
    }
  }, [_vm._v("38")])]), _vm._v(" And we can only speculate about the possible results of the contemporary culture wars if both sides were not imbued with a two-hundred-year-old tradition of at least some core concept of religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Professor Garvey also says that peace alone cannot explain religious liberty, because peace might be achieved by suppressing all religious dissent, or at least by suppressing all dissent from groups small enough to be suppressed. But my claim is that the autonomy and peace arguments work together and in light of history. Pursuing peace by suppressing dissent is historically a failed policy, and even if it could succeed, it would be utterly inconsistent with the protection of autonomy in a domain that is extraordinarily important to individuals. Professor Garvey considers autonomy and peace separately and finds the argument wanting, but he does not consider the argument whole."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.65.39",
      "id": "ft65.39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Reading free exercise and disestablishment in light of my three historical propositions, it is possible to generate the full range of modern religious liberty protections—separating church and state, maximizing religious liberty in individuals and their voluntary groups, minimizing government influence on religion, and forbidding government to take positions on religious questions. Believers and nonbelievers may each find more emotional resonance in their separate theistic and anti-theistic perspectives, but they can have no hope of persuading each other from those perspectives. My account may seem thin to some, although I do not find it so. But thin or thick, its great advantage is that it is not dependent on beliefs about religion.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.5.3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('strong', [_vm._v("III. Other Explanations")])])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Of course my three propositions were not the only important propositions in the intellectual milieu that led to the American guarantees of religious liberty, nor are they an exhaustive list of the reasons for protecting religious liberty today."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.40",
      "id": "ft66.40"
    }
  }, [_vm._v("40")]), _vm._v(" Other explanations are not necessarily wrong, and they often reinforce or enrich the basic argument. But other explanations are not necessary, and to the extent that they depend on particular views about religion, they must be reformulated to have any persuasive force for those with different views about religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As in all political debates, self-interest played an important role in the decision to commit to religious liberty. The groups most fearful of government persecution were the most aggressive in demanding the broadest guarantees of religious liberty. That is why the established Anglicans and Congregationalists offered free exercise and resisted disestablishment, and why the dissenting evangelical sects insisted on both."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.41",
      "id": "ft66.41"
    }
  }, [_vm._v("41")])]), _vm._v(" But these sects protected themselves by protecting everyone; no one suggests that we construe the Religion Clauses to prefer evangelical sects over Episcopalians and Congregationalists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Self-interest promoted the recognition that a government that oppresses one faith today might turn on another tomorrow. The point is most directly illustrated by the Massachusetts establishment, which ended when its principal defenders started losing parish elections to Unitarians."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.42",
      "id": "ft66.42"
    }
  }, [_vm._v("42")])]), _vm._v(" It was in everyone’s interest to agree that government would not interfere with anyone’s beliefs about religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Fear of the new federal government played an important role, but the Religion Clauses were not just federalism provisions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.43",
      "id": "ft66.43"
    }
  }, [_vm._v("43")])]), _vm._v(" The brief Congressional debate over the Religion Clauses focused on religious liberty issues, not federalism issues."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.44",
      "id": "ft66.44"
    }
  }, [_vm._v("44")])]), _vm._v(" The battle for religious liberty was also fought out state by state, and the various state and federal debates informed the similar debates that came later. All the states eventually did disestablish their churches, and "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("the federal guarantee of religious liberty was eventually extended to and enforced against the states."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.67.45",
      "id": "ft67.45"
    }
  }, [_vm._v("45")]), _vm._v(" Federalism and religious liberty were separate issues, interacting but independent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Theological developments played an important role, perhaps an indispensable one. These religious beliefs are consistent with the Constitution, and they are among the multiplicitous reasons that motivated a broad coalition to enact constitutional guarantees of religious liberty. But these religious beliefs cannot be imputed to the Constitution without abandoning governmental neutrality on religious questions. Theistic arguments for religious liberty can neither persuade nontheists nor speak equally to all the varieties of theistic religious experience. Religious reasons have to be recast in the form of a statement about what some people believe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Many Christians came to believe that religious belief and practice are efficacious only when voluntary."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.67.46",
      "id": "ft67.46"
    }
  }, [_vm._v("46")])]), _vm._v(" This belief eliminated the principal religious reason for opposing religious liberty; if coerced belief could not save souls, there was no reason to pay the terrible temporal costs of struggling to maintain uniformity. But the theological point is neither unambiguous nor uncontroversial: Christianity rejected it for a long time, Protestants came to it sooner than Catholics, and fundamentalist Islam appears to reject it today. Atheists and agnostics can have no informed opinion on what makes theistic religious belief efficacious. Believers committed to an inherited religious tradition take understandable offense at overly enthusiastic statements of the value of voluntariness, which judges sometimes mistakenly equate with the value of individual religious choice."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.67.47",
      "id": "ft67.47"
    }
  }, [_vm._v("47")])]), _vm._v(" Believers who are offended by judicial rhetoric about individual choice should see the threat of serious discrimination between faiths in Professor Marshall’s suggestion that religious ideas should be protected but religious identities constrained."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.67.48",
      "id": "ft67.48"
    }
  }, [_vm._v("48")])]), _vm._v(" None of these conflicting "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("views about the nature of religious belief can be imputed to the Constitution. What we can say on behalf of the Constitution is that government should not impose beliefs about religion, whatever the various faiths teach about the efficacy of the attempt.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Another important religious argument, traceable to Roger Williams, is that religion is sacred and the state is corrupt, so that separation of church and state is necessary to protect religion from corruption by the state."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.68.49",
      "id": "ft68.49"
    }
  }, [_vm._v("49")]), _vm._v(" This is as much an argument for disestablishment as for free exercise; the state may corrupt the church even when it tries to help. There was and is substantial evidence, both in the Founders’ time and in ours, that establishment reduces the appeal of the established church."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.68.50",
      "id": "ft68.50"
    }
  }, [_vm._v("50")])]), _vm._v(" But here too nonbelievers are likely to disagree with the claim that religion is sacred in its private form and faces only corruption from the state, and some particularistic believers are likely to think that their own religion is sacred but that many others are false or corrupt and might benefit from state intervention were it not for all the other reasons for keeping the state out of religion. The argument that religious liberty protects the sacred is best understood as a particularized version of the claim that religion is of extraordinary importance to many individuals. Individuals and their voluntary groups are entitled to keep their religion in what "), _c('em', [_vm._v("they")]), _vm._v(" believe to be its pure form; any government interference changes it from what the religion would have been on its own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Still another religious argument is that each citizen’s duties to God are superior to his duties to the civil society; by respecting religious liberty, the state defers to this prior duty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.68.51",
      "id": "ft68.51"
    }
  }, [_vm._v("51")])]), _vm._v(" Undoubtedly many religious citizens at the founding and today have supported religious liberty partly on this ground. "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("But again, those who do not believe that God exists cannot believe that God imposes binding obligations superior to those imposed by civil society, and certainly not that the Constitution of the United States writes such a theistic proposition into the fundamental law of the land. And although each believer may believe that God imposes binding obligations, only radical theistic pluralists really believe that God imposes inconsistent but equally binding obligations on adherents of different faiths."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.69.52",
      "id": "ft69.52"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But this argument too can be reworked consistently with the three fundamental propositions set out above. It is irrelevant whether God "), _c('em', [_vm._v("really")]), _vm._v(" imposes a bewildering variety of inconsistent obligations, all superior to the claims of civil society, on persons of different faiths. It is sufficient that many individuals "), _c('em', [_vm._v("believe")]), _vm._v(" themselves subject to such God-imposed obligations, that these beliefs are usually far more important to the individual than to the state, and that state attempts to override these beliefs will cause unnecessary conflict and human suffering.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.5.4"
    }
  }, [_c('strong', [_vm._v("IV. Defining “Religion”")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I have said that the domain of religious liberty is liberty with respect to religious choices and commitments. This seemingly simple formulation conceals a fundamental and largely unexamined disagreement. What is “religion” within the meaning of the Religion Clauses? To avoid incoherence the answer must be that “religion” is any set of answers to religious questions, including the negative and skeptical answers of atheists, agnostics, and secularists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have argued that the most fundamental reason for religious liberty is to avoid conflict over the answers to religious questions, to enable people of fundamentally different views about religion to live together in peace and self-governance. It is utterly irrelevant to that purpose which answers to religious questions are in conflict. “What is the nature of God and what does He/She want for us?” is the fundamental religious question, and any answer to that question is inherently a religious proposition. “No God exists and this imaginary construct wants nothing for us” is a belief about religion. It is not merely a descriptive statement about religion, such as an anthropologist might make, or a scholar of comparative religion. Rather, it is an affirmation "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("of belief, capable of generating commitment and even lifelong activism on behalf of the cause.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("The emergence of a vocal nontheistic minority in a predominantly theistic society causes serious social conflict. If the government is allowed to take sides, the two sides will fight to control the government, and the government will disapprove of, discriminate against, or suppress the losers. The most fundamental religious conflict in the United States today is between those who have abandoned theistic belief or accommodated their theism to contemporary secular values, and those who have not. This conflict has multiple axes that are not quite parallel. James Davison Hunter emphasizes the conflict between orthodox believers, who believe that God laid down unchangeable moral laws, and progressives, who believe that human understanding of truth, including religious and moral truth, is changeable and ever unfolding."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.53",
      "id": "ft70.53"
    }
  }, [_vm._v("53")]), _vm._v(" Phillip Johnson emphasizes the conflict between modernists or naturalists, who have excluded the possibility of supernatural events and explanations from their working worldview, and believers to whom the world is incomprehensible without creation and the continuing presence of God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.54",
      "id": "ft70.54"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Each side has its passionate advocates. Many traditional theists genuinely believe that morality can have no secure basis unless founded on God’s law;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.55",
      "id": "ft70.55"
    }
  }, [_vm._v("55")])]), _vm._v(" many nontheists are equally certain that religious faith is like reading entrails"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.56",
      "id": "ft70.56"
    }
  }, [_vm._v("56")])]), _vm._v(" or denying the Holocaust"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.57",
      "id": "ft70.57"
    }
  }, [_vm._v("57")])]), _vm._v(" and that morality can have no secure basis unless founded on reason. Suzanna Sherry vigorously attacks the destructive effects of faith,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.58",
      "id": "ft70.58"
    }
  }, [_vm._v("58")])]), _vm._v(" while Peter Kreeft calls for an “ecumenical jihad” by believers of all faiths against modernism and relativism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.59",
      "id": "ft70.59"
    }
  }, [_vm._v("59")])]), _vm._v(" These are the sides in the much discussed culture wars. Any interpretation is wrong if it amounts to a claim that the Religion Clauses award victory to one side or the other."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.60",
      "id": "ft70.60"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second and third historical points are also applicable to nontheists. "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Atheistic and agnostic beliefs will be very important to many of the individuals who hold such beliefs; these people will define themselves partly in reaction to the strongly held theistic beliefs of others. And these beliefs are of little importance to government if both theists and nontheists can be loyal citizens. Thus, “the core purpose of the Religion Clauses applies to nonbelievers as well as to believers.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.61",
      "id": "ft71.61"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The resistance to this conclusion seems to me partly linguistic and partly strategic. The linguistic argument is that the word “religion” has traditionally been used to refer only to affirmative answers to the great religious questions; atheism, agnosticism, and secularism have been thought of not as religion, but as the opposite of religion. This description of usage is accurate so far as I know in the Founders’ time, when the question could hardly have arisen; this description of usage is mostly accurate in this century, but not entirely so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("John Dewey and the first "), _c('em', [_vm._v("Humanist Manifesto")]), _vm._v(" presented humanism as a new religion to supersede traditional religions thought to have become un-convincing."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.62",
      "id": "ft71.62"
    }
  }, [_vm._v("62")])]), _vm._v(" The "), _c('em', [_vm._v("Manifesto")]), _vm._v(" opened with the statement that “the time has come for widespread recognition of the radical changes in religious beliefs through the modern world.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.63",
      "id": "ft71.63"
    }
  }, [_vm._v("63")])]), _vm._v(" The second paragraph warned that “There is a great danger of a final, and we believe fatal, identification of the word "), _c('em', [_vm._v("religion")]), _vm._v(" with doctrines and methods which have lost their significance and which are powerless to solve the problem of human living in the Twentieth Century.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.64",
      "id": "ft71.64"
    }
  }, [_vm._v("64")])]), _vm._v(" The third paragraph proclaimed the need for “a new statement of the means and purposes of religion.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.65",
      "id": "ft71.65"
    }
  }, [_vm._v("65")])]), _vm._v(" The Manifesto then set out fifteen “theses of religious humanism”;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.66",
      "id": "ft71.66"
    }
  }, [_vm._v("66")])]), _vm._v(" these theses included explicit rejection of creation, theism, and “supernatural guarantees of human values.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.67",
      "id": "ft71.67"
    }
  }, [_vm._v("67")])]), _vm._v(" Searching for a new definition of religion, the drafters came up with the wholly unworkable proposition that “Religion consists of those actions, purposes, and experiences which are humanly significant.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.68",
      "id": "ft71.68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This work by a handful of intellectuals is evidence of some usage, obviously "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("not of general usage. The drafters’ usage may have been strategic; they might have thought that they were more likely to win converts with this formulation than if they repudiated all religion. But their usage also reflects a genuine and steady evolution through “theism, deism, modernism, and the several varieties of ‘new thought.’ ”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.72.69",
      "id": "ft72.69"
    }
  }, [_vm._v("69")]), _vm._v(" "), _c('em', [_vm._v("Humanist Manifesto II")]), _vm._v(" dropped the talk of religion, although it continued to recognize religious humanism as one branch of humanism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.72.70",
      "id": "ft72.70"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('em', [_vm._v("The Encyclopedia of American Religions")]), _vm._v(" lists a “liberal family” of religions that includes the Unitarian Universalist Association, the American Humanist Association, the American Ethical Union, American Atheists, and others."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.72.71",
      "id": "ft72.71"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Eventually the religious right began to argue that secular humanism is a religion and that it is established in the schools, and the organized humanist movement began to respond that it is not a religion after all. In 1980, the Council for Democratic and Secular Humanism (now the Council on Secular Humanism) split off from the American Humanist Association, and published its own statement, "), _c('em', [_vm._v("A Secular Humanist Declaration.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.72.72",
      "id": "ft72.72"
    }
  }, [_vm._v("72")])]), _vm._v(" The leading founder of this new organization later explained that “the term "), _c('em', [_vm._v("secular")]), _vm._v(" humanism has thus been introduced to distinguish it from "), _c('em', [_vm._v("religious")]), _vm._v(" humanism.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.72.73",
      "id": "ft72.73"
    }
  }, [_vm._v("73")])]), _vm._v(" The core beliefs do not appear to have changed, but the characterization has.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Assume that this is all epiphenomenon, and that in the dominant American usage, disbelief is the opposite of religion. So what? Where neutrality, equality, and nondiscrimination are part of the central purpose of a clause, it is no anomaly that the clause applies to opposites. The whole point of neutrality, equality, and nondiscrimination is to give equal treatment to categories that are opposite in some way that has been socially significant. To prefer one set of answers to religious questions over other answers to the same questions is to violate the core of the Religion Clauses. The only way to avoid that violation is to recognize that for constitutional purposes, any answer to religious questions is religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As the history of organized humanism illustrates, actual usage in this "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("century has been driven in part by strategic considerations. The strategic temptations lie on both sides. Some believers insist that nonbelief is not a religion, so that theistic religion gets special constitutional recognition, so that the government can endorse generic theism or give “nonpreferential” aid to religion without departing from neutrality, or so that regulatory exemptions under the Free Exercise Clause or the Religious Freedom Restoration Act are available only to those whose conscientious objection is rooted in theism. Nontheists typically insist that their nontheistic views are not religious, so that government is free to promote them and act on them, and so that they can dismiss without analysis the claim that secular humanism has been established. Thus Paul Kurtz argues that the most immediate reason not to consider secular humanism a religion is that it would then follow that secular humanism “cannot be taught to the young, using public funds and in the guise of neutrality.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.73.74",
      "id": "ft73.74"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For reasons I have explained at somewhat greater length elsewhere, I do not believe that secular humanism has been established in the schools."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.73.75",
      "id": "ft73.75"
    }
  }, [_vm._v("75")])]), _vm._v(" Secular humanism offers explicit negative answers to the basic theological questions, but I know of no case in which schools have taught those answers. But certainly we can imagine a school that did teach those answers. We can imagine a government that established atheism, and even think of real examples; the Soviet Union did it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If atheism is not a religion for constitutional purposes, such an establishment would be perfectly constitutional. The Free Speech Clause would protect citizens from being forced to affirm atheistic beliefs,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.73.76",
      "id": "ft73.76"
    }
  }, [_vm._v("76")])]), _vm._v(" and the Free Exercise Clause would protect believers from persecution or discrimination, but there is no Establishment Clause with respect to secular ideas. If atheism is just a secular idea, government would be free to promote atheism to the same extent that it has ever promoted any other secular idea—say the war effort in World War II, or civil rights during the Second Reconstruction. Government could teach atheism in the schools, promote atheism in the mass media, subsidize the American Atheists and a network of local chapters, and ridicule God as the opiate of the masses. The only sensible interpretation is that this would be an establishment of religion—an establishment of a certain set of views about religion, of a certain set of answers to the fundamental religious questions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.73.77",
      "id": "ft73.77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("The consequences of excluding nontheists from the Free Exercise Clause would be less dramatic, because the Free Speech Clause and the Test Oath Clause would fill much of the gap. The most important residual gap would be the protection for religiously motivated conduct—either the substantive protection argued for here and provided in the Religious Freedom Restoration Act,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.74.78",
      "id": "ft74.78"
    }
  }, [_vm._v("78")]), _vm._v(" or the nondiscrimination protection recognized in "), _c('em', [_vm._v("Church of the Lukumi Babalu Aye v. City of Hialeah")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.74.79",
      "id": "ft74.79"
    }
  }, [_vm._v("79")])]), _vm._v(" and "), _c('em', [_vm._v("Employment Division v. Smith.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.74.80",
      "id": "ft74.80"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The law should recognize nontheistic answers to religious questions as religion for constitutional purposes and for RFRA purposes. And the law should provide parallel protections for theistic and nontheistic beliefs about religion for as far as the parallels can be reasonably extended. Government should be neutral among these beliefs, endorsing none of them and taking no position on the truth or value of any of them. Private speech from any of these perspectives should be protected as high-value speech, doubly protected by both the Free Speech and Free Exercise Clause."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.74.81",
      "id": "ft74.81"
    }
  }, [_vm._v("81")])]), _vm._v(" The Constitution and RFRA should protect the autonomy of atheist, agnostic, and humanist organizations, just as they protect the autonomy of churches;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.74.82",
      "id": "ft74.82"
    }
  }, [_vm._v("82")])]), _vm._v(" they should protect conduct motivated by disbelief in God, if any there be, just as they protect conduct motivated by more traditional religious beliefs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.74.83",
      "id": "ft74.83"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most controversial, but essential to the pursuit of religious neutrality, the law should protect nontheists’ deeply held conscientious objection to compliance with civil law to the same extent that it protects the theistically motivated conscientious objection of traditional believers. "), _c('em', [_vm._v("United States v.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('em', [_vm._v("Seeger")]), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.84",
      "id": "ft75.84"
    }
  }, [_vm._v("84")]), _vm._v(" and "), _c('em', [_vm._v("Welsh v. United States")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.85",
      "id": "ft75.85"
    }
  }, [_vm._v("85")])]), _vm._v(" were rightly decided; they implement policies at the core of religious liberty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.86",
      "id": "ft75.86"
    }
  }, [_vm._v("86")])]), _vm._v(" The law cannot protect the pursuit of all personal commitments or obligations, or all disagreements with the policy or prudence of political decisions. Unlike religious disagreements, political disagreements are committed to the political process; my third reason for religious liberty does not apply when the disagreement is essentially political. What the law can do is protect those moral obligations of nontheists that are functionally equivalent to the protected moral obligations of theists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some commentators seem to assume that this interpretation takes unacceptable liberties with the constitutional text. The full elaboration of this argument runs that nontheism is not religion, so nontheistic conscientious objectors cannot be protected. Because it would be discriminatory to protect theistic conscientious objectors without protecting nontheistic conscientious objectors, whatever we might think the underlying policy of free exercise would be otherwise, the pursuit of religious neutrality requires that we repudiate regulatory exemptions for theistic objectors. Variations on this argument may be the longest standing modern objection to recognizing regulatory exemptions at all."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.87",
      "id": "ft75.87"
    }
  }, [_vm._v("87")])]), _vm._v(" I should therefore note before continuing that the Supreme Court has unanimously rejected the claim that regulatory exemptions for religion violate the Establishment Clause."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.88",
      "id": "ft75.88"
    }
  }, [_vm._v("88")])]), _vm._v(" That decision is clearly right; one does not establish a religion by leaving it alone."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.89",
      "id": "ft75.89"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider on the merits the argument that nontheistic objectors cannot be protected and so it is discriminatory to protect theistic objectors. This argument accepts my claim that neutrality is a central purpose of the Religion Clauses, and it accepts my claim that theistic and nontheistic answers to religious questions are essentially parallel and entitled to equal treatment. But it pursues neutrality at the expense of liberty; it repudiates everyone’s substantive "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("liberty to exercise a religion rather than extend that liberty from the more familiar case of theistic conscientious objectors to the parallel case of nontheistic conscientious objectors.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("This repudiation of the substantive right to exercise a religion is perverse in terms of liberty and perverse in terms of human suffering. A principal argument for the repudiation is to avoid the intangible indignity to nontheists of knowing that they are ineligible for exemptions available to some theists."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.76.90",
      "id": "ft76.90"
    }
  }, [_vm._v("90")]), _vm._v(" (This resentment of exemptions available only to theists is of course an example of my point that religious groups are highly sensitive to any indication that government likes some other religious group best.) If exemptions were eliminated, the nontheistic conscientious objectors would still have to comply with the laws to which they object. They would be no better off, except that they would no longer feel slighted. The proposed cost of eliminating this intangible indignity is tangible and vastly disproportionate to the gain: believers whose religion forbids compliance with certain laws would have to abandon religious behaviors of profound importance to them, or go to jail, or expatriate, or rebel against the government—even if the burdensome law serves no particularly important government interest. On the free exercise side, the argument that nontheistic answers to religious questions are not religion sacrifices liberty in pursuit of a dog-in-the-manger version of neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The argument becomes even more perverse on the establishment side where, as we have seen, it would permit nontheistic views about religion to be established. Thus, any gains to neutrality on the free exercise side would be offset by the total abandonment of neutrality on the establishment side. There would be a major loss to liberty on the free exercise side, and no gain whatever to liberty on the establishment side; indeed, there would be a loss to liberty on the establishment side too if you accept my view that government expression of religious views interferes with the free development of beliefs about religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This perverse combination of results cannot be justified on the mere ground that the Founders did not think to consider atheism a religion. We do know that in the case where they thought most explicitly about disbelief, they protected it—in the Test Oath Clause. This protection did not go unnoticed; it was a point of some controversy in the state ratifying conventions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.76.91",
      "id": "ft76.91"
    }
  }, [_vm._v("91")])]), _vm._v(" Other models were available in state constitutions; South Carolina provided that there could be no oaths except for monotheism and belief in a future state of "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("rewards and punishments."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.77.92",
      "id": "ft77.92"
    }
  }, [_vm._v("92")]), _vm._v(" But the federal Constitution’s prohibition on test oaths is absolute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More fundamentally, the Founders knew that the principal antagonists in religious conflicts varied from time to time and place to place. They knew about Christians and Muslims in the Crusades, Christians and Jews in the Spanish Inquisition, Catholics and Protestants in Reformation Europe, Anglicans and Puritans in the English Civil War, Episcopalians and Baptists in Virginia, Congregationalists and Baptists in Massachusetts. They knew that the immediate combatants were typically a religious movement on one side and a government on the other; Madison noted that it was “the secular arm” that had spilled “torrents of blood” in the effort to eliminate religious differences."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.77.93",
      "id": "ft77.93"
    }
  }, [_vm._v("93")])]), _vm._v(" They knew, if they thought about it, that the secular arm often acted for secular reasons of its own."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.77.94",
      "id": "ft77.94"
    }
  }, [_vm._v("94")])]), _vm._v(" Certainly they knew about Henry II and Thomas à Becket, and about Henry VIII taking over the English Church. The identity of the factions did not change the central problem; the Founders’ principle had to cover future religious conflicts whatever the factional alignment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Founders may not have predicted that the central conflict in early nineteenth-century Massachusetts would be between Trinitarians and Unitarians, but the Religion Clauses applied to any federal manifestations of that unforeseen conflict, and that conflict forced Massachusetts to rewrite its religious liberty provisions and join the rest of the country in disestablishment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.77.95",
      "id": "ft77.95"
    }
  }, [_vm._v("95")])]), _vm._v(" The Founders greatly feared Catholicism, and they probably did not foresee the massive Catholic immigration beginning in the mid-nineteenth century. The Founders undoubtedly did not anticipate the current alignment of forces, in which traditional Protestants, Catholics, and Jews maintain their distinct traditions while making common cause against the forces of secularism. But the Religion Clauses speak to this conflict and can still serve to mediate it, helping these antagonists like others before them to live together in a peaceful and self-governing society. The clauses cannot serve this function if one side in the central conflict is defined as a religion and the other side is not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Michael McConnell has offered a somewhat different argument for refusing protection to nontheistic conscientious objectors. He agrees that "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("“[u]nbelief is, after all, a system of opinions regarding the existence of God and thus regarding ultimate religious questions of life and value.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.78.96",
      "id": "ft78.96"
    }
  }, [_vm._v("96")]), _vm._v(" And he agrees that “[t]he protection of religious opinion will equally benefit religion and unbelief.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.78.97",
      "id": "ft78.97"
    }
  }, [_vm._v("97")])]), _vm._v(" But he insists that conscientious objection is different:")]), _vm._v(" "), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_vm._v("[U]nbelief entails no obligations and no observances. Unbelief may be coupled with various sorts of moral conviction.… But these convictions must necessarily be derived from some source other than unbelief itself; belief in the nonexistence of God does not in itself generate a moral code. Accordingly, to the extent that religious "), _c('em', [_vm._v("actions")]), _vm._v(" are protected under the Religion Clauses, there will be an asymmetry in the treatment of religion and unbelief."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.78.98",
      "id": "ft78.98"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This is true in a sense, but largely irrelevant. In the case of theistic conscientious objectors, and in common usage, we understand “religion” to include a cluster of associated beliefs, and we rarely if ever undertake close examination of the causal connections among them. Theology and liturgy are at the core; church governance is plainly included though not very salient for most people today; moral obligations associated with religious belief are both included and more salient. The path of derivation within the cluster is not, and should not be, dispositive of exemption claims. Consider four cases, not entirely hypothetical.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First, consider a Catholic pacifist. He has moral beliefs not derived from his Church’s teaching on the subject, possibly derived from other teachings of his Church or from his understanding of God’s will, but quite possibly derived from reading the moral arguments of nontheistic pacifists. Courts can inquire into his sincerity, but I think that they cannot inquire into whether his pacifism is “derived from” his belief in God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, consider a person who becomes a pacifist out of secular moral conviction, and then becomes a Quaker because his pacifism leads him to a pacifist church. He is not disqualified from exemption on the ground that his religion is “derived from” his moral conviction instead of the other way around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, consider a secular Jew who doubts or denies the existence of God, but who observes the Sabbath and the dietary laws out of loyalty to the faith of his fathers. His observances are “derived from” somebody’s religion, although perhaps not from “his” religion, and certainly not from a belief in the "), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("existence of God. But surely the state must recognize his observances as religious; he is entitled to Sabbath accommodation under the employment discrimination laws and to Kosher food if he lands in prison.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Fourth, consider a modernist Christian who thinks the essence of Christianity is the Sermon on the Mount, who is therefore committed to serving his fellow humans, and who thinks that killing is inconsistent with that obligation. He is active in his church, but he thinks that Jesus was just a great teacher, and he doubts the existence of God. For him, Christianity is a powerful symbol system that he “resymbolize[s]” in modern terms."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.79.99",
      "id": "ft79.99"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I think that each of these claimants must be treated as having religious claims. To do otherwise would be inconsistent with common usage and understanding of what is religious behavior, and would inquire far too deeply into the workings of religious belief systems. Variations in the content and derivation of religious beliefs cannot be the basis for differences in legal treatment. Yet it is not clear that any of the moral beliefs in these four cases meet McConnell’s standard of being “derived from” a belief in the existence of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With respect to the nontheistic objector, the challenge is to identify that cluster of beliefs that are analogous to the cluster of beliefs we recognize as religious in the case of adherents to traditions that we can all agree are religions. Beliefs about the nonexistence of God are plainly analogous to the theist’s belief in God’s existence. Professors Sherry, Marshall, McConnell, and I all agree on that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The nontheist’s belief in transcendent moral obligations—in obligations that transcend his self-interest and his personal preferences and which he experiences as so strong that he has no choice but to comply—are analogous to the transcendent moral obligations that are part of the cluster of theistic beliefs that we recognize as religious. The derivation of these beliefs may be murky, as in the four cases just considered, but these beliefs and the sources from which the nontheist derived them are serving the same functions in his life as the equivalent moral beliefs and sources of derivation serve for theists. The nontheist may experience natural law or the equality of all humans as “a transcendent authority prior to and beyond the authority of civil government,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.79.100",
      "id": "ft79.100"
    }
  }, [_vm._v("100")])]), _vm._v(" just as the theist experiences divine command or religious tradition. An individual’s religious beliefs may evolve from theism to deism to modernism to resymbolized Christianity to humanism to agnosticism "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("to atheism. This evolution is itself an exercise of religion; it is a series of religious choices or of shifting religious commitments. The state should not draw a line across this evolutionary path; it should not decree that anyone who crosses the line forfeits his right to conscientious objection and loses protection for his deepest moral commitments. Such a line would not be consistent with either liberty or neutrality.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course judges may draw such a line despite its incoherence. All that should follow is that nontheism would be outside the Religion Clauses and outside RFRA. The scope of protection for religions inside the Clauses and inside RFRA should not be changed, lest the core of religious liberty be determined by anomalous cases at the margin.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("Consistently for decades, 95% of Americans have said they believe in God or a Universal Spirit."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.80.101",
      "id": "ft80.101"
    }
  }, [_vm._v("101")]), _vm._v(" This number includes people whose beliefs are modernist, attenuated, or unconventional; it includes most people on both sides of the culture wars. It includes all sorts of minorities, many of them tiny; the fact that 95% have theism in common does not mean that the enormous range of religious views that make up the 95% can protect themselves through the political process. These 95% will be able to state any conscientious objection to government policy in theistic terms, so their moral beliefs will qualify as religious under theistic definitions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The problem of avowed nontheists is statistically marginal; judicial refusal to protect the 5% should not become the excuse for withdrawing protection from the 95%. A judge who says that “religion” in the First Amendment means theism cannot then say that special protection for theism violates the Establishment Clause because it discriminates against the 5% he refuses to protect. I would prefer liberty and neutrality for all, but if forced to choose between liberty and neutrality for 95%, or liberty for none and neutrality for all, the constitutional choice is easy. The neutrality of universal suppression is not the constitutional vision.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.5.5"
    }
  }, [_c('strong', [_vm._v("V. Constitutional Text and History")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("My argument so far has been based on history and function at the very largest scale. I have asked what we can infer about religious liberty from centuries of religious conflict. I turn now to more specific sources of constitutional meaning—to constitutional text, to the political debate that led to that text, and to the history of our national effort to implement that text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("The Constitution consists of the ratified text; the People’s representatives voted on nothing else. All inferences from history, structure, and policy must be tested for consistency with that text. I think that the text is consistent with the views expressed so far, and that to the extent possible in so brief a formulation, the text affirmatively supports the interpretation of guaranteeing as much liberty as possible to holders of all views about religion.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("The Free Exercise Clause guarantees a substantive right to exercise one’s religion. “Exercise” means activity or practice, both now and in the Founders’ time;"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.81.102",
      "id": "ft81.102"
    }
  }, [_vm._v("102")]), _vm._v(" it is not confined to belief or to speech. The right is not stated as a mere right to nondiscrimination. It is common ground that religious conduct is the exercise of religion;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.81.103",
      "id": "ft81.103"
    }
  }, [_vm._v("103")])]), _vm._v(" otherwise, the Free Exercise Clause would not protect such conduct even from discrimination. But once that is conceded, a law prohibiting religious conduct is quite literally a law “prohibiting the free exercise thereof”—a law prohibiting the exercise of religion. This is the most straightforward, plain-meaning interpretation of the text, and only this reading can satisfy the religion-neutral rationales for religious liberty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.81.104",
      "id": "ft81.104"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The phrase “free exercise of religion” was deliberately substituted for a guarantee of “toleration” in drafting the Virginia Declaration of Rights."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.81.105",
      "id": "ft81.105"
    }
  }, [_vm._v("105")])]), _vm._v(" “Toleration” might have suggested a mere right of religious minorities to live within our boundaries. Indeed, “toleration” might have been consistent with Professor Sherry’s view that believers are a dangerous, superstitious faction whose epistemology is rejected in our founding documents, but whose liberty must unfortunately be protected to prevent their becoming angry and resentful."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.81.106",
      "id": "ft81.106"
    }
  }, [_vm._v("106")])]), _vm._v(" Whatever “toleration” might have meant, the word would have been less probative on the right to “exercise” one’s religion. The more protective phrase was the one written into the federal bill of rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The constitutional text lends indirect support to the argument that nontheistic views about religion must be recognized as religion, although the argument is hardly free of difficulty. The principal argument against such recognition is also textual—that nontheistic views simply are not “religion” in common usage or in the Founders’ usage, and worse, that the First Congress considered and rejected drafts that would have protected “liberty of "), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("conscience” instead of, or in addition to, “free exercise of religion.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.82.107",
      "id": "ft82.107"
    }
  }, [_vm._v("107")]), _vm._v(" But there was no recorded controversy in the First Congress or elsewhere over the supposed distinction between religion and conscience,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.82.108",
      "id": "ft82.108"
    }
  }, [_vm._v("108")])]), _vm._v(" and speakers and state constitutions of the time used the two phrases interchangeably."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.82.109",
      "id": "ft82.109"
    }
  }, [_vm._v("109")])]), _vm._v(" The great Calvinist teaching that “God alone is Lord of the conscience”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.82.110",
      "id": "ft82.110"
    }
  }, [_vm._v("110")])]), _vm._v(" plainly referred to religion and not to something different. Nontheistic conscientious objection was simply not a significant issue in the Founders’ time. One speaker on a proposal to constitutionalize a specific right to exemptions from militia service was able to envision the possibility of nontheistic conscientious objectors, but he did not describe that possibility in terms of a distinction between religion and conscience."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.82.111",
      "id": "ft82.111"
    }
  }, [_vm._v("111")])]), _vm._v(" Professor McConnell identifies two other distinctions that might be read into the choice between “free exercise of religion” and “liberty of conscience.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.82.112",
      "id": "ft82.112"
    }
  }, [_vm._v("112")])]), _vm._v(" With three possible explanations of what the choice of language might have meant if it meant anything, no record of an actual dispute, and no record of a consistent difference in usage, it is hard to draw much meaning from the failure to include a conscience clause. But I do agree that when the Founders thought of religion, they thought of theism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Assuming some force to the argument that the Founders’ common understanding of religion excluded nontheistic views, we are faced with a new situation that creates serious tension within the constitutional text. We now have significant numbers of citizens with nontheistic beliefs; we now have new axes of religious conflict that the Founders could not foresee. Either we must expand the textual meaning of “religion” to include the new answers to religious questions, or we must shrink the textual meaning of “exercise” to avoid preferring theistic beliefs with respect to conscientious objection, or we "), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("must exclude nontheists from the goal of government neutrality on religious questions. The purely textual argument becomes at worst a draw.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In fact, the textual argument for protecting nontheistic beliefs about religion is better than a draw. I would expand the traditional meaning of “religion” to include beliefs that secularists agree cannot be discriminated against relative to the traditional religious beliefs that are most explicitly protected. That is, I read the constitutional term to include newly emerged beliefs that were not socially significant in the Founders’ time but that fall easily into a category—beliefs about the nature of God—that we know the Founders meant to protect. By contrast, those who would deny protection to conscientious objectors must shrink the meaning of “exercise” so dramatically that any substantive right to practice a religion disappears. And, as argued above, this dispute is not even close in terms of constitutional purposes. Shrinking the meaning of “exercise” and refusing to recognize nontheistic views as “religion” abandons both the liberty and neutrality policies of the clauses and permits the government to take sides in a core religious conflict.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("The constitutional text is absolute; there is no textual exception in either of the Religion Clauses. Of course we know from experience that absolute religious liberty is unacceptable. But a strong burden of persuasion rests on those who would imply exceptions to an expressly absolute constitutional text. This is the textual basis for inferring the compelling interest exception and construing it narrowly"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.83.113",
      "id": "ft83.113"
    }
  }, [_vm._v("113")]), _vm._v("—for minimizing the exception and maximizing the protected liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Speakers of English do not use “establishment” in quite the same sense with respect to anything but religion; the word really has no plain English meaning. It takes its meaning from its historical usage, of which the core case is the “the Church of England as by law established.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.83.114",
      "id": "ft83.114"
    }
  }, [_vm._v("114")])]), _vm._v(" An established church was supported by the government in multiple ways;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.83.115",
      "id": "ft83.115"
    }
  }, [_vm._v("115")])]), _vm._v(" in my view, any of these forms of support is a law respecting an establishment of religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Coercing citizens to support a religion in which they do not believe will often, and arguably always, violate the Free Exercise Clause. If the Establishment Clause were also confined to coercion, it would be redundant. This redundancy "), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("in the coercion interpretation is textual support for the belief that the Establishment Clause goes beyond coercion, and therefore that noncoercive support of religion is an establishment. This reading is consistent with the fact that endorsements of the established church were part of the package of support that government gave to the established church, and in some cases in the period just before the First Amendment, endorsements were all or nearly all that the established church got."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.84.116",
      "id": "ft84.116"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This prohibition on endorsements makes Religion Clause neutrality an extraordinary kind of neutrality. Unlike political matters, government is forbidden to influence opinion even by persuasion. Religion is to be as free of government influence as anything can be in a society with a large government.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In general terms, the Free Exercise Clause prohibits government suppression of religion; the Establishment Clause forbids government support of religion. This balance between the clauses is further evidence for believing that government must be neutral toward religion, although the text is not specific enough to define neutrality without further inquiry."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.84.117",
      "id": "ft84.117"
    }
  }, [_vm._v("117")])]), _vm._v(" It is at least clear that each clause must be construed in light of the other, and in light of the rest of the First Amendment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I reject Professor Sherry’s view that this contrast between the clauses renders them inconsistent."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.84.118",
      "id": "ft84.118"
    }
  }, [_vm._v("118")])]), _vm._v(" That would be a last resort interpretation, after exhausting all attempts to reconcile the clauses."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.84.119",
      "id": "ft84.119"
    }
  }, [_vm._v("119")])]), _vm._v(" In fact, the reconciliation is not difficult, especially in the light of history. Both disestablishment and free exercise protect the liberty of individuals and their voluntary groups with respect to choices and commitments about religion. Government support of established churches had harmed the religious liberty of persons who did not believe in the teachings of the established church; in different ways, government support had harmed the religious liberty of the established church and its members. The two clauses together are complementary guarantees of religious liberty for both the majority (if any) and the various minorities, including nontheists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I think it is of some significance that the Establishment Clause prohibits laws “respecting an establishment of religion,” and not merely establishment of a church or establishment of a particular religion. The reference seems to "), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("be to religion generally; the clause includes generic support for theism."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.85.120",
      "id": "ft85.120"
    }
  }, [_vm._v("120")]), _vm._v(" Particularly given the drafting history and the then-recent debates over the meaning of disestablishment, this is strong evidence against the claim that government can support religion if it does so nonpreferentially."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.85.121",
      "id": "ft85.121"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The principal alternative to the policy eventually ratified in the Religion Clauses had been nonpreferential establishments. The defenders of the established churches tried to make establishment acceptable by converting it into nonpreferential support for all Christian denominations. The effort to be nonpreferential was mostly sham in New England, more genuine in Maryland and Virginia, but in both regions, nonpreferentialism was the last strategy to save the establishment. Nonpreferential establishment was rejected in the drafting of the Religion Clauses, and eventually in all the states."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.85.122",
      "id": "ft85.122"
    }
  }, [_vm._v("122")])]), _vm._v(" I think history is clearer on this than history usually is on most things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This prohibition on nonpreferential support for generic theism is further indirect evidence for the claim that both theistic and nontheistic beliefs are protected by the clauses. The Founders opposed nonpreferential establishments partly for fear that they would be preferential in practice, partly out of genuine commitment to religious voluntarism. They were not thinking about unanticipated conflict between generic theism and nontheism, but their rejection of nonpreferential support for theistic churches left their Religion Clauses open to that application when the axes of religious conflict changed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another central issue in the founding generation was the financing of churches. The Founders clearly rejected the view that government should pay for churches as such. There is no evidence that they considered the principal modern controversy, which is funding for secular health, educational, or welfare services provided by churches."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.85.123",
      "id": "ft85.123"
    }
  }, [_vm._v("123")])]), _vm._v(" They sent missionaries to the Indians, but it is not clear that anyone thought about whether that raised Establishment Clause issues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Protestant Bible controversy in the nineteenth century is a formative national experience that has gotten insufficient attention in the interpretation of the Religion Clauses."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.85.124",
      "id": "ft85.124"
    }
  }, [_vm._v("124")])]), _vm._v(" That controversy demonstrates that conflict "), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("over government-sponsored religious observances can lead to violence. It is powerful confirmation of the wisdom of the school prayer decisions, and more generally, of the view that government should take no position on religious questions. This controversy is also the source of the widespread belief that government payments to religiously affiliated schools violate the Establishment Clause. Thirty-two states amended their Constitutions in this period to prohibit public funding of religious schools."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.125",
      "id": "ft86.125"
    }
  }, [_vm._v("125")]), _vm._v(" Democrats in the Senate narrowly defeated the Blaine Amendment to the federal Constitution, which would have codified the Protestant position by authorizing Bible reading in the public schools and forbidding any use of state or federal funds to support religious schools."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.126",
      "id": "ft86.126"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is important that the Religion Clauses restrict Congress, a branch of government; they do not restrict churches or religious believers. Restricting the power of Congress restricts the entire federal government in most contexts, because most of the work of the other branches is to execute or interpret Congressional legislation;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.127",
      "id": "ft86.127"
    }
  }, [_vm._v("127")])]), _vm._v(" in any event, the Court has interpreted “Congress” to mean the whole federal government without attending to the problem."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.128",
      "id": "ft86.128"
    }
  }, [_vm._v("128")])]), _vm._v(" Slavery and the Civil War confirmed Madison’s view that the states were an equal or greater threat to liberty, and the Privileges or Immunities Clause makes the Religion Clauses binding on state and local governments."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.129",
      "id": "ft86.129"
    }
  }, [_vm._v("129")])]), _vm._v(" The Supreme Court’s explanation is less textually plausible, but it works, and it has fewer ambiguities about the scope of coverage."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.130",
      "id": "ft86.130"
    }
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("Each of these extensions of the original textual constraint on Congress extended the constraint to other branches and levels of government. Of course this tracks the whole constitutional structure; the Bill of Rights is a set of constraints on government, and only the Thirteenth Amendment directly restricts the conduct of private persons not engaged in state action. It is breathtaking to assert—without even acknowledging the existence of contrary constitutional text and structure—that the primary purpose of the Religion Clauses was to protect the state from the church and not to protect churches from the state."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.87.131",
      "id": "ft87.131"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is not the place for an intellectual history of attitudes toward religion in the founding generation. But I cannot pass without comment Professor Sherry’s remarkable claim that the Religion Clauses must be interpreted to subordinate religious faith because the Founders were committed to reason."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.87.132",
      "id": "ft87.132"
    }
  }, [_vm._v("132")])]), _vm._v(" She and I at least agree on this much: most of the Founders saw no conflict between faith and reason. She says that “[t]he question of whether to privilege faith or reason would not have occurred to the founders for the simple reason that they did not see them as in conflict.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.87.133",
      "id": "ft87.133"
    }
  }, [_vm._v("133")])]), _vm._v(" Professor Smith’s statement that “the founding generation was deeply and pervasively influenced by Protestant thought and practice”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.87.134",
      "id": "ft87.134"
    }
  }, [_vm._v("134")])]), _vm._v(" is irrelevant, according to Professor Sherry, because “the founding generation did not draw the same distinction between faith and reason that we do.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.87.135",
      "id": "ft87.135"
    }
  }, [_vm._v("135")])]), _vm._v(" But of course, if the lack of conflict between faith and reason makes the pervasive commitment to Protestantism irrelevant, it makes the commitment to reason equally irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet Professor Sherry says that somehow the Founders addressed this unrecognized conflict and resolved it in the Constitution. Her preferred resolution is not in the constitutional text, which singles out religion rather than reason. And it could not be in any conscious intention if the Founders did not see the issue. The appeal to unexamined practice in the absence of a real controversy is the most worthless form of intentionalist argument."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.87.136",
      "id": "ft87.136"
    }
  }, [_vm._v("136")])]), _vm._v(" To say the Founders enshrined reason because they reasoned is like saying they enshrined prayer because they prayed. It is considerably weaker than saying "), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("they enshrined seditious libel because they passed the Sedition Act; they at least had a real argument about the Sedition Act, an argument that surfaced the constitutional issues.")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("Professor Sherry attempts to deny that the evangelicals were a major force behind the Religion Clauses. This is, quite simply, preposterous; it is as absurd and inconsistent with the evidence as any belief held by people she accuses of irrationally relying on faith alone. She cites no sources for this proposition, and no responsible historian would support the claim. She does cite legal scholars who disagree with the much more specific and controversial claim that the original intention supports free exercise exemptions for religious objectors."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.88.137",
      "id": "ft88.137"
    }
  }, [_vm._v("137")]), _vm._v(" These citations are accurate but irrelevant; they imply nothing about the role of evangelicals in enacting the Religion Clauses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course the Enlightenment was an important intellectual influence in eighteenth-century America, especially but not exclusively among the elites who led the Constitutional Convention and the First Congress. But the Great Awakening was an equally important intellectual influence. A great religious revival swept through the colonies in the 1740s—through most of the western world in the eighteenth century"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.88.138",
      "id": "ft88.138"
    }
  }, [_vm._v("138")])]), _vm._v("—partly in reaction to the Enlightenment’s rationalizing of religion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.88.139",
      "id": "ft88.139"
    }
  }, [_vm._v("139")])]), _vm._v(" The Great Awakening invigorated the Baptists, Presbyterians, and other evangelical sects and greatly expanded their numbers. And there is simply no doubt that it was these dissenting sects who made religious liberty a central issue of the time. “The chief political demand of Radical Evangelicals was religious toleration.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.88.140",
      "id": "ft88.140"
    }
  }, [_vm._v("140")])]), _vm._v(" It was the evangelicals who provided the political muscle behind the legislative leadership “of a few liberally minded individuals” such as Madison."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.88.141",
      "id": "ft88.141"
    }
  }, [_vm._v("141")])]), _vm._v(" These few individuals “could have accomplished little without the support they received from religious groups opposed to any Church-State connection. The Baptists, the Quakers, and the Presbyterians were specially prominent in this effort.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.88.142",
      "id": "ft88.142"
    }
  }, [_vm._v("142")])]), _vm._v(" “[C]hronologically, the effective efforts of the philosopher-statesmen came only after the ground had been well cleared by the dissenting ministers.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.88.143",
      "id": "ft88.143"
    }
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scholars of unimpeachable strict separationist credentials agree on the "), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("basic outlines of this story. Thus Leonard Levy writes that the Great Awakening “proliferated sects, mainly Separates, Baptist, and New Side Presbyterian, whose dissenter experiences led them to oppose establishments of religion and advance the cause of religious liberty.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.144",
      "id": "ft89.144"
    }
  }, [_vm._v("144")]), _vm._v(" Levy’s history of disestablishment in America starts not with James Madison, but with Isaac Backus and the Baptists."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.145",
      "id": "ft89.145"
    }
  }, [_vm._v("145")])]), _vm._v(" Leo Pfeffer wrote that “the ardent revivalist groups which formed the movement [the Great Awakening] became staunch partisans of the separation of church and state.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.146",
      "id": "ft89.146"
    }
  }, [_vm._v("146")])]), _vm._v(" In considering why the complete separation of church and state first occurred in Virginia, the first reason Pfeffer offers is that “[t]he dissenting sects, particularly the Baptists and Presbyterians, were numerous and well organized; from half to two-thirds of the population were dissenters.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.147",
      "id": "ft89.147"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Madison himself was educated at Princeton from 1769 to 1771, then a New Light Presbyterian college, founded in 1746 as a direct product of the Great Awakening."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.148",
      "id": "ft89.148"
    }
  }, [_vm._v("148")])]), _vm._v(" Some of his friends and classmates became itinerant preachers, and in 1773–74, we find Madison protesting the imprisonment of unlicensed Baptist preachers in Virginia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.149",
      "id": "ft89.149"
    }
  }, [_vm._v("149")])]), _vm._v(" By 1776, he was in the legislature, successfully substituting a guarantee of “free exercise” for a proposed guarantee of “toleration,” and unsuccessfully moving to disestablish the Anglican Church."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.150",
      "id": "ft89.150"
    }
  }, [_vm._v("150")])]), _vm._v(" We can only speculate whether Madison would have eventually become committed to religious liberty for rationalist reasons; it seems clear that in fact he became committed to religious liberty out of sympathy for and persuasion by the evangelicals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever his motivation, it is clear that Madison depended on the evangelicals for votes. He failed in his efforts to defeat the general assessment bill in the Virginia legislature; it passed on two readings and passed again on a vote to engross a bill."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.151",
      "id": "ft89.151"
    }
  }, [_vm._v("151")])]), _vm._v(" But he prevailed on a vote to postpone final reading to the next session, so that members could consult their constituents."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.152",
      "id": "ft89.152"
    }
  }, [_vm._v("152")])]), _vm._v(" In "), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("the ensuing public debate, a great outpouring of evangelical opposition swamped the bill. Madison’s "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v(", which combined religious and rationalist arguments, attracted well under two thousand signatures,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.90.153",
      "id": "ft90.153"
    }
  }, [_vm._v("153")]), _vm._v(" compared with just over one thousand signatures supporting the assessment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.90.154",
      "id": "ft90.154"
    }
  }, [_vm._v("154")])]), _vm._v(" Other petitions, overwhelmingly from the dissenting sects, attracted some "), _c('em', [_vm._v("ten")]), _vm._v(" thousand signatures."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.90.155",
      "id": "ft90.155"
    }
  }, [_vm._v("155")])]), _vm._v(" Many petitions came from Baptist, Presbyterian, and Quaker churches; the single most common petition, with more than twice as many signatures as the "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v(", came from evangelical Christians of unidentified affiliation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.90.156",
      "id": "ft90.156"
    }
  }, [_vm._v("156")])]), _vm._v(" The "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v(" is a brilliant synthesis of many arguments, and Madison’s legislative maneuvering secured the critical opportunity for expression of public opinion, but “to contemporary observers, the work of the evangelicals and particularly the Presbyterians appeared ever more decisive for the outcome.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.90.157",
      "id": "ft90.157"
    }
  }, [_vm._v("157")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The record is most fully developed in Virginia, but there is no doubt that in the other states as well, it was the evangelicals who led the fight for disestablishment. “It was naturally everywhere the nonestablished churches, and particularly the Baptists, who led the movement for disestablishment, which they favored both from reasons of religious conviction and practical advantage.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.90.158",
      "id": "ft90.158"
    }
  }, [_vm._v("158")])]), _vm._v(" Indeed, one of the ironies is that the elites on whom Professor "), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("Sherry relies to show the dominance of reason were disproportionately members of the established Congregational and Episcopal Churches.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("Throughout the ratification process, and into the elections to the First Congress, Madison remained firmly opposed to adding a Bill of Rights or any other amendments to the new Constitution."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.91.159",
      "id": "ft91.159"
    }
  }, [_vm._v("159")]), _vm._v(" In the elections to the Virginia ratifying convention, Madison was forced to campaign for the first time in his life, and Paul Finkelman concludes that a meeting with the Baptist leader John Leland, two days before the election, was “critical” to Madison’s election."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.91.160",
      "id": "ft91.160"
    }
  }, [_vm._v("160")])]), _vm._v(" In the elections to the First Congress, Madison encountered both an anti-Federalist gerrymander and organized opposition from Baptists on the ground of his continued opposition to amendments. To secure the Baptist vote, Madison reminded them of his long service to their cause, and he repeatedly and unequivocally committed himself to work for amendments."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.91.161",
      "id": "ft91.161"
    }
  }, [_vm._v("161")])]), _vm._v(" It is familiar history that in the First Congress he successfully honored this commitment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.91.162",
      "id": "ft91.162"
    }
  }, [_vm._v("162")])]), _vm._v(" But for the Virginia Baptists, we might not have a Bill of Rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have no strong view on the relative overall influence of the Enlightenment and the Great Awakening in eighteenth-century America. On religious liberty issues, the evangelicals appear to have been more important than the Deists. Certainly the evangelicals were necessary; perhaps they would have been sufficient if the Deists had not been available to help. But relative importance or counterfactual speculation is not my point. What is clear is that as history actually developed, there were important roles for both the evangelicals and for sympathetic Episcopalians such as Madison and Jefferson. Religious liberty was the product of an alliance, and neither side in today’s culture wars can claim it as exclusively their own.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.5.6"
    }
  }, [_c('strong', [_vm._v("VI. The Principal Contemporary Issues")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I see three major clusters of contemporary issues, and one large question of how to integrate responses to these issues.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "PT1.1.5.6.1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('strong', [_c('em', [_vm._v("A. Exemptions for Religious Conduct and Religious Organizations")])])])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("Laws that restrict religiously motivated conduct or interfere with the autonomy of religious organizations prima facie violate the Free Exercise Clause."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.92.163",
      "id": "ft92.163"
    }
  }, [_vm._v("163")]), _vm._v(" The Religious Freedom Restoration Act was an appropriate response to the Supreme Court’s unwillingness to enforce the clause."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.92.164",
      "id": "ft92.164"
    }
  }, [_vm._v("164")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is common ground that exemptions expand religious liberty. Exemptions are also consistent with substantive neutrality so long as they do not encourage religious belief or practice. Refusal to exempt is not consistent with neutrality, because government regulation is a powerful incentive not to practice one’s religion, or to conform it to the government’s preferences. Claims for exemption that align with self-interest are problematic because they create incentives to join the exempted faith, and in practice such claims have not been recognized."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.92.165",
      "id": "ft92.165"
    }
  }, [_vm._v("165")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As argued above, nontheists subject to moral compulsion based on their own belief system should be entitled to exemption on the same basis as theists. This is the only neutral solution. It remains the case that exemptions cannot be extended to political disagreement or personal needs whose only analogy to religion is that they may be deeply felt. Just where to draw the line here is difficult, but the nature of the problem is the familiar one of applying old principles to new conditions. The Religion Clauses guarantee government neutrality with respect to answers to religious questions; a new set of answers has become important in our time, and those who give such answers must be treated neutrally. To the extent that they present issues that are analogous to the issues presented by those who give older, more familiar answers, they should be treated under the same rules.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "PT1.1.5.6.2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. Religious Speech")])])])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("There have been vast amounts of litigation over religious speech, where I think the rules should be quite simple."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.93.166",
      "id": "ft93.166"
    }
  }, [_vm._v("166")]), _vm._v(" Private speakers have freedom of speech; religious speech is high value speech (a reasonable textual inference from the Free Exercise Clause); private religious speakers should be as fully protected as though they were discussing politics. With qualifications confined to dictum, that is what the Supreme Court has held."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.93.167",
      "id": "ft93.167"
    }
  }, [_vm._v("167")])]), _vm._v(" Religious speakers are free to use public forums and to speak in places where they have a right to be. They are free to make religious arguments in political debates; any other rule would be transparent viewpoint discrimination."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.93.168",
      "id": "ft93.168"
    }
  }, [_vm._v("168")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By contrast, government speech about religion is tightly circumscribed by the Establishment Clause. Government should not conduct religious observances, and it should not take a position on religious questions. Usually the best course is for government to remain silent and provide ample public forums.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sometimes government must speak about religion, most obviously in public school curricula. It must teach about the role of religion in history and in contemporary society. It must teach about society’s moral expectations, and it is cannot do that honestly without noting that for many citizens, morality has a religious base. In such situations, government must be scrupulously even-handed, treating the range of religious and nonreligious views as neutrally as possible.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "PT1.1.5.6.3"
    }
  }, [_c('strong', [_c('em', [_vm._v("C. Funding")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The third great cluster of issues is funding. It is clear that government cannot give preferential funding to churches or religious activities. After a long evolution of views, I have finally come to the conclusion that government generally should fund religious organizations that fall within the scope of secular programs for funding private activity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.93.169",
      "id": "ft93.169"
    }
  }, [_vm._v("169")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("The easier case is secular services delivered by religious organizations. The neutral course is to fund the secular service without regard to the religious or secular nature of the organization providing the service. We may need to devise accounting rules that separate the cost of the secular from the cost of the religious with as little intrusion into internal church affairs as possible.")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("The harder case is illustrated by "), _c('em', [_vm._v("Rosenberger v. Rector of the University of Virginia")]), _vm._v(","), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.94.170",
      "id": "ft94.170"
    }
  }, [_vm._v("170")]), _vm._v(" where a religious magazine fell within the scope of a program for subsidizing student activities, including publications. Here the activity was clearly religious; the secular benefit was a broad debate that included all views on campus. Perhaps government should not be in the business of funding publications, but if it is there, it should not skew the debate. The more neutral course is to fund everybody.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "PT1.1.5.6.4"
    }
  }, [_c('strong', [_c('em', [_vm._v("D. Reintegrating Disaggregated Neutrality")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I have wondered in earlier work about an arguable contradiction that appears in much work in this area, on all sides of most questions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.94.171",
      "id": "ft94.171"
    }
  }, [_vm._v("171")])]), _vm._v(" I will illustrate principally with my own positions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With respect to the exemptions issue, I say that the most neutral course is usually exemptions. Religion is different from other human activities, and the neutral course is to treat it differently. With respect to government speech, I say government should generally refrain from religious speech; once again, religion is different and the neutral course is to treat it differently. But with respect to the private speech issues and the funding issues, I say that the most neutral course is to treat religion like other private speech and other funded activities. Religion is not so different after all. Am I guilty of wanting substantive neutrality with respect to exemptions and government speech, and formal neutrality with respect to funding and private speech?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I think not. I am arguing for substantive neutrality in all four contexts, but substantive neutrality is sometimes achieved by special treatment for religion and sometimes by identical treatment. Recall that substantive neutrality is about incentives. The goal is to minimize government influence, to avoid distorting private religious choices and commitments. So look at the incentives that are created.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Restrictions on private religious speech discourage religion. They say that speakers can have access to the public forum (a desirable thing from the "), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("perspective of most speakers) if they omit the religious content from their speech. A worship service cannot comply and will abandon the public forum, suffering a penalty for religious speech. But at the margins, speakers can adjust their message. Religious articles can be dropped from magazines; religious references can be dropped from political arguments or public appeals.")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("The University of Virginia unwittingly provided a clear example in "), _c('em', [_vm._v("Rosenberger.")]), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.95.172",
      "id": "ft95.172"
    }
  }, [_vm._v("172")]), _vm._v(" In an effort to show that the Muslim students’ publication was cultural and therefore eligible for funding, the University reported that the publication had previously published articles that were “specifically religious,” that the Student Activities Committee had challenged this content when the magazine’s funding came up for renewal, that the Muslim students had given “adequate reassurance on this point,” and that they then “published a second and very different issue of "), _c('em', [_vm._v("Al-Salam.")]), _vm._v("” The plaintiffs could not have imagined a clearer demonstration of how the power to fund or refuse funding was used to limit the content of student publications. Restricting religious speech skews the marketplace of ideas; in this example, secular viewpoints were amplified and religious viewpoints were restricted. Equal access is substantively neutral; censoring speech is not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The same analysis applies to funding. If I am running a school, or a homeless shelter, or a child welfare agency, and the government says it will fund the social services if I completely segregate them from any church and exclude all religious references, that is a powerful incentive to do what the government asks. Once again government would skew the market; secular social service agencies would expand and religious agencies would contract. Government must be sure that it gets its secular service, which probably justifies nondiscrimination rules, but the neutral course is to fund whoever will provide the service and to not interfere with the religious environment in which some providers deliver the service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With respect to self-interested exemptions, the analysis is the same as for private speech and funding. If religious objectors to paying taxes do not have to pay, there is an incentive to adopt the faith that gives rise to the objection. That is why I carved self-interested exemptions out of my general analysis of exemptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But with respect to most exemptions, exemptions minimize the incentive effects. Most religious behavior is meaningless or burdensome to nonbelievers. I do not want to have a driver’s license without a picture; I would have a harder time cashing checks or proving my identity in other contexts. I do not want to refrain from work on the Sabbath; I am too far behind as it is. I do "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("not want to eat peyote; I would almost certainly throw up. Most exemptions do very little to draw adherents to a faith. But criminal liability or loss of government benefits is a powerful incentive to abandon a faith. Exemptions—treating religion differently—are generally more neutral because they generally minimize government influence on religion.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With respect to government speech, neutrality requires treating religion differently. Certainly religion must be treated differently from the myriad of political issues on which government takes positions and tries to lead opinion. More fundamentally, in many contexts government silence is more neutral than attempts at even-handed speech. It is very hard to discuss religion in a way that is neutral and fair to the myriad of competing views. When government prays, it models a particular form of prayer. It puts its influence behind that form as opposed to all others, and behind prayer as opposed to no prayer at all. When government celebrates Christmas, it puts its influence behind a particular version of how to celebrate Christmas—usually a secularized version, sometimes a devout version, always a public version—but a particular version, whatever it chooses. Government influence on religion is generally minimized by government silence and a public forum that is wide open to the broad range of views about religion that compete in the private sector.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("Michael McConnell has argued that when government is large, government silence on matters of religion is itself a distortion of public discourse and a departure from neutrality."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.96.173",
      "id": "ft96.173"
    }
  }, [_vm._v("173")]), _vm._v(" He has proposed a different measure of neutrality with respect to government speech:")]), _vm._v(" "), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_vm._v("If the aspects of culture controlled by the government (public spaces, public institutions) exactly mirrored the culture as a whole, then the influence and effect of government involvement would be nil; the religious life of the people would be precisely the way it would be if the government were absent from the cultural sphere."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.96.174",
      "id": "ft96.174"
    }
  }, [_vm._v("174")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This is logically perfect and practically disastrous. Government has no way to “exactly mirror[] the culture as a whole,” or even to get in the ballpark. It has only the vaguest notion of how many Christians, Jews, Muslims, atheists, etc., are in the population, and no idea whatever of the distribution of views over how to celebrate Christmas, whether and how to take public note of Hanukkah, Passover, or Purim, or what are the means of salvation. In practice, Professor "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("McConnell’s approach would lead to predominant government expression of majoritarian religious views, diluted to appeal to the largest possible coalition, with occasional nods to influential minorities. In short, government statements on religion would be indistinguishable from those of a relatively tolerant government with an established church.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A far better way to make the public sphere mirror the culture is to open public forums to religious speech and to clearly provide that the responsibility for religious speech in those forums lies exclusively with the private sector. Religion is vibrant in the private sector; in such a regime, the public square would not remain naked for a single season. Those people who cared enough to say anything would say what they wanted, and we would get some sense of the distribution of views in the culture. Thus, with respect to government speech, I adhere to the view that the most nearly neutral course is for government to be quiet and let the private sector do it.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.5.7"
    }
  }, [_c('strong', [_vm._v("VII. Conclusion: A Personal Note")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("Almost twenty years ago, I circulated the manuscript of my first article on religious liberty, a comment on the Seventh Circuit’s decision in "), _c('em', [_vm._v("Catholic Bishop v. NLRB.")]), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.97.175",
      "id": "ft97.175"
    }
  }, [_vm._v("175")]), _vm._v(" The first footnote said that I was not a Catholic and had never been one. Professor (now Justice) Scalia, then my colleague, crossed out the footnote and wrote in the margins, “Never give the bastards any comfort.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We never discussed this marginal note, but I took “the bastards” to be anti-Catholic bigots, and I decided he was right, at least in part. He may have over-estimated the number of anti-Catholic bigots, but he had correctly inferred the reason for the footnote. The article showed familiarity with Catholic sources, it would be a reasonable inference from that familiarity that I might be Catholic, and I was embarrassed by the possibility that anyone might draw that inference about me. Especially in an academic environment, I did not want anyone to think that I held beliefs that seemed to me so untestable and implausible. I was not worried about tenure, or discrimination, or even that anyone would ever say anything to me. I was projecting my own inability to comprehend belief; I did not want anyone to think that I was gullible enough to be a Catholic. From Scalia’s perspective, to disclaim Catholicism might give the bastards comfort because it implied these attitudes "), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("and put them in print. The footnote implied that Catholicism is the sort of movement that requires a disclaimer or disassociation, in the same way a scholar might disclaim any sympathy with the Ku Klux Klan in an article defending the Klan’s free speech rights.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More generally, I decided that my views on religion were and should be irrelevant to my views on religious liberty. The whole point of religious liberty, it seemed to me, was that people from across the whole range of views about religion agree to respect the religious liberty of everyone else across the whole range of views about religion. Religious liberty only or principally for people of one’s own views would not be religious liberty at all; that was the Puritan mistake in seventeenth-century Massachusetts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So I took out the footnote, and I have since worked in this field without referring to my own views about religion. I have never concealed anything, but only very rarely have I volunteered anything. I have been disappointed at the widespread tendency to assume that I must share the religious views of whatever client I am representing at the moment. People have explicitly assumed over the years that I must be Catholic, Jewish, Presbyterian, or evangelical; I do not know what people thought about the Christian Scientists, the Hare Krishnas, and the Santeria. The underlying assumption must be that I am most likely to defend religious liberty for my own faith group, or at least for some group in strategic or tactical alliance with my own faith group. This is the Puritan mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I break silence now, after all these years, because the Puritan mistake has taken on new significance as I come to better understand the new axes of religious conflict. I have gradually come to realize that one of the more serious threats to religious liberty is from people who think very much like me about religion, and who, because their commitment to winning their religious disputes exceeds their commitment to religious liberty, want to subordinate or marginalize religious views. Consequently, I now see a new cost to letting people make false assumptions about my religious beliefs—not that I might be embarrassed, but that my arguments about liberty might be discounted as mere special pleading on behalf of my presumed religious commitments. I have some concern that once I go public, believers will discount my arguments instead. That too would be the Puritan mistake, and I hope I have enough accumulated credibility with that side that the risk is small. So here goes. Whatever mistakes I may have made, I at least have not made the Puritan mistake.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("I am agnostic about matters of religion. None of the claims of the world’s religions seem to me either plausible or falsifiable. A Creator God who set the universe in motion is hard to imagine, but so are all the other explanations ")]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("for the origins of the universe. Assuming there might be such a God, I find all claims about the details of His/Her nature and intentions to be wildly implausible. No God has given me the slightest hint of His/Her existence; if there is a God Who wants me to believe in Him/Her, He/She should quit being so secretive. I am inclined to think that humans create God in their own images—that knowing nothing whatever of God, most people impute to God those traits they think an attractive God should have.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("All my early sympathies were with the nonbelieving minority. As a high school sophomore, flush with adolescent excitement from reading Thomas Paine,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.99.176",
      "id": "ft99.176"
    }
  }, [_vm._v("176")]), _vm._v(" I walked out of the school Christmas assembly in constitutional protest. The principal was not interested in my explanation of the Establishment Clause, and I felt victimized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As a law student, I was outraged at "), _c('em', [_vm._v("Walz v. Tax Commission.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.99.177",
      "id": "ft99.177"
    }
  }, [_vm._v("177")])]), _vm._v(" I entered the field of religious liberty enthusiastic about the Establishment Clause and eager to defend the rights of nonbelievers. But from the very beginning, I at least recognized the central premise that religious liberty must protect people of all views about religion. And as it turned out, I have had many more occasions to defend the rights of believers than of nonbelievers. Lawyers for theists with viable claims call me continuously; only once in twenty years have I gotten a call from a lawyer for an atheist with a viable claim. I have had occasion to challenge establishments of religion"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.99.178",
      "id": "ft99.178"
    }
  }, [_vm._v("178")])]), _vm._v(" and to challenge broad arguments for why some kinds of establishments should be permitted."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.99.179",
      "id": "ft99.179"
    }
  }, [_vm._v("179")])]), _vm._v(" But the dominant forces of regulation are more at odds with traditional believers than with nonbelievers; my experience has been that believers’ rights are violated more often than nonbelievers’ rights. And over the years, I have come to realize that some of my early conceptions of the Establishment Clause reflected special pleading for my own religious views rather than neutrality toward all religious views. I now think that "), _c('em', [_vm._v("Walz")]), _vm._v(" was right and that the mistake came in "), _c('em', [_vm._v("Jimmy Swaggart Ministries v. Board of Equalization.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.99.180",
      "id": "ft99.180"
    }
  }, [_vm._v("180")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("My epistemological views are largely those of Professor Sherry."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.100.181",
      "id": "ft100.181"
    }
  }, [_vm._v("181")]), _vm._v(" In my own decision making, I am a rationalist, a reasoner, an empiricist. I got extreme scores on the “Thinker” variable when I once had to take the Myers-Briggs Personality Inventory. Personal feelings and claims of personal revelation are important facts about human beings, never safely ignored, but they are not in my view a method of making judgments. In terms of the fundamental religious split in the culture, I am firmly on Professor Sherry’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But hostility to theistic religion need not follow from this worldview. I went through my period of hostility to theistic religion, went through my period of stick figure caricatures of believers, and I learned better. I learned that highly intelligent and accomplished people are devout believers—indeed, that they believe that they have personally experienced the presence of God. I learned that believers reason just as well as nonbelievers on average, and that most believers do not see the conflict between faith and reason that Professor Sherry posits. I learned that religious faith is a powerful force for good in the lives of many believers. I learned that the great religious traditions often embody accumulated wisdom, whatever its sources and whatever the accumulated baggage of positions that seem to me mistaken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I believed as a sophomore, and I believe now, that organized religion has done great harm in the world. But in the interim I have attended to the rather obvious fact that this does not distinguish organized religion from any other human institution. Reason is prone to its own set of excesses; reasoners often carry out ideas to the limits of their logic, without regard to competing values or common sense or accumulated wisdom. Stephen Jay Gould, as secular a reasoner as one could wish for, often writes about the mistakes of scientists who reason from a mistaken premise or a cultural prejudice, or who reason beyond the limits of data or common sense."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.100.182",
      "id": "ft100.182"
    }
  }, [_vm._v("182")])]), _vm._v(" Paul Johnson, a less sympathetic "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("witness, has blamed the influence of reasoning intellectuals for many of the policy disasters of modern history."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.101.183",
      "id": "ft101.183"
    }
  }, [_vm._v("183")]), _vm._v(" He exaggerates; his book is an example of the excessive pursuit of a single idea that he criticizes in others. But he supplies ample illustrations of my point: like organized religion, secular reasoning has also done great harm in the world. I am a direct intellectual descendant of the Enlightenment, comfortable with Enlightenment methodologies and with no other. But I recognize that among the Enlightenment’s first fruits were the Terror, the persecution of the Catholic Church in France, and the Napoleonic Wars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The preceding two paragraphs are a statement of tolerance and respect for beliefs that I cannot begin to share. But this renewed respect for religion is not the source of my commitment to religious liberty. Both chronology and causation are clear: the source of my respect for religion was frequent contact with sophisticated believers, and one of the sources of those contacts was my work on behalf of religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It probably is the case that my agnostic view of religion predisposes me to an agnostic explanation for religious liberty. But as I have written before, this equation of different levels or kinds of agnosticism is “misleading in an important way.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.101.184",
      "id": "ft101.184"
    }
  }, [_vm._v("184")])])]), _vm._v(" "), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_vm._v("An agnostic has no opinion on whether God exists, and neither should the government. But an agnostic also believes that humans are incapable of knowing whether God exists. If the government believed that, it would prefer agnostics over theists and atheists. Agnostics have no opinion for epistemological reasons; the government must have no opinion for constitutional reasons. The government must have no opinion because it is not the government’s role to have an opinion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.101.185",
      "id": "ft101.185"
    }
  }, [_vm._v("185")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Excluding the government from religious opinions entails interpreting the Constitution in a way that is free of religious opinions. And this commitment to a government free of religious opinions should be part of religious liberty whatever one’s views about religion. To explain religious liberty on either theistic or anti-theistic grounds is to make a diluted form of the Puritan mistake. It is to say that religious liberty is principally for the benefit of people on "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("only one side of a great dividing line on the religious spectrum. But in my view of religious liberty, the goal is to enable people on both sides of such divides to live together in peace and equality and without surrender of religious autonomy.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft55.1",
      "id": "fn.55.1"
    }
  }, [_vm._v("1")]), _vm._v(". Lemon v. Kurtzman, 403 U.S. 602, 612 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft55.2",
      "id": "fn.55.2"
    }
  }, [_vm._v("2")]), _vm._v(". "), _c('em', [_vm._v("Contra")]), _vm._v(", John H. Garvey, "), _c('em', [_vm._v("An Anti-Liberal Argument for Religious Freedom")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 275, 291 (1996). For another argument that religious liberty can be explained only by a commitment to theistic religion (perhaps only by a commitment to true religion, but this is not clear), see Steven D. Smith, "), _c('em', [_vm._v("The Rise and Fall of Religious Freedom in Constitutional Discourse")]), _vm._v(", 140 U. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 149 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft55.3",
      "id": "fn.55.3"
    }
  }, [_vm._v("3")]), _vm._v(". "), _c('em', [_vm._v("Contra")]), _vm._v(", Suzanna Sherry, "), _c('em', [_vm._v("Enlightening the Religion Clauses")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 473 (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft55.4",
      "id": "fn.55.4"
    }
  }, [_vm._v("4")]), _vm._v(". "), _c('em', [_vm._v("Contra")]), _vm._v(", Church of the Holy Trinity v. United States, 143 U.S. 457, 471 (1892).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft55.5",
      "id": "fn.55.5"
    }
  }, [_vm._v("5")]), _vm._v(". "), _c('em', [_vm._v("Contra")]), _vm._v(", Kathleen M. Sullivan, "), _c('em', [_vm._v("Religion and Liberal Democracy")]), _vm._v(", 59 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 195, 198 (1992).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft55.6",
      "id": "fn.55.6"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('em', [_vm._v("Compare, e.g.")]), _vm._v(", Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2"
    }
  }, [_vm._v("note 2")]), _vm._v(" (arguing that eighteenth-century America was pervasively Protestant, and that the Constitution reflects Protestant views), "), _c('em', [_vm._v("with, e.g.")]), _vm._v(", Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.3"
    }
  }, [_vm._v("note 3")]), _vm._v(" (arguing that eighteenth-century America was pervasively committed to reason, and that the Constitution reflects rationalist views).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft56.7",
      "id": "fn.56.7"
    }
  }, [_vm._v("7")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(" Mark Tushnet, "), _c('em', [_vm._v("The Constitution of Religion")]), _vm._v(", 18 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 701, 729 (1986) (“Constitutionalists today are committed to developing a law of religion even though they do not understand why they have to do so.”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft56.8",
      "id": "fn.56.8"
    }
  }, [_vm._v("8")]), _vm._v(". Yes, and the Second Amendment too, although the preamble’s recital that the holders of this right are to be “well-regulated” implies a very different sort of right from the textually absolute rights created in the First Amendment. For further insightful comparison of the First and Second Amendments, see L. A. Powe, "), _c('em', [_vm._v("Guns, Words, and Constitutional Interpretation")]), _vm._v(", 38 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1311 (1997).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.9",
      "id": "fn.57.9"
    }
  }, [_vm._v("9")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.3"
    }
  }, [_vm._v("note 3")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.10",
      "id": "fn.57.10"
    }
  }, [_vm._v("10")]), _vm._v(". Steven D. Smith, "), _c('em', [_vm._v("Unprincipled Religious Freedom")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 497, 503–04 (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.11",
      "id": "fn.57.11"
    }
  }, [_vm._v("11")]), _vm._v(". Garvey, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2"
    }
  }, [_vm._v("note 2")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.12",
      "id": "fn.57.12"
    }
  }, [_vm._v("12")]), _vm._v(". S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TEVEN")]), _vm._v(" D. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MITH")]), _vm._v(", F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OREORDAINED")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AILURE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UEST")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTIONAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RINCIPLE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOM")]), _vm._v(" (1995).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.13",
      "id": "fn.57.13"
    }
  }, [_vm._v("13")]), _vm._v(". Susanna Sherry, "), _c('em', [_vm._v("Lee v. Weisman: Paradox Redux")]), _vm._v(", 1992 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 123.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.14",
      "id": "fn.57.14"
    }
  }, [_vm._v("14")]), _vm._v(". William P. Marshall, "), _c('em', [_vm._v("Religion as Ideas: Religion as Identity")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 385, 392–94 (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.15",
      "id": "fn.57.15"
    }
  }, [_vm._v("15")]), _vm._v(". Michael J. Perry, "), _c('em', [_vm._v("Religion, Politics, and the Constitution")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 407, 437–46 (1996); Abner Greene, "), _c('em', [_vm._v("The Irreducible Constitution")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 293, 303–05 (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft57.16",
      "id": "fn.57.16"
    }
  }, [_vm._v("16")]), _vm._v(". Greene, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.15"
    }
  }, [_vm._v("note 15")]), _vm._v("; Ira C. Lupu, "), _c('em', [_vm._v("To Protect Religious Liberty and Control Religious Faction: A General Theory of the Religion Clauses")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 357 (1996); Perry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.15"
    }
  }, [_vm._v("note 15")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft58.17",
      "id": "fn.58.17"
    }
  }, [_vm._v("17")]), _vm._v(". Maimon Schwarzschild, "), _c('em', [_vm._v("Pluralism, Interpretation, Religion, and the First Amendment")]), _vm._v(", 7 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGAL")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUES")]), _vm._v(" 447 (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft58.18",
      "id": "fn.58.18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('em', [_vm._v("Contra")]), _vm._v(", Marshall, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.14"
    }
  }, [_vm._v("note 14")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft59.19",
      "id": "fn.59.19"
    }
  }, [_vm._v("19")]), _vm._v(". For an overview that collects historical sources, see Douglas Laycock, "), _c('em', [_vm._v("Continuity and Change in the Threat to Religious Liberty: The Reformation Era and the Late Twentieth Century")]), _vm._v(", 80 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1047, 1049–66 (1996) (text at notes 3–142).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft59.20",
      "id": "fn.59.20"
    }
  }, [_vm._v("20")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOMS")]), _vm._v(": C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASSAGE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MENDMENT")]), _vm._v(" (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft59.21",
      "id": "fn.59.21"
    }
  }, [_vm._v("21")]), _vm._v(". J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(", M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMORIAL")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMONSTRANCE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GAINST")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STABLISHMENTS")]), _vm._v(" ¶11 (1785), reprinted in Everson v. Board of Educ., 330 U.S. 1, 69 (appendix to opinion of Rutledge, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft60.22",
      "id": "fn.60.22"
    }
  }, [_vm._v("22")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSEPH")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AGAN")]), _vm._v(", W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HY")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATTERS")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MPACT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RACTICE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OCIAL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TABILITY")]), _vm._v(" (1995) (collecting studies).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft60.23",
      "id": "fn.60.23"
    }
  }, [_vm._v("23")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("“Nonpreferential” Aid to Religion: A False Claim About Original Intent")]), _vm._v(", 27 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 875, 918 & nn.223–26 (1986) (collecting historical sources).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft60.24",
      "id": "fn.60.24"
    }
  }, [_vm._v("24")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URNER")]), _vm._v(", W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITHOUT")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")]), _vm._v(", W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITHOUT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REED")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIGINS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NBELIEF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" 44–47 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft61.25",
      "id": "fn.61.25"
    }
  }, [_vm._v("25")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("The Benefits of the Establishment Clause")]), _vm._v(", 42 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 373, 374–75 (1992) (text at notes 3–4) (conceding that constitutional protection of religious liberty “entails one choice about types of religion,” but arguing that this “is a principled choice, based on the view that the best you can do to maximize religious liberty for all citizens is to prevent anyone from using the government for religious purposes.”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft61.26",
      "id": "fn.61.26"
    }
  }, [_vm._v("26")]), _vm._v(". An earlier version of this formulation appears in Douglas Laycock, "), _c('em', [_vm._v("Formal, Substantive, and Disaggregated Neutrality Toward Religion")]), _vm._v(", 39 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 993, 1002 (1990) (text at notes 27–28). I have added the phrase “and private commitment” after “private choice,” to avoid the unintentional exclusion of believers who feel bound by religious commitments with no sense of having chosen them. See text at note 47 "), _c('em', [_vm._v("infra.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft61.27",
      "id": "fn.61.27"
    }
  }, [_vm._v("27")]), _vm._v(". For further argument, see Douglas Laycock, "), _c('em', [_vm._v("The Remnants of Free Exercise")]), _vm._v(", 1990 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1; Michael W. McConnell, "), _c('em', [_vm._v("Free Exercise Revisionism and the Smith Decision")]), _vm._v(", 57 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1109 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft62.28",
      "id": "fn.62.28"
    }
  }, [_vm._v("28")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.26"
    }
  }, [_vm._v("note 26")]), _vm._v("; "), _c('em', [_vm._v("see also")]), _vm._v(" Church of the Lukumi Babalu Aye, Inc. v. City of Hialeah, 508 U.S. 520, 562 (Souter, J., concurring) (distinguishing substantive and formal neutrality in similar terms).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft62.29",
      "id": "fn.62.29"
    }
  }, [_vm._v("29")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.26"
    }
  }, [_vm._v("note 26")]), _vm._v(", at 1001 (text at "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.27"
    }
  }, [_vm._v("note 27")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft62.30",
      "id": "fn.62.30"
    }
  }, [_vm._v("30")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1002 (text at "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.62.28"
    }
  }, [_vm._v("note 28")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft62.31",
      "id": "fn.62.31"
    }
  }, [_vm._v("31")]), _vm._v(". See Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.25"
    }
  }, [_vm._v("note 25")]), _vm._v(", at 379 (text at notes 19–20) (“[I]f I had to give up one of the rights in the First Amendment, this is the one I would give up.”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft63.32",
      "id": "fn.63.32"
    }
  }, [_vm._v("32")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.13"
    }
  }, [_vm._v("note 13")]), _vm._v(", at 149 (“[G]ranting an exemption sends a message of endorsement of religious over secular beliefs and relegates nonbelievers to the status of outsiders.”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft63.33",
      "id": "fn.63.33"
    }
  }, [_vm._v("33")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("“Noncoercive” Support for Religion: Another False Claim About the Establishment Clause")]), _vm._v(", 26 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 37, 43–44 (1991) (text at notes 38–40) (reviewing complaints that incorporation of Episcopal Church gave it “the Honour of an important name” and “the particular sanction” of the legislature).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft63.34",
      "id": "fn.63.34"
    }
  }, [_vm._v("34")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Lee v. Weisman, 505 U.S. 577, 593–99 (1992) (opinion of the Court by Kennedy, J.) (finding coercion in “public pressure, as well as peer pressure … though subtle and indirect”); County of Allegheny v. ACLU, 492 U.S. 573, 660–61 (1989) (Kennedy, J., dissenting in part) (arguing that coercion may be “indirect,” and implying that “the permanent erection of a large Latin cross on the roof of city hall” would be coercive).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft64.35",
      "id": "fn.64.35"
    }
  }, [_vm._v("35")]), _vm._v(". Lynch v. Donnelly, 465 U.S. 668, 688 (1984) (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft64.36",
      "id": "fn.64.36"
    }
  }, [_vm._v("36")]), _vm._v(". Brown v. Board of Educ., 349 U.S. 294, 300 (1955).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft65.37",
      "id": "fn.65.37"
    }
  }, [_vm._v("37")]), _vm._v(". Garvey, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2"
    }
  }, [_vm._v("note 2")]), _vm._v(", at 275–82; Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2"
    }
  }, [_vm._v("note 2")]), _vm._v(", at 202–04, 207–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft65.38",
      "id": "fn.65.38"
    }
  }, [_vm._v("38")]), _vm._v(". For a summary with citations to sources, see Douglas Laycock, "), _c('em', [_vm._v("A Survey of Religious Liberty in the United States")]), _vm._v(", 47 O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIO")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". L.J. 409, 416–20 (1986) (text at notes 38–76).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft65.39",
      "id": "fn.65.39"
    }
  }, [_vm._v("39")]), _vm._v(". That may be my fault. See the unnumbered note p. 54 "), _c('em', [_vm._v("supra.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft66.40",
      "id": "fn.66.40"
    }
  }, [_vm._v("40")]), _vm._v(". For a longer but still not exhaustive list of reasons gathered from recent literature, see William P. Marshall, "), _c('em', [_vm._v("Truth and the Religion Clauses")]), _vm._v(", 43 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 243 (1994).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft66.41",
      "id": "fn.66.41"
    }
  }, [_vm._v("41")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20"
    }
  }, [_vm._v("note 20")]), _vm._v(", at 134–40, 163–73; L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EONARD")]), _vm._v(" W. L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STABLISHMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAUSE")]), _vm._v(": R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MENDMENT")]), _vm._v(" 30–34, 63–67 (2d ed. 1994); "), _c('em', [_vm._v("infra")]), _vm._v(" text accompanying "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.87.132"
    }
  }, [_vm._v("notes 132–62")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft66.42",
      "id": "fn.66.42"
    }
  }, [_vm._v("42")]), _vm._v(". For accounts, see L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.41"
    }
  }, [_vm._v("note 41")]), _vm._v(", at 36–52; J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" T. N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OONAN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIEVER")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWERS")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAT")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RE")]), _vm._v(" 159–60 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft66.43",
      "id": "fn.66.43"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('em', [_vm._v("Contra")]), _vm._v(", Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.12"
    }
  }, [_vm._v("note 12")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft66.44",
      "id": "fn.66.44"
    }
  }, [_vm._v("44")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.23"
    }
  }, [_vm._v("note 23")]), _vm._v(", at 879–81, 906–08 (text at notes 26–37, 166–72).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft67.45",
      "id": "fn.67.45"
    }
  }, [_vm._v("45")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Kurt T. Lash, "), _c('em', [_vm._v("The Second Adoption of the Establishment Clause: The Rise of the Nonestablishment Principle")]), _vm._v(", 27 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIZ")]), _vm._v(". S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". L.J. 1085 (1995); Kurt T. Lash, "), _c('em', [_vm._v("The Second Adoption of the Free Exercise Clause: Religious Exemptions Under the Fourteenth Amendment")]), _vm._v(", 88 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1106 (1994).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft67.46",
      "id": "fn.67.46"
    }
  }, [_vm._v("46")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.21"
    }
  }, [_vm._v("note 21")]), _vm._v(", ¶ 1 at 64 (“Religion or the duty which we owe to our Creator and the Manner of discharging it, can be directed only by reason and conviction, not by force or violence”) (quoting Va. Declaration of Rights art. 16); Garvey, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2"
    }
  }, [_vm._v("note 2")]), _vm._v("; Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2"
    }
  }, [_vm._v("note 2")]), _vm._v(", at 154–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft67.47",
      "id": "fn.67.47"
    }
  }, [_vm._v("47")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Mary Ann Glendon, "), _c('em', [_vm._v("Law, Communities, and the Religious Freedom Language of the Constitution")]), _vm._v(", 60 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH")]), _vm._v(". L. Rev. 672, 678–79 (1992); Michael J. Sandel, "), _c('em', [_vm._v("Freedom of Conscience or Freedom of Choice?")]), _vm._v(", in A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RTICLES")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AITH")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RTICLES")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EACE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAUSES")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBLIC")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILOSOPHY")]), _vm._v(" 74, 85–89 (James Davison Hunter & Os Guinness, eds., 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft67.48",
      "id": "fn.67.48"
    }
  }, [_vm._v("48")]), _vm._v(". Marshall, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.14"
    }
  }, [_vm._v("note 14")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft68.49",
      "id": "fn.68.49"
    }
  }, [_vm._v("49")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARK")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLFE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWE")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARDEN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILDERNESS")]), _vm._v(" 5–6 (1965) (quoting Roger Williams, "), _c('em', [_vm._v("Mr. Cotton’s Letter Lately Printed, Examined and Answered")]), _vm._v("); "), _c('em', [_vm._v("see generally")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWE")]), _vm._v(", "), _c('em', [_vm._v("supra;")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DWIN")]), _vm._v(" S. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUSTAD")]), _vm._v(", L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCIENCE")]), _vm._v(": R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OGER")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLIAMS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft68.50",
      "id": "fn.68.50"
    }
  }, [_vm._v("50")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDREW")]), _vm._v(" M. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REELEY")]), _vm._v(", R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HANGE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" 126–27 (1989) (reporting survey data showing that difference in religious participation between United States and Great Britain is entirely explained by lower participation of members of established Church of England); M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.21"
    }
  }, [_vm._v("note 21")]), _vm._v(", ¶ 7 at 68 (arguing that fruits of establishment had been “pride and indolence in the Clergy; ignorance and servility in the laity; in both, superstition, bigotry and persecution”); "), _c('em', [_vm._v("see also")]), _vm._v(" R. Stephen Warner, "), _c('em', [_vm._v("Work in Progress Toward a New Paradigm for the Sociological Study of Religion in the United States")]), _vm._v(", 98 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". J. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OC")]), _vm._v(". 1044, 1048–58 (1993) (exploring the relationship between disestablishment and measures of religious vitality).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft68.51",
      "id": "fn.68.51"
    }
  }, [_vm._v("51")]), _vm._v(". M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.21"
    }
  }, [_vm._v("note 21")]), _vm._v(", ¶ 1 at 64 (“This duty [to the Creator] is precedent both in order of time and degree of obligation, to the claims of Civil Society.”); McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.27"
    }
  }, [_vm._v("note 27")]), _vm._v(", at 1150–52; Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.2"
    }
  }, [_vm._v("note 2")]), _vm._v(", at 154.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft69.52",
      "id": "fn.69.52"
    }
  }, [_vm._v("52")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Book Note, F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HINGS")]), _vm._v(" No. 63 at 66 (May 1996) (deriding the claim that a single Ultimate “lies behind each of the great religious traditions”) (reviewing M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAN")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AY")]), _vm._v("? F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUR")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IEWS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALVATION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LURALISTIC")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORLD")]), _vm._v(" (Dennis L. Okholm & Timothy R. Phillips, eds.).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.53",
      "id": "fn.70.53"
    }
  }, [_vm._v("53")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVISON")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UNTER")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULTURE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARS")]), _vm._v(" (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.54",
      "id": "fn.70.54"
    }
  }, [_vm._v("54")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILLIP")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHNSON")]), _vm._v(", R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EASON")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALANCE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GAINST")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATURALISM")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CIENCE")]), _vm._v(", L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DUCATION")]), _vm._v(" (1995).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.55",
      "id": "fn.70.55"
    }
  }, [_vm._v("55")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETER")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEFT")]), _vm._v(", E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CUMENICAL")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IHAD")]), _vm._v(" 17–21 (1996) (“The abolition of God entails the abolition of man, the abolition of the specifically human faculty of conscience, God’s prophet in the soul. The authority of conscience, like that of any prophet, depends on the authority of God.”); R. C. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PROUL")]), _vm._v(", E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THICS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIAN")]), _vm._v(" 28 (1986) (“Without God the only possible end of ethical reflection is chaos.”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.56",
      "id": "fn.70.56"
    }
  }, [_vm._v("56")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUCE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CKERMAN")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OCIAL")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USTICE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERAL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" 280–81 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.57",
      "id": "fn.70.57"
    }
  }, [_vm._v("57")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.3"
    }
  }, [_vm._v("note 3")]), _vm._v(", at 491, 493.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.58",
      "id": "fn.70.58"
    }
  }, [_vm._v("58")]), _vm._v(". "), _c('em', [_vm._v("See id.;")]), _vm._v(" Suzanna Sherry, "), _c('em', [_vm._v("The Sleep of Reason")]), _vm._v(", 84 Geo. L.J. 453 (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.59",
      "id": "fn.70.59"
    }
  }, [_vm._v("59")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEFT")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.55"
    }
  }, [_vm._v("note 55")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft70.60",
      "id": "fn.70.60"
    }
  }, [_vm._v("60")]), _vm._v(". For further analysis, see Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.19"
    }
  }, [_vm._v("note 19")]), _vm._v(", at 1069–89 (text at notes 166–248).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.61",
      "id": "fn.71.61"
    }
  }, [_vm._v("61")]), _vm._v(". Norman Dorsen, "), _c('em', [_vm._v("The Religion Clauses and Nonbelievers")]), _vm._v(", 27 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 863, 868 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.62",
      "id": "fn.71.62"
    }
  }, [_vm._v("62")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EWEY")]), _vm._v(", A C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMON")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AITH")]), _vm._v(" (1934) (proposing a religion based on faith in the accumulated values of human civilization); "), _c('em', [_vm._v("Humanist Manifesto I")]), _vm._v(", 6 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMANIST")]), _vm._v(" No. 3 (1933), "), _c('em', [_vm._v("reprinted in")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORLISS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMONT")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILOSOPHY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMANISM")]), _vm._v(" 285 (7th ed. 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.63",
      "id": "fn.71.63"
    }
  }, [_vm._v("63")]), _vm._v(". "), _c('em', [_vm._v("Humanist Manifesto I, supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.62"
    }
  }, [_vm._v("note 62")]), _vm._v(", at 285.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.64",
      "id": "fn.71.64"
    }
  }, [_vm._v("64")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.65",
      "id": "fn.71.65"
    }
  }, [_vm._v("65")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 286.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.66",
      "id": "fn.71.66"
    }
  }, [_vm._v("66")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 288.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.67",
      "id": "fn.71.67"
    }
  }, [_vm._v("67")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 286–87.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft71.68",
      "id": "fn.71.68"
    }
  }, [_vm._v("68")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 287.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft72.69",
      "id": "fn.72.69"
    }
  }, [_vm._v("69")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 287; "), _c('em', [_vm._v("see generally")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URNER")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.24"
    }
  }, [_vm._v("note 24")]), _vm._v(" (documenting the historic intellectual path from traditional Christianity though deism and modernism to agnosticism and atheism).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft72.70",
      "id": "fn.72.70"
    }
  }, [_vm._v("70")]), _vm._v(". "), _c('em', [_vm._v("Humanist Manifesto II")]), _vm._v(", H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMANIST")]), _vm._v(" (Sept./Oct. 1973), reprinted in L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMONT")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.71.62"
    }
  }, [_vm._v("note 62")]), _vm._v(", at 290, 291.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft72.71",
      "id": "fn.72.71"
    }
  }, [_vm._v("71")]), _vm._v(". J. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORDON")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELTON")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCYCLOPEDIA")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIONS")]), _vm._v(" 145–58 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft72.72",
      "id": "fn.72.72"
    }
  }, [_vm._v("72")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URTZ")]), _vm._v(", A S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECULAR")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMANIST")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECLARATION")]), _vm._v(" (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft72.73",
      "id": "fn.72.73"
    }
  }, [_vm._v("73")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URTZ")]), _vm._v(", L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVING")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITHOUT")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(": E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPRAXOPHY")]), _vm._v(" 8 (1994). I have to doubt that the word “eupraxophy” is going to catch on.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft73.74",
      "id": "fn.73.74"
    }
  }, [_vm._v("74")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 9–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft73.75",
      "id": "fn.73.75"
    }
  }, [_vm._v("75")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.19"
    }
  }, [_vm._v("note 19")]), _vm._v(", at 1081–82 (text at notes 216–19).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft73.76",
      "id": "fn.73.76"
    }
  }, [_vm._v("76")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Wooley v. Maynard, 430 U.S. 705, 713–17 (1977); West Virginia Board of Education v. Barnette, 319 U.S. 624 (1943).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft73.77",
      "id": "fn.73.77"
    }
  }, [_vm._v("77")]), _vm._v(". For a much more fully developed but essentially consistent argument that secular humanism must be treated as a religion for constitutional purposes, see Mary Harter Mitchell, "), _c('em', [_vm._v("Secularism in Public Education: The Constitutional Issues")]), _vm._v(", 67 B.U. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 603, 627–63 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft74.78",
      "id": "fn.74.78"
    }
  }, [_vm._v("78")]), _vm._v(". 42 U.S.C. §§ 2000bb to 2000bb-4 (1994).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft74.79",
      "id": "fn.74.79"
    }
  }, [_vm._v("79")]), _vm._v(". 508 U.S. 520 (1993).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft74.80",
      "id": "fn.74.80"
    }
  }, [_vm._v("80")]), _vm._v(". 494 U.S. 872 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft74.81",
      "id": "fn.74.81"
    }
  }, [_vm._v("81")]), _vm._v(". For the proposition that religious speech is protected by both clauses, see Capitol Square Review & Advisory Bd. v. Pinette, 515 U.S. 753, 767 (1995) (plurality opinion); Board of Educ. v. Mergens, 496 U.S. 226, 250 (1990) (plurality opinion); Largent v. Texas, 318 U.S. 418, 422 (1943); Douglas Laycock, "), _c('em', [_vm._v("Freedom of Speech That Is Both Religious and Political")]), _vm._v(", 29 U.C. D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVIS")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 793 (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft74.82",
      "id": "fn.74.82"
    }
  }, [_vm._v("82")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Serbian E. Orthodox Diocese v. Milivojevich, 426 U.S. 696, 723 (1976) (holding that Constitution precludes “searching and therefore impermissible inquiry” into questions of religious doctrine or administration); EEOC v. Catholic Univ., 83 F.3d 455, 460–62 (D.C. Cir. 1996) (holding that constitutional protection for internal management of religious organization survived "), _c('em', [_vm._v("Employment Div. v. Smith")]), _vm._v(", 484 U.S. 872 (1990)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft74.83",
      "id": "fn.74.83"
    }
  }, [_vm._v("83")]), _vm._v(". In re Young, 82 F.3d 1407, 1418 (8th Cir. 1996) (interpreting RFRA to protect “religiously motivated as well as religiously compelled conduct”); Mack v. O’Leary, 80 F.3d 1175, 1179 (7th Cir. 1996) (interpreting RFRA to protect “religiously motivated conduct”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft75.84",
      "id": "fn.75.84"
    }
  }, [_vm._v("84")]), _vm._v(". 380 U.S. 163 (1965).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft75.85",
      "id": "fn.75.85"
    }
  }, [_vm._v("85")]), _vm._v(". 398 U.S. 333 (1970).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft75.86",
      "id": "fn.75.86"
    }
  }, [_vm._v("86")]), _vm._v(". For a less complete statement of this position, see Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.26"
    }
  }, [_vm._v("note 26")]), _vm._v(", at 1002 (text at notes 29–30).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft75.87",
      "id": "fn.75.87"
    }
  }, [_vm._v("87")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILIP")]), _vm._v(" B. K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URLAND")]), _vm._v(", R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(": O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("F")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPREME")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURT")]), _vm._v(" 40–41 (1962); William P. Marshall, "), _c('em', [_vm._v("The Case Against Free Exercise Exemptions")]), _vm._v(", 40 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASE")]), _vm._v(" W.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 357, 388–94 (1990); William P. Marshall, "), _c('em', [_vm._v("The Religious Freedom Restoration Act: Establishment, Equal Protection and Free Speech Concerns")]), _vm._v(", 56 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONT")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 227, 229–44 (1995); Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.13"
    }
  }, [_vm._v("note 13")]), _vm._v(", at 135–43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft75.88",
      "id": "fn.75.88"
    }
  }, [_vm._v("88")]), _vm._v(". Corporation of the Presiding Bishop v. Amos, 483 U.S. 327 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft75.89",
      "id": "fn.75.89"
    }
  }, [_vm._v("89")]), _vm._v(". Douglas Laycock, "), _c('em', [_vm._v("Towards a General Theory of the Religion Clauses: The Case of Church Labor Relations and the Right to Church Autonomy")]), _vm._v(", 81 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1373, 1416 (1981) (text at notes 316–17). Even Professor Marshall reluctantly concedes some force to this point. Marshall, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.87"
    }
  }, [_vm._v("note 87")]), _vm._v(", at 240.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft76.90",
      "id": "fn.76.90"
    }
  }, [_vm._v("90")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.13"
    }
  }, [_vm._v("note 13")]), _vm._v(", at 149.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft76.91",
      "id": "fn.76.91"
    }
  }, [_vm._v("91")]), _vm._v(". For an account, see Edwin S. Gaustad, "), _c('em', [_vm._v("Religion and Ratification")]), _vm._v(", in T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOMS")]), _vm._v(": R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGHTS")]), _vm._v(" 41, 46–53 (James E. Wood, Jr., ed., 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft77.92",
      "id": "fn.77.92"
    }
  }, [_vm._v("92")]), _vm._v(". S.C. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". of 1778, art. XXXVIII, in F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANCIS")]), _vm._v(" N. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HORPE")]), _vm._v(", 6 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDERAL")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTIONS")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLONIAL")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARTERS")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THER")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RGANIC")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERRITORIES")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLONIES")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OW")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OR")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERETOFORE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORMING")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" 3255–57 (1906).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft77.93",
      "id": "fn.77.93"
    }
  }, [_vm._v("93")]), _vm._v(". M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.21"
    }
  }, [_vm._v("note 21")]), _vm._v(", ¶ 1 at 64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft77.94",
      "id": "fn.77.94"
    }
  }, [_vm._v("94")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.19"
    }
  }, [_vm._v("note 19")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft77.95",
      "id": "fn.77.95"
    }
  }, [_vm._v("95")]), _vm._v(". "), _c('em', [_vm._v("See supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.42"
    }
  }, [_vm._v("note 42")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft78.96",
      "id": "fn.78.96"
    }
  }, [_vm._v("96")]), _vm._v(". Michael W. McConnell, "), _c('em', [_vm._v("Accommodation of Religion")]), _vm._v(", 1985 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft78.97",
      "id": "fn.78.97"
    }
  }, [_vm._v("97")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft78.98",
      "id": "fn.78.98"
    }
  }, [_vm._v("98")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 10–11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft79.99",
      "id": "fn.79.99"
    }
  }, [_vm._v("99")]), _vm._v(". The word in quotation marks is from James Davison Hunter’s description of religious progressives. H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UNTER")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.53"
    }
  }, [_vm._v("53")]), _vm._v(", at 144–45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft79.100",
      "id": "fn.79.100"
    }
  }, [_vm._v("100")]), _vm._v(". The phrase is from Michael W. McConnell, "), _c('em', [_vm._v("The Origins and Historical Understanding of Free Exercise of Religion")]), _vm._v(", 103 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1409, 1500 (1990). But he would reject the application.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft80.101",
      "id": "fn.80.101"
    }
  }, [_vm._v("101")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EORGE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARNA")]), _vm._v(", V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRTUAL")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" 107 (1994); Greeley, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.68.50"
    }
  }, [_vm._v("note 50")]), _vm._v(", at 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft81.102",
      "id": "fn.81.102"
    }
  }, [_vm._v("102")]), _vm._v(". McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.79.100"
    }
  }, [_vm._v("note 100")]), _vm._v(", at 1488–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft81.103",
      "id": "fn.81.103"
    }
  }, [_vm._v("103")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872, 877 (1990) (“But the ‘exercise of religion’ often involves not only belief and profession but the performance of (or abstention from) physical acts;”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft81.104",
      "id": "fn.81.104"
    }
  }, [_vm._v("104")]), _vm._v(". "), _c('em', [_vm._v("See supra")]), _vm._v(" text accompanying "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.27"
    }
  }, [_vm._v("note 27")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft81.105",
      "id": "fn.81.105"
    }
  }, [_vm._v("105")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20"
    }
  }, [_vm._v("note 20")]), _vm._v(", at 135.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft81.106",
      "id": "fn.81.106"
    }
  }, [_vm._v("106")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.3"
    }
  }, [_vm._v("note 3")]), _vm._v(", at 485.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft82.107",
      "id": "fn.82.107"
    }
  }, [_vm._v("107")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.79.100"
    }
  }, [_vm._v("note 100")]), _vm._v(", at 1488–500. Each successive draft also changed the more controversial Establishment Clause. The successive drafts are set out in sequence in Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.23"
    }
  }, [_vm._v("note 23")]), _vm._v(", at 879–81 (text at notes 27–36).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft82.108",
      "id": "fn.82.108"
    }
  }, [_vm._v("108")]), _vm._v(". McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.79.100"
    }
  }, [_vm._v("note 100")]), _vm._v(", at 1495.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft82.109",
      "id": "fn.82.109"
    }
  }, [_vm._v("109")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1493–94.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft82.110",
      "id": "fn.82.110"
    }
  }, [_vm._v("110")]), _vm._v(". "), _c('em', [_vm._v("The Westminster Confession of Faith")]), _vm._v(" (1647), reprinted in 3 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTENDOM")]), _vm._v(" 600 (Philip Schaff, ed., 1919); "), _c('em', [_vm._v("Principles of Church Order")]), _vm._v(", adopted by the 1st General Assembly of the Presbyterian Church in the United States (1788), quoted in "), _c('em', [_vm._v("“God Alone Is Lord of the Conscience”: Policy Statement and Recommendations Regarding Religious Liberty Adopted by the 200th General Assembly, Presbyterian Church (U.S.A.)")]), _vm._v(" (1988), reprinted in 8 J.L. & Religion 331, 331 (1990) [and in Appendix I of this volume].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft82.111",
      "id": "fn.82.111"
    }
  }, [_vm._v("111")]), _vm._v(". 1 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NNALS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". 796 (J. Gales ed. 1834) (Aug. 20, 1789) (remarks of Mr. Scott).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft82.112",
      "id": "fn.82.112"
    }
  }, [_vm._v("112")]), _vm._v(". McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.79.100"
    }
  }, [_vm._v("note 100")]), _vm._v(", at 1489–91 (suggesting that the difference between the two words might have been between exercise as action and conscience as belief, or between religion as institutional religion and conscience as individual belief).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft83.113",
      "id": "fn.83.113"
    }
  }, [_vm._v("113")]), _vm._v(". Douglas Laycock, "), _c('em', [_vm._v("Notes on Judicial Review, the Growth of Federal Power, and the Structure of Constitutional Rights")]), _vm._v(" (Book Review), 99 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1711, 1744–46 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft83.114",
      "id": "fn.83.114"
    }
  }, [_vm._v("114")]), _vm._v(". "), _c('em', [_vm._v("The Church of England Canons of 1604")]), _vm._v(", quoted in G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UY")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYFIELD")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLAND")]), _vm._v(": I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMBERS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TS")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USINESS")]), _vm._v(" 5 (1963). Eighteenth-century American statutes used similar constructions. "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", An Act for Exempting the Different Societies of Dissenters (1776), in 9 Hening’s Stat. 164–67 (“the church established by law”); C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20"
    }
  }, [_vm._v("note 20")]), _vm._v(", at 173 (quoting Massachusetts provisions for the “ministers established by law”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft83.115",
      "id": "fn.83.115"
    }
  }, [_vm._v("115")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.63.33"
    }
  }, [_vm._v("note 33")]), _vm._v(", at 41–42 (text at notes 22–28).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft84.116",
      "id": "fn.84.116"
    }
  }, [_vm._v("116")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 43–45 (text at notes 32–45).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft84.117",
      "id": "fn.84.117"
    }
  }, [_vm._v("117")]), _vm._v(". For elaborations of my understanding of neutrality, see Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.26"
    }
  }, [_vm._v("note 26")]), _vm._v("; Douglas Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Private Speech by Private Speakers")]), _vm._v(", 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft84.118",
      "id": "fn.84.118"
    }
  }, [_vm._v("118")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.57.13"
    }
  }, [_vm._v("note 13")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft84.119",
      "id": "fn.84.119"
    }
  }, [_vm._v("119")]), _vm._v(". "), _c('em', [_vm._v("Cf., e.g.")]), _vm._v(", Marbury v. Madison, 5 U.S. (1 Cranch) 137, 174 (1803) (“It cannot be presumed that any clause in the constitution is intended to be without effect;”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft85.120",
      "id": "fn.85.120"
    }
  }, [_vm._v("120")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Lee v. Weisman, 505 U.S. 577, 614 n.2 (Souter, J., joined by Stevens and O’Connor, JJ., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft85.121",
      "id": "fn.85.121"
    }
  }, [_vm._v("121")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.23"
    }
  }, [_vm._v("note 23")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft85.122",
      "id": "fn.85.122"
    }
  }, [_vm._v("122")]), _vm._v(". "), _c('em', [_vm._v("Id.;")]), _vm._v(" Lee v. Weisman, 505 U.S. 577, 615 (1992) (Souter, J., joined by Stevens and O’Connor, JJ., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft85.123",
      "id": "fn.85.123"
    }
  }, [_vm._v("123")]), _vm._v(". For discussion, see Douglas Laycock, "), _c('em', [_vm._v("Text, Intent, and the Religion Clauses")]), _vm._v(", 4 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTRE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" J.L. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THICS")]), _vm._v(", & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 683, 695 (1990) (text at notes 30–36).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft85.124",
      "id": "fn.85.124"
    }
  }, [_vm._v("124")]), _vm._v(". For a brief review, collecting historical sources, see Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.63.33"
    }
  }, [_vm._v("note 33")]), _vm._v(", at 50–53 (text at notes 65–79).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft86.125",
      "id": "fn.86.125"
    }
  }, [_vm._v("125")]), _vm._v(". For a list, see C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARL")]), _vm._v(" Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLMAN")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" §§ 65–66 at 78–80 (2d ed. 1933). For additional background, see C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARLES")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LENN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YTH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMON")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" 251–53 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft86.126",
      "id": "fn.86.126"
    }
  }, [_vm._v("126")]), _vm._v(". For the text of the amendment with discussion, see G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LENN")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.125"
    }
  }, [_vm._v("note 125")]), _vm._v(", at 251–53; A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSON")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HELPS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", 2 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" 68–69, 722–28 (1950); Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLMAN")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.125"
    }
  }, [_vm._v("note 125")]), _vm._v(", § 62 at 75–76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft86.127",
      "id": "fn.86.127"
    }
  }, [_vm._v("127")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Taking Constitutions Seriously: A Theory of Judicial Review")]), _vm._v(", 59 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 343, 366 n.203 (1981) (Book Review). For the drafting history, and the view that the First Amendment does not restrict the judiciary in the exercise of its common law and equitable powers, see Mark P. Denbeaux, "), _c('em', [_vm._v("The First Word of the First Amendment")]), _vm._v(", 80 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1156 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft86.128",
      "id": "fn.86.128"
    }
  }, [_vm._v("128")]), _vm._v(". Denbeaux, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.127"
    }
  }, [_vm._v("note 127")]), _vm._v(", at 1157–61, 1201–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft86.129",
      "id": "fn.86.129"
    }
  }, [_vm._v("129")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.127"
    }
  }, [_vm._v("note 127")]), _vm._v(", at 348; Lash, "), _c('em', [_vm._v("Establishment, supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.67.45"
    }
  }, [_vm._v("note 45")]), _vm._v("; Lash, "), _c('em', [_vm._v("Free Exercise, supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.67.45"
    }
  }, [_vm._v("note 45")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft86.130",
      "id": "fn.86.130"
    }
  }, [_vm._v("130")]), _vm._v(". The Due Process Clause applies to “persons,” which includes aliens and artificial legal persons such as churches. The Privileges or Immunities Clause arguably applies only to “citizens,” although the difficulty is not textually insurmountable. "), _c('em', [_vm._v("See")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LY")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMOCRACY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTRUST")]), _vm._v(" 24–25 (1980) (arguing that the clause forbids any state to deprive any person of any of that class of entitlements described as “the privileges and immunities of citizens of the United States”); Douglas Laycock, "), _c('em', [_vm._v("Equal Citizens of Equal and Territorial States: The Constitutional Foundations of Choice of Law")]), _vm._v(", 92 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 249, 268–70 (1992) (arguing that clauses that apply only to citizens might protect organizations by protecting the right of their members or shareholders to form and control organizations).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft87.131",
      "id": "fn.87.131"
    }
  }, [_vm._v("131")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.3"
    }
  }, [_vm._v("note 3")]), _vm._v(", at 487.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft87.132",
      "id": "fn.87.132"
    }
  }, [_vm._v("132")]), _vm._v(". "), _c('em', [_vm._v("Id.; see also")]), _vm._v(" Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.58"
    }
  }, [_vm._v("note 58")]), _vm._v(", at 464–72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft87.133",
      "id": "fn.87.133"
    }
  }, [_vm._v("133")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.58"
    }
  }, [_vm._v("note 58")]), _vm._v(", at 468.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft87.134",
      "id": "fn.87.134"
    }
  }, [_vm._v("134")]), _vm._v(". Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.34.2"
    }
  }, [_vm._v("note 2")]), _vm._v(", at 157.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft87.135",
      "id": "fn.87.135"
    }
  }, [_vm._v("135")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.35.3"
    }
  }, [_vm._v("note 3")]), _vm._v(", at 487.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft87.136",
      "id": "fn.87.136"
    }
  }, [_vm._v("136")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.85.123"
    }
  }, [_vm._v("note 123")]), _vm._v(", at 689 (text at notes 16–17).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft88.137",
      "id": "fn.88.137"
    }
  }, [_vm._v("137")]), _vm._v(". Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#fn.35.3"
    }
  }, [_vm._v("note 3")]), _vm._v(", at 485 n.62.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft88.138",
      "id": "fn.88.138"
    }
  }, [_vm._v("138")]), _vm._v(". Perry Miller, "), _c('em', [_vm._v("Jonathan Edwards and the Great Awakening")]), _vm._v(", in A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RISIS")]), _vm._v(" 5 (Daniel Aaron, ed., 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft88.139",
      "id": "fn.88.139"
    }
  }, [_vm._v("139")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft88.140",
      "id": "fn.88.140"
    }
  }, [_vm._v("140")]), _vm._v(". S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TEPHEN")]), _vm._v(" A. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARINI")]), _vm._v(", R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECTS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVOLUTIONARY")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLAND")]), _vm._v(" 23 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft88.141",
      "id": "fn.88.141"
    }
  }, [_vm._v("141")]), _vm._v(". 1 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.126"
    }
  }, [_vm._v("note 126")]), _vm._v(", at 243.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft88.142",
      "id": "fn.88.142"
    }
  }, [_vm._v("142")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 244.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft88.143",
      "id": "fn.88.143"
    }
  }, [_vm._v("143")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 379.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.144",
      "id": "fn.89.144"
    }
  }, [_vm._v("144")]), _vm._v(". Leonard W. Levy & Alfred Young, Foreword to T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAT")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WAKENING")]), _vm._v(": D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OCUMENTS")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LLUSTRATING")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RISIS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSEQUENCES")]), _vm._v(" v–vi (Alan Heimert & Perry Miller, eds., 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.145",
      "id": "fn.89.145"
    }
  }, [_vm._v("145")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.41"
    }
  }, [_vm._v("note 41")]), _vm._v(", at 2–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.146",
      "id": "fn.89.146"
    }
  }, [_vm._v("146")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FEFFER")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOM")]), _vm._v(" 92 (1953).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.147",
      "id": "fn.89.147"
    }
  }, [_vm._v("147")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 93–94.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.148",
      "id": "fn.89.148"
    }
  }, [_vm._v("148")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALPH")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETCHAM")]), _vm._v(", J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(": A B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IOGRAPHY")]), _vm._v(" 28–29 (1971); Levy & Young, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.144"
    }
  }, [_vm._v("note 144")]), _vm._v(", at vi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.149",
      "id": "fn.89.149"
    }
  }, [_vm._v("149")]), _vm._v(". K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETCHAM")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.148"
    }
  }, [_vm._v("note 148")]), _vm._v(", at 54–58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.150",
      "id": "fn.89.150"
    }
  }, [_vm._v("150")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 72–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.151",
      "id": "fn.89.151"
    }
  }, [_vm._v("151")]), _vm._v(". T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" E. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCKLEY")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVOLUTIONARY")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRGINIA")]), _vm._v(", 1776–1787, at 105–08 (1977).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft89.152",
      "id": "fn.89.152"
    }
  }, [_vm._v("152")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 108.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft90.153",
      "id": "fn.90.153"
    }
  }, [_vm._v("153")]), _vm._v(". The historian Forrest McDonald says 1,552. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORREST")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C")]), _vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONALD")]), _vm._v(", N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVUS")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RDO")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECLORUM")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTELLECTUAL")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIGINS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTION")]), _vm._v(" 45 (1984). Thomas Buckley, whose investigations were concentrated on religious liberty issues in Virginia, and so were probably more thorough, says “approximately seventeen hundred.” Buckley, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.151"
    }
  }, [_vm._v("note 151")]), _vm._v(", at 147.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft90.154",
      "id": "fn.90.154"
    }
  }, [_vm._v("154")]), _vm._v(". B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCKLEY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.151"
    }
  }, [_vm._v("note 151")]), _vm._v(", at 147.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft90.155",
      "id": "fn.90.155"
    }
  }, [_vm._v("155")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C")]), _vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONALD")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.90.153"
    }
  }, [_vm._v("note 153")]), _vm._v(", at 45 (9,337 signatures on petitions other than the "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v("); B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCKLEY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.151"
    }
  }, [_vm._v("note 151")]), _vm._v(", at 147 (more than twelve thousand signatures opposed, of whom only about seventeen hundred signed the "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v(" and about three hundred signed a somewhat similar petition by Madison’s protege John Breckenridge).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft90.156",
      "id": "fn.90.156"
    }
  }, [_vm._v("156")]), _vm._v(". B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCKLEY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.151"
    }
  }, [_vm._v("note 151")]), _vm._v(", at 148–49; C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20"
    }
  }, [_vm._v("note 20")]), _vm._v(", at 141–42; L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.41"
    }
  }, [_vm._v("note 41")]), _vm._v(", at 63–64. Levy appears to have examined the petitions independently. "), _c('em', [_vm._v("See id.")]), _vm._v(" at 64 n.36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft90.157",
      "id": "fn.90.157"
    }
  }, [_vm._v("157")]), _vm._v(". B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCKLEY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.151"
    }
  }, [_vm._v("note 151")]), _vm._v(", at 143. To similar effect, see C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20"
    }
  }, [_vm._v("note 20")]), _vm._v(", at 143 (noting that the "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v(" “did not in its contemporary setting enjoy the preeminence it would acquire over time”); L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.41"
    }
  }, [_vm._v("note 41")]), _vm._v(", at 63–67 (reviewing the evangelical contribution to the fight); S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.126"
    }
  }, [_vm._v("note 126")]), _vm._v(", at 366–97 (separately reviewing the contributions of the Baptists, the Presbyterians, and the “political philosophers”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft90.158",
      "id": "fn.90.158"
    }
  }, [_vm._v("158")]), _vm._v(". S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.86.126"
    }
  }, [_vm._v("note 126")]), _vm._v(", at 426. For further detail, "), _c('em', [_vm._v("see, e.g., id.")]), _vm._v(" at 240–44, 306–10, 353–58, 364–65, 410–11, 418–26; and see the index entries for Baptists, Presbyterians, and Quakers in C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20"
    }
  }, [_vm._v("note 20")]), _vm._v(", and L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.66.41"
    }
  }, [_vm._v("note 41")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft91.159",
      "id": "fn.91.159"
    }
  }, [_vm._v("159")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Paul Finkelman, "), _c('em', [_vm._v("James Madison and the Bill of Rights: A Reluctant Paternity")]), _vm._v(", 1990 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 301, 313–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft91.160",
      "id": "fn.91.160"
    }
  }, [_vm._v("160")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 323–24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft91.161",
      "id": "fn.91.161"
    }
  }, [_vm._v("161")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.59.20"
    }
  }, [_vm._v("note 20")]), _vm._v(", at 198–99; Finkelman, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.91.159"
    }
  }, [_vm._v("note 159")]), _vm._v(", at 334–36; K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETCHAM")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.89.148"
    }
  }, [_vm._v("note 148")]), _vm._v(", at 276; R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" A. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTLAND")]), _vm._v(", J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADISON")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUNDING")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATHER")]), _vm._v(" 44–49 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft91.162",
      "id": "fn.91.162"
    }
  }, [_vm._v("162")]), _vm._v(". For a detailed account, see Finkelman, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.91.159"
    }
  }, [_vm._v("note 159")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft92.163",
      "id": "fn.92.163"
    }
  }, [_vm._v("163")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.27"
    }
  }, [_vm._v("note 27")]), _vm._v("; Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.75.89"
    }
  }, [_vm._v("note 89")]), _vm._v("; McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.27"
    }
  }, [_vm._v("note 27")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft92.164",
      "id": "fn.92.164"
    }
  }, [_vm._v("164")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Thomas C. Berg, "), _c('em', [_vm._v("What Hath Congress Wrought? An Interpretive Guide to the Religious Freedom Restoration Act")]), _vm._v(", 39 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1 (1994); Douglas Laycock & Oliver S. Thomas, "), _c('em', [_vm._v("Interpreting the Religious Freedom Restoration Act")]), _vm._v(", 73 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 209 (1994); Douglas Laycock, "), _c('em', [_vm._v("RFRA, Congress, and the Ratchet")]), _vm._v(", 56 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONT")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 145 (1995); Douglas Laycock, "), _c('em', [_vm._v("The Religious Freedom Restoration Act")]), _vm._v(", 1993 B.Y.U. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 221; Douglas Laycock, "), _c('em', [_vm._v("Summary and Synthesis: The Crisis in Religious Liberty")]), _vm._v(", 60 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 841, 846–56 (1992) (text at notes 28–75); Michael Stokes Paulsen, "), _c('em', [_vm._v("A RFRA Runs Through It: Religious Freedom and the U.S. Code")]), _vm._v(", 56 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONT")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 249 (1995); Rex E. Lee, "), _c('em', [_vm._v("The Religious Freedom Restoration Act: Legislative Choice and Judicial Review")]), _vm._v(", 1993 B.Y.U. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 73; Matt Pawa, Comment, "), _c('em', [_vm._v("When the Supreme Court Restricts Constitutional Rights, Can Congress Save Us? An Examination of Section 5 of the Fourteenth Amendment")]), _vm._v(", 141 U. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1029 (1993).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft92.165",
      "id": "fn.92.165"
    }
  }, [_vm._v("165")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.26"
    }
  }, [_vm._v("note 26")]), _vm._v(", at 1016–18 (text at notes 95–99).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft93.166",
      "id": "fn.93.166"
    }
  }, [_vm._v("166")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.84.117"
    }
  }, [_vm._v("note 117")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft93.167",
      "id": "fn.93.167"
    }
  }, [_vm._v("167")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Rosenberger v. Rector of the Univ. of Va., 515 U.S. 819 (1995); Capitol Square Review & Advisory Bd. v. Pinette, 515 U.S. 753 (1995); Board of Educ. v. Mergens, 496 U.S. 226 (1990); Widmar v. Vincent, 454 U.S. 263 (1981); Cantwell v. Connecticut, 310 U.S. 296 (1940).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft93.168",
      "id": "fn.93.168"
    }
  }, [_vm._v("168")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.74.81"
    }
  }, [_vm._v("note 81")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft93.169",
      "id": "fn.93.169"
    }
  }, [_vm._v("169")]), _vm._v(". For a thorough analysis, see Michael W. McConnell, "), _c('em', [_vm._v("The Selective Funding Problem: Abortions and Religious Schools")]), _vm._v(", 104 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 989 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft94.170",
      "id": "fn.94.170"
    }
  }, [_vm._v("170")]), _vm._v(". 515 U.S. 819 (1995).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft94.171",
      "id": "fn.94.171"
    }
  }, [_vm._v("171")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.26"
    }
  }, [_vm._v("note 26")]), _vm._v(", at 1008 (text at notes 48–55).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft95.172",
      "id": "fn.95.172"
    }
  }, [_vm._v("172")]), _vm._v(". See Respondent’s Brief, 1995 Westlaw 16452 at n.3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft96.173",
      "id": "fn.96.173"
    }
  }, [_vm._v("173")]), _vm._v(". Michael W. McConnell, "), _c('em', [_vm._v("Religious Freedom at a Crossroads")]), _vm._v(", 59 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 115, 188–94 (1992).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft96.174",
      "id": "fn.96.174"
    }
  }, [_vm._v("174")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 193.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft97.175",
      "id": "fn.97.175"
    }
  }, [_vm._v("175")]), _vm._v(". Douglas Laycock, "), _c('em', [_vm._v("Civil Rights and Civil Liberties")]), _vm._v(", 54 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(".-K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENT")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 390, 415–35 (1977) (text at notes 146–265) (analyzing Catholic Bishop v. NLRB, 559 F.2d 1112 (7th Cir. 1977), "), _c('em', [_vm._v("aff’d on other grounds")]), _vm._v(", 440 U.S. 490 (1979)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft99.176",
      "id": "fn.99.176"
    }
  }, [_vm._v("176")]), _vm._v(". T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AINE")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EASON")]), _vm._v(" (1793).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft99.177",
      "id": "fn.99.177"
    }
  }, [_vm._v("177")]), _vm._v(". 397 U.S. 664 (1970) (rejecting an Establishment Clause challenge to exempting church property from taxation).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft99.178",
      "id": "fn.99.178"
    }
  }, [_vm._v("178")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Brief of National Council of Churches of Christ in the U.S.A. et al., as Amici Curiae in Support of Respondents, Board of Educ. v. Grumet, 512 U.S. 687 (1994) (arguing that Establishment Clause precludes deliberate creation of public school district with population all of the same religion); Brief Amici Curiae of the American Jewish Congress et al., Lee v. Weisman, 505 U.S. 577 (1992) (arguing that Establishment Clause precludes prayer as part of official program at public school graduation).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft99.179",
      "id": "fn.99.179"
    }
  }, [_vm._v("179")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.60.23"
    }
  }, [_vm._v("note 23")]), _vm._v(" (arguing against nonpreferential aid to religion); Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.63.33"
    }
  }, [_vm._v("note 33")]), _vm._v(" (arguing against noncoercive aid to religion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft99.180",
      "id": "fn.99.180"
    }
  }, [_vm._v("180")]), _vm._v(". 493 U.S. 378 (1990) (holding that application of general sales and use tax to distribution of religious literature is not a cognizable burden on the free exercise of religion). For commentary, see Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.61.27"
    }
  }, [_vm._v("note 27")]), _vm._v(", at 4–7, 23–28, 39–41 (text at notes 17–31, 99–118, 156–58).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft100.181",
      "id": "fn.100.181"
    }
  }, [_vm._v("181")]), _vm._v(". See Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.55.3"
    }
  }, [_vm._v("note 3")]), _vm._v("; Sherry, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.70.58"
    }
  }, [_vm._v("note 58")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft100.182",
      "id": "fn.100.182"
    }
  }, [_vm._v("182")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TEPHEN")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AY")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OULD")]), _vm._v(", B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULLY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RONTOSAURUS")]), _vm._v(" 215, 225 (1991). Reviewing the work of a naturalist who convinced himself that flamingos are pink so they will be camouflaged when seen against the sunset, Gould wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "Quote1Sb"
  }, [_vm._v("Thayer’s pathway from insight to ridicule followed a distressingly common route among intellectuals.… Little by little, plausibly at first, but grading slowly to red wings in the sunset … Thayer progressively invaded the categories of mimicry and revealing coloration to gain, or so he thought, more cases for concealment.…")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteIN1"
  }, [_vm._v("The "), _c('em', [_vm._v("idée fixe")]), _vm._v(" is a common intellectual fault of all professions.… I have often written about scientists as single-mindedly committed to absurd unities and false simplifications as Thayer was devoted to the exclusivity of concealing coloration in nature. Some are charming and a bit dotty.… Others are devious and more than a bit dangerous.…")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes1"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft101.183",
      "id": "fn.101.183"
    }
  }, [_vm._v("183")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHNSON")]), _vm._v(", I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTELLECTUALS")]), _vm._v(" (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft101.184",
      "id": "fn.101.184"
    }
  }, [_vm._v("184")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/012_Chapter04#fn.84.117"
    }
  }, [_vm._v("note 117")]), _vm._v(", at 7 (text at notes 32–33).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ft101.185",
      "id": "fn.101.185"
    }
  }, [_vm._v("185")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 7–8 (text at notes 32–33).")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes-para"
  }, [_vm._v("I am grateful to the participants in this symposium for provoking a clear statement of the ideas in this paper. With respect to our disagreements, I had the quite unfair advantage of seeing substantially complete drafts of their papers while providing no reasonable draft of my paper. I regret that conflicting commitments made it impossible to attend to this paper sooner. I am also grateful to Sanford Levinson and L.A. Powe for remarkably quick and helpful reads of an earlier draft.")])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467434133',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(229)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(231);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 231 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.96ef97e3847ba9498989.js